// Simplified Chinese for the HEVN Portal — GENERATED by scripts/i18n_langs.cjs from flat translations of `en` in
// i18n.js (2026-10-21). Edit a string here or re-run the script; a key absent here falls back to English.
// Acronyms, system and product names stay as written (EXF, FOB, MOQ, SAP, NetSuite, Helinox …).
const zh = {
  "common": {
    "notif": {
      "title": "通知",
      "unreadCount": "{{count}} 条未读通知",
      "markAll": "全部标为已读",
      "markRead": "标为已读",
      "loading": "加载中…",
      "empty": "暂无通知。系统就您的工作给您发邮件时，也会在这里显示。",
      "open": "打开相关页面",
      "by": "来自 {{name}}",
      "settings": "选择要提醒的内容",
      "settingsHint": "选择要在铃铛中显示的分组。邮件照常发送；关闭的分组只在这里隐藏，重新打开后会再次显示。",
      "save": "保存",
      "cancel": "返回",
      "saved": "已保存",
      "unreadIn": "{{count}} 条未读",
      "g_approvals": "审批与决定",
      "g_access": "访问申请（新成员）",
      "g_tickets": "工单",
      "g_samples": "样品截止日期",
      "g_projects": "项目（SKU 新增、移动、放弃）",
      "g_cycletime": "周期时间检查",
      "g_ceo": "CEO Office",
      "g_chat": "群聊 (GCC)",
      "g_tasks": "系统项目",
      "g_other": "其他",
      "hidden": "已隐藏 {{count}} 个分组",
      "merged": "{{who}} 对“{{subject}}”做了 {{count}} 处更改",
      "mergedNoWho": "“{{subject}}”有 {{count}} 处更改",
      "loadMore": "加载更多",
      "showHidden": "显示",
      "hideHidden": "重新隐藏",
      "fromHidden": "已隐藏的分组"
    },
    "common": {
      "language": "语言",
      "theme": "主题",
      "light": "浅色",
      "dark": "深色",
      "allRoles": "全部角色"
    },
    "cpAtt": {
      "photos": "照片",
      "messages": "消息",
      "you": "我",
      "pendingTag": "保存时发送",
      "noMessages": "暂无消息。",
      "placeholder": "写下关于此报价的备注…",
      "send": "发送",
      "withdraw": "删除",
      "deleteConfirm": "删除此消息？所有人都将看不到它，且无法恢复。",
      "saveFailed": "消息保存失败。",
      "deleteFailed": "消息删除失败。"
    },
    "bench": {
      "title": "Inline 成本表",
      "sub": "已读入 Inline 基准的供应商成本表，保存在此，无需文件即可对照报价。",
      "search": "搜索款式、文件、供应商、季…",
      "empty": "尚未读取任何成本表。请使用上方的“导入成本表” — 读取的内容会保存在这里，在填写报价的 Inline 基准时供选择。",
      "noHit": "没有与“{{q}}”匹配的内容。",
      "loading": "正在读取表格…",
      "lines": "{{n}} 行",
      "edit": "编辑信息",
      "remove": "移除",
      "save": "保存",
      "saved": "已保存。",
      "removed": "已从库中移除。",
      "editTitle": "季、供应商和备注",
      "editBody": "工作簿中未注明的三项信息。成本不可编辑 — 它们是供应商给出的数字，旁边的采购成本是核对它们的依据。",
      "season": "季",
      "vendor": "供应商",
      "note": "备注",
      "removeTitle": "移除此成本表？",
      "removeBody": "{{file}} 将从库中移除，填写基准时不再提供。已据此对照的报价会保留其数字及旁边的记录行。",
      "colLine": "行",
      "colVariant": "成本版本",
      "colStated": "表内采购成本",
      "import": "导入成本表",
      "readOk": "{{file}} — 已读取并保存 {{n}} 行。",
      "readRefused": "{{n}} 行被拒绝：各列合计与旁边标注的采购成本不符。"
    },
    "ceo": {
      "title": "CEO 办公室",
      "sub": "所有已开启的事项都会跟踪到关闭为止。转发到 ceo.office@ 的邮件会生成工单；计数根据每张工单自身的事件日志计算。",
      "desk": "工作组",
      "bothDesks": "两组",
      "desk_business": "业务",
      "desk_executive": "高管",
      "refresh": "刷新",
      "newTicket": "新建工单",
      "newSub": "工单在一个工作组中创建并一直留在该组。法人实体和内部联系人可以留空 — 大多数事项开始时都还没有归属。",
      "create": "创建",
      "cancel": "取消",
      "close": "关闭",
      "needTitle": "工单需要标题。",
      "fromWho": "来自",
      "notSet": "未设置",
      "noTickets": "此工作组暂无工单。",
      "noDesk": "您不属于任何工作组，因此没有可显示的内容。请联系 Young 将您加入 Business 或 Executive。",
      "filteredBy": "仅显示 {{name}} — {{n}} 张工单。",
      "clearFilter": "显示全部",
      "cardOpen": "进行中",
      "cardOpenRule": "未关闭或放弃",
      "cardOverdue": "已逾期",
      "cardOverdueRule": "仍未结，已过期限",
      "cardUntouched": "3 天以上未跟进",
      "cardUntouchedRule": "自上次联系事件起",
      "cardWaiting": "等待 CEO",
      "cardWaitingRule": "按状态判断",
      "cardNoEntity": "未设置法人实体",
      "cardNoEntityRule": "尚无归属",
      "cardClosed": "本周关闭",
      "cardClosedRule": "最近 7 天内关闭",
      "colTicket": "工单",
      "colTitle": "标题 / 来自",
      "colDesk": "工作组",
      "colType": "类型",
      "colEntity": "法人实体",
      "colContact": "内部联系人",
      "colOwner": "负责人",
      "colDue": "期限",
      "colStatus": "状态",
      "colLast": "最近联系",
      "colDday": "D-day",
      "logTitle": "事件日志",
      "logContacted": "我方已联系",
      "logReply": "对方已回复",
      "ev_created": "创建",
      "ev_contacted": "联系",
      "ev_reply": "回复",
      "ev_status": "状态",
      "ev_field": "编辑",
      "ev_closed": "关闭",
      "ev_reopened": "重新打开",
      "ev_note": "备注",
      "closeTicket": "关闭工单",
      "reopenTicket": "重新打开",
      "closeTitle": "关闭 {{id}}",
      "reopenTitle": "重新打开 {{id}}",
      "closeSub": "它将移出“进行中”和“已逾期”，计入“本周关闭”。它仍保留在列表和搜索中，包含完整历史，并可重新打开。",
      "reopenSub": "工单恢复为关闭前的状态，并重新计为未结。",
      "closeNote": "关闭备注（可选）",
      "reopenNote": "重新打开原因（可选）",
      "closeNotePh": "例如：电话中已谈妥 — 无需进一步处理。",
      "reopenNotePh": "例如：对方回信提出了新的请求。",
      "closedBy": "{{who}} 关闭 · {{when}}",
      "statusClosedHint": "已关闭 — 点击“重新打开”可更改状态。",
      "logNote": "添加内部备注",
      "logNoteSub": "能打开此工单的人可在系统内看到，不会发邮件给任何人。它不算联系，也不会改变“最近联系”。按 Ctrl+Enter 记录。",
      "logNoteWhy": "供工作组和 CEO 查看的备注。不改变任何日期或计数。",
      "notePh": "发生了什么、决定了什么、下一步是什么。",
      "historyTitle": "历史",
      "hist_all": "全部",
      "hist_mail": "邮件",
      "hist_note": "备注",
      "hist_change": "变更",
      "historyEmpty": "此工单尚无此类记录。",
      "hSent": "已发送邮件",
      "hReceived": "已收到邮件",
      "hSentWhy": "由 CEO 办公室邮箱或工作组成员发送。",
      "hReceivedWhy": "从外部发送到 CEO 办公室。",
      "hTo": "收件人",
      "hCc": "抄送",
      "hQuoted": "显示此邮件中引用的早前邮件",
      "hQuotedHide": "隐藏引用的邮件",
      "hNote": "内部备注",
      "hCreated": "已创建工单",
      "hCreatedMail": "由 CEO 办公室邮箱创建的工单",
      "hClosed": "已关闭（原为 {{from}}）",
      "hReopened": "已重新打开 → {{to}}",
      "hFile": "已附加文件",
      "historyScope": "邮件到达 {{mailbox}} 时才会显示在这里 — 发给它、抄送它或从它发出。工作组成员从自己的邮箱发出且未抄送 {{mailbox}} 的邮件，系统无法看到。",
      "restricted": "受限 — 另一工作组",
      "otherDesk": "此工单属于另一工作组。您可以看到它存在，但无权查看其历史。",
      "entityTitle": "法人实体抄送地址",
      "entityFilled": "已设置 {{n}} / {{total}}",
      "entitySub": "法人实体和内部联系人是工单外发邮件的抄送对象。在 Young 提供这八个地址之前均为空 — 这里的地址会收到真实邮件，因此不做任何猜测。",
      "entityPh": "尚未设置",
      "fTitle": "标题",
      "fTitlePh": "开启了什么 — 此工单要跟踪的事项",
      "fFromPh": "来自何人（如有）",
      "fTypePh": "跟进、法务、文件…",
      "newLater": "除标题外都可以留空，稍后再填 — 大多数事项开始时都还没有归属。",
      "fLaterPh": "尚不清楚可留空",
      "tabTickets": "工单",
      "allDesks": "全部",
      "unassigned": "未分配",
      "choosedesk": "分配到…",
      "deskRule": "每个工作组只看到自己的工单，CEO 可以看到两组。",
      "open": "打开",
      "fAllStatuses": "全部状态",
      "fAllTypes": "全部类型",
      "fAllEntities": "全部法人实体",
      "fAllContacts": "全部内部联系人",
      "fAllOwners": "全部负责人",
      "searchPh": "搜索标题或发件人…",
      "searchLeadPh": "搜索对方名称…",
      "ddayWhat": "从期限日期起算。+ 表示已超过的天数，- 表示剩余天数。",
      "ddayLegend": "D-day 从期限日期起算：+5 表示已超过五天，-5 表示还剩五天。仅在工单未结时计算。",
      "ev_file": "文件",
      "fileUnreadable": "无法读取该文件。",
      "files": "附件",
      "filesSub": "此工单正在等待的资料或随附的资料。每个文件 10 MB，每张工单 {{n}} 个。",
      "addFile": "添加文件",
      "removeFile": "删除",
      "removeFileSub": "文件将从服务器删除，无法撤销。",
      "uploading": "上传中…",
      "logContactedSub": "通过什么方式发出、说了什么。两项均可选 — 无论如何都会记录日期。按 Ctrl+Enter 记录。",
      "logReplySub": "通过什么方式回复、对方说了什么。两项均可选 — 无论如何都会记录日期。按 Ctrl+Enter 记录。",
      "channel": "方式",
      "channelPh": "邮件、电话、会议…",
      "contactNote": "备注",
      "contactNotePh": "例如：催要签字版",
      "replyNotePh": "例如：对方还需要两周",
      "record": "记录",
      "colDwell": "当前状态天数",
      "nDays": "{{n}} 天",
      "atStageN": "此阶段 {{n}} 天",
      "worstN": "最长 {{n}} 天",
      "lateShape": "延误集中在哪里",
      "lateShapeSub": "是某一个队列卡住，还是全部",
      "nothingLate": "没有逾期事项。",
      "howLong": "此工作组的处理时长",
      "howLongSub": "来自事件日志 — 无手动输入",
      "toFirstAnswer": "创建 → 首次回复",
      "toClose": "创建 → 关闭",
      "neverAnswered": "未结且从未回复",
      "medianOf": "{{n}} 件的中位数",
      "notEnough": "数据不足 — 目前 {{n}} 件",
      "loading": "加载中…",
      "noHistory": "暂无记录。",
      "reset": "重置",
      "resetN": "重置 ({{n}})",
      "sortedBy": "按 {{col}} 排序",
      "showingN": "显示 {{total}} 条中的 {{n}} 条 —",
      "leadContactHint": "记录日期 — “最近联系”和“未回复”都从此日期起算。",
      "exportExcel": "导出 Excel",
      "contactHint": "记录日期 — “最近联系”和“3 天以上未跟进”都从此日期起算。",
      "logContactedWhy": "我方已联系。在此工单上记录今天的日期，并重新计算未跟进天数。",
      "logReplyWhy": "对方已回复。同样记录今天的日期 — 单独记录，因为催促与得到答复是两回事。",
      "tab_tickets": "工单",
      "tab_leads": "潜在客户",
      "tab_daily": "每日",
      "sub_tickets": "所有已开启的事项都会跟踪到关闭为止。转发到 ceo.office@ 的邮件会生成工单；计数根据每张工单自身的事件日志计算。",
      "sub_leads": "新客户开发管道。CEO 设定寻找的市场和条件；工作组负责联系，并将答复与标准对照。",
      "sub_daily": "每天早上四个板块。界面与自动邮件显示相同内容。",
      "newLead": "新潜在客户",
      "newLeadSub": "潜在客户归属 Business 工作组。可以指定所属工单，也可以在工单产生前先创建。",
      "needCounterparty": "需要填写对方名称。",
      "counterpartyPh": "正在洽谈的对象",
      "sectorPh": "分销、零售、线上…",
      "leadTicketPh": "选择此潜在客户所属的工单（如有）",
      "countryPh": "泰国、越南…",
      "criteriaPh": "对照 CEO 的条件…",
      "noLeads": "暂无潜在客户。",
      "noReply": "{{n}} 天未回复",
      "colLead": "潜在客户",
      "colCounterparty": "对方",
      "colCountry": "国家",
      "colSector": "行业",
      "colStage": "阶段",
      "colCriteria": "标准",
      "colNext": "下次联系",
      "leadsNote": "潜在客户只在 Business 工作组。CEO 决定看哪些市场、什么条件；工作组负责联系、获得答复并与标准对照。",
      "stageRule_Contacted": "已发首封邮件",
      "stageRule_Replied": "对方已回复",
      "stageRule_Checking_criteria": "对照 CEO 的条件",
      "stageRule_With_CEO": "已通过，等待决定",
      "stageRule_Closed": "已成交或未达标准",
      "dOpened": "昨日以来新开",
      "dMoved": "有变动",
      "dOverdue": "已逾期",
      "dWaiting": "等待 CEO",
      "nItems": "{{n}} 项",
      "reachFirst": "优先联系",
      "nothingHere": "无。",
      "dailyNote": "每个工作日 08:30 (KL 时间) 发送。每个工作组收到关于自己工单的邮件；CEO 两份都收到。界面与邮件内容相同。"
    },
    "pricing": {
      "title": "Collab 报价计算器",
      "subtitle": "成本、T1、MSRP 和版权费集于一屏 — 以 USD 核算",
      "modeGeneral": "普通 Collab · OEM / ODM",
      "modeGeneralSub": "无版权费 · Markup Base → T1 → MSRP",
      "modeLicensed": "授权 Collab（版权费）",
      "modeLicensedSub": "全球 MSRP → 本地价格 → 版权费",
      "padClose": "关闭",
      "padNeedInstruction": "请在下方指示栏写明条件，然后再按一次。",
      "padOptionN": "方案 {{n}}",
      "padInlineRrp": "Inline 零售价",
      "padPremium": "Collab 溢价",
      "padTargetMsrp": "目标 MSRP",
      "padOwnRetailRef": "Inline，仅供参考",
      "padPartnerNa": "不适用 — Inline 不向合作伙伴销售",
      "padGapOwn": "自营零售：Collab 保留 {{c}}%，Inline 为 {{i}}%",
      "padGapPartnerBelow": "合作伙伴批发：计入额外成本后低于成本 {{amt}}",
      "padGapPartnerOk": "合作伙伴批发：计入额外成本后 {{pct}}%",
      "padToB7": "→ 第 7 板块：合作伙伴一侧每件 {{amt}} 由谁承担？",
      "padSkuN": "SKU {{n}}",
      "padB7NoteMany": "整份报价只做一个决定：{{n}} 个 SKU，整单额外成本 {{e}}。A、B、C 三种方案中 MSRP 和合作伙伴单价都不变，只有由谁承担这部分额外成本不同。",
      "padFrameModel": "框架型号",
      "padB1": "1 · 订单",
      "padKindOrder": "这些数字所依据的条件",
      "padLeadDays": "{{d}} 天 → 短交期 {{r}}",
      "padWhyShow": "差异原因 ({{n}})",
      "padWhyHide": "收起",
      "padNoReason": "未注明原因",
      "padMoqNote": "仅 MOQ 附加费就有 {{amt}}，占此数量下额外成本的 {{pct}}%。",
      "padB2": "2 · 工厂成本",
      "padB3": "3 · 框架成本",
      "padB4": "4 · 额外成本",
      "padB5": "5 · 总成本",
      "padB6": "6 · 价格与毛利",
      "padB7": "7 · 额外成本由谁承担 — 整单 {{n}} EA 共 {{amt}}",
      "padB7Kind": "决策 · 一键 · 扣除 O.H 后的净利润",
      "padB7KindCalc": "只读 · 审批人据以决策的卡片",
      "paApproveOne": "只选一个方案",
      "paGmAll": "所有款式同一毛利率",
      "paGmEach": "每个品项各自的毛利率",
      "paGmToAll": "全部相同",
      "paYlOnly": "由 YL 在价格审批页面选择一个方案",
      "paSwitch": "改选此方案",
      "padB7NoteCalc": "每份报价都有 A、B、C。如需其他分摊额外成本的方式，请在上方添加方案 — 它会在这里和审批人的界面上多出一张卡片。",
      "padB7Note": "仅适用于合作伙伴批发渠道。A、B、C 中 MSRP {{m}} 和合作伙伴单价 {{p}} 均不变，只有每件 {{e}} 的额外成本变化。",
      "padKindCompare": "对比",
      "padKindSolo": "仅 Collab · 无对比",
      "padThisQuote": "本报价",
      "padCompareOnly": "仅供对比",
      "padInlineShort": "Inline",
      "padSameWord": "相同",
      "padNoBench": "无基准",
      "padNoneWord": "无",
      "padFactory": "工厂成本",
      "padFrame": "框架成本",
      "padFactoryN": "工厂成本 (2)",
      "padFrameN": "框架成本 (3)",
      "padExtraN": "额外成本 (4)",
      "padExtraPerUnit": "每件额外成本",
      "padBaseFrom": "= 工厂 {{f}} + 框架 {{r}}",
      "padBaseSub": "工厂 + 框架",
      "padPctOfTotal": "占总成本 {{n}}%",
      "padMultBase": "仅基础成本：Collab 为 {{x}}× Inline",
      "padMultAll": "含额外成本：{{x}}× Inline",
      "padLead": "基础成本相近，问题在于额外成本。",
      "padOwnRetailSub": "HINC 等按 MSRP 销售",
      "padPartnerWs": "合作伙伴批发",
      "padPartnerWsSub": "按 MSRP 的 {{p}}% 供货",
      "padCallout": "自营零售承担额外成本后仍保留 {{pct}}%。合作伙伴批发做不到，会低于成本。由第 7 板块决定合作伙伴一侧的额外成本由谁承担。",
      "padMsrp": "MSRP",
      "padPartnerUnit": "合作伙伴单价",
      "padExtraBilledUnit": "+ 加收的额外成本",
      "padPerUnit": "/件",
      "padExtraAbsorbed": "Helinox 承担的额外成本",
      "padGrossSub": "= O.H + 净利润",
      "padWhoA": "额外成本按净成本单列开票，不加毛利。",
      "padWhoB": "额外成本计入 HPAC 营销费用，合作伙伴只看到单价。",
      "padWhoC": "一半向合作伙伴收取，一半由 Helinox 承担。",
      "padCeoDecision": "CEO 决定",
      "padCeoDecisionSub": "随审批一并记录。申请人按此条件完成报价，无需重新提交。",
      "padDrowFinal": "最终条件",
      "padDrowRecorded": "已记录",
      "padOpenCalc": "在计算器中打开",
      "approverView": "审批人将看到的内容",
      "approverViewSub": "与报价审批界面相同的两个板块，使用相同数据。只读 — 数字在上方输入。",
      "padSubmittedBy": "提交人",
      "padNoSnapshot": "此报价提交于数字冻结功能上线之前，因此没有可显示的记录。请在计算器中打开查看当前状态。",
      "padFrozen": "以下数字为提交审批时的数值。",
      "padEdited": "报价在发送后已被修改。",
      "padLine": "条目",
      "padCollab": "Collab",
      "padInline": "Inline",
      "padGap": "差额",
      "padBase": "基础成本",
      "padExtra": "额外成本",
      "padExtraNote": "Inline 生产中不会发生",
      "padTotal": "每件总成本",
      "padOrder": "订单合计 · {{qty}} EA",
      "padPriceMargin": "价格与毛利",
      "padOwnRetail": "自营零售",
      "padPartner": "合作伙伴批发 · MSRP 的 {{pct}}%",
      "padWeSell": "我方售价",
      "padMarginPre": "额外成本前毛利",
      "padMarginPost": "额外成本后毛利",
      "padWhoCarries": "额外成本由谁承担 — {{qty}} EA 共 {{total}}",
      "padWhoSub": "仅限合作伙伴批发渠道。各方案中 MSRP {{msrp}} 和合作伙伴单价 {{unit}} 均不变，只有额外成本变化。",
      "padOptA": "A · 合作伙伴支付额外成本",
      "padOptB": "B · Helinox 承担",
      "padOptC": "C · 各承担 50 / 50",
      "fxBilledRule": "额外成本 × 合作伙伴承担比例",
      "fxRevenueRule": "各 SKU 数量 × MSRP，按整单合计",
      "fxAbsorbedRule": "额外成本 − 向合作伙伴收取的金额",
      "fxGrossRule": "合作伙伴收入 + 加收的额外成本 − 总成本",
      "fxOhRule": "订单基础成本 × O.H 费率",
      "fxNetRule": "毛利 − Helinox O.H",
      "fxMarginRule": "净利润 ÷ 合作伙伴收入",
      "padGate": "批准此报价？",
      "padGateSub": "当前处于 {{status}}。下一步将逐个 SKU 决定，并附上备注。",
      "padGateApprove": "批准",
      "padGateReject": "退回",
      "padGateCancel": "暂不处理",
      "padOtherCostings": "此报价另有 {{n}} 种成本核算",
      "padOtherCostingsSub": "同一报价在计算器中按其他方式核算的结果。每种都按 A 计算，以便与 A 卡对照 — 选择其一即采用该核算，并由合作伙伴承担额外成本。",
      "padRefAt": "按 A 计算 · 合作伙伴支付额外成本",
      "padSettings": "这些数字的计算设置",
      "padSetPremium": "Collab 溢价",
      "padSetPartner": "合作伙伴毛利",
      "padSetSplitC": "分摊比例（C 卡）",
      "padSetOh": "Helinox O.H",
      "padSetOhVal": "基础成本的 {{pct}}%",
      "padSetCase": "情形",
      "padOptTerms": "其他条件",
      "padOptTermsSub": "以上卡片都不合适？请在下方指示栏写明条件，申请人将按此完成报价。",
      "padSrcPortal": "系统默认",
      "padSrcQuote": "申请人添加",
      "padSrcApprover": "由您填写条件",
      "padSumHead": "您正在批准此报价 {{all}} 个 SKU 中的 {{n}} 个",
      "padSumCard": "额外成本承担方",
      "padSumQty": "批准数量",
      "padSumNoCard": "尚未选择卡片，因此本次批准只确定 SKU，额外成本暂不分配。",
      "padSumNothing": "所有 SKU 都已排除。请改用“退回”退回整份报价。",
      "padSumUnread": "其中 {{n}} 个您尚未打开。",
      "padSkuUnseen": "未打开",
      "padSkuCut": "已排除",
      "padSkuSeen": "您已打开此报价 {{all}} 个 SKU 中的 {{n}} 个",
      "padSkuAllSeen": "您已打开全部 {{n}} 个 SKU",
      "padSkuCutN": "{{n}} 个此前已排除",
      "padCardScope": "这些数字只涵盖剩余的 {{n}} 个 SKU，而非报价中全部 {{all}} 个。",
      "padCardGone": "— 此方案已不在报价中",
      "padBilled": "加收的额外成本",
      "padRevenue": "销售收入（数量 × MSRP）",
      "padAllIn": "合作伙伴总支付",
      "padGross": "订单毛利",
      "padOh": "Helinox O.H · 基础成本的 {{pct}}%",
      "padNetProfit": "Helinox 订单净利润",
      "padNetMargin": "净利率 · 占合作伙伴价格 %",
      "padSelect": "选择 {{key}}",
      "padDecision": "已记录的决定",
      "padChosen": "额外成本承担方",
      "padUndecided": "尚未决定",
      "padInstruction": "指示",
      "padInstructionPh": "例如：选 A，但合作伙伴单价取整为 $60，额外成本一次性收取。",
      "padSaveInstruction": "保存指示",
      "padDecisionSaved": "决定已记录。",
      "padMemo": "Sales OP 最终备忘",
      "padMemoSub": "阅读上方决定后最终商定的价格和条件。只能填写一次，之后不可编辑。",
      "padMemoPh": "最终商定的价格和条件…",
      "padMemoWaitShort": "尚未记录",
      "padMemoWait": "此报价尚未作出决定。",
      "padMemoSave": "记录备忘",
      "padMemoSaved": "备忘已记录。",
      "modeRules": "定价规则",
      "modeRulesSub": "管理员 · 所有报价的计价常数",
      "rulesTitle": "定价规则",
      "rulesSub": "更改只适用于保存之后创建的报价。已创建的报价保留其计价时的规则，因此已有报价不会变动。",
      "ruleName": "规则",
      "ruleNow": "现行值",
      "ruleNew": "新值",
      "ruleWhy": "原因",
      "ruleWhyPh": "为什么要更改？",
      "ruleSave": "保存",
      "ruleSaved": "已保存。从现在起创建的报价将使用新规则。",
      "ruleHistory": "全部更改，最新在前",
      "ruleValue": "值",
      "ruleBy": "更改人",
      "ruleFrom": "生效时间",
      "rule_partner_ratio_pct": "合作伙伴价格",
      "ruleHint_partner_ratio_pct": "合作伙伴价格占 MSRP 的比例。",
      "rule_tier_oh_pct": "Helinox O.H",
      "ruleHint_tier_oh_pct": "层级比例中的管理费部分。作为新报价的初始值；已保存的报价保留自己的值。",
      "rule_frame_profit_pct": "框架利润",
      "ruleHint_frame_profit_pct": "框架成本 × 此比例，框架免费提供时除外。",
      "modeSaved": "已保存项目",
      "modeSavedSub": "浏览 · 载入 · 导出 Excel",
      "modeOpa": "OPA / SCT",
      "modeOpaSub": "工序分析 · 标准周期时间",
      "projectPlaceholder": "项目名称 — 例如：26FW MICRO KICKBOARD x Chair One (re)",
      "template": "导入模板",
      "importExcel": "导入 Excel",
      "importBom": "导入供应商 BOM",
      "bomRead": "按 {{vendor}} BOM 读取 — {{n}} 个 SKU 来自：{{names}}",
      "bomFailed": "无法读取此 BOM",
      "bomLookedFor": "系统识别两种供应商格式，并查找了：",
      "bomSheets": "此文件中的工作表：{{list}}",
      "dismiss": "关闭",
      "imported": "已从文件载入 {{n}} 个 SKU — 请核对数字后保存项目。",
      "save": "保存项目",
      "saveChanges": "保存更改",
      "newProject": "新项目",
      "exportExcel": "导出 Excel",
      "savedAs": "已保存为 {{id}} — 可以开始下一个。",
      "loaded": "已载入 {{id}} — 保存后将更新它并清空界面。",
      "needName": "请先填写项目名称。",
      "needSave": "请先保存项目 — 导出读取的是已保存的内容。",
      "deleteAsk": "删除 {{id}}？它将从列表中移除，成本核算本身仍会保留。",
      "sku": "SKU",
      "addSku": "添加 SKU",
      "duplicate": "复制",
      "del": "删除",
      "inputs": "输入",
      "collapse": "收起",
      "expand": "展开",
      "results": "结果",
      "skuName": "SKU / 品名",
      "skuNameHint": "项目中用于区分此品项的名称。",
      "qty": "订单数量 (EA)",
      "qtyHint": "决定 MOQ 附加费和 HPAC 借记金额。",
      "poDate": "PO 下达日期",
      "poDateHint": "交期起算日。",
      "xfDate": "要求的 XF 日期",
      "xfDateHint": "XF − PO = 交期。",
      "moqLabel": "MOQ",
      "moqNone": "500 pcs 及以上 → 无附加费",
      "moqApplied": "{{qty}} pcs → {{of}} 的 {{rate}}",
      "moqQtyPcs": "{{qty}} pcs →",
      "moqOfBase": "按 {{of}} 计",
      "leadLabel": "交期",
      "leadNone": "填写两个日期即可计算",
      "leadDays": "{{days}} 天 → 短交期 {{rate}}",
      "leadWarn": "{{days}} 天少于 60 天 — 规定未覆盖此情况。暂按 50% 计算，附加费需另行协商。",
      "baseTitle": "Markup Base 成本",
      "baseSub": "毛利仅以这些项目和 FM 费为基础计算，不含其他。",
      "skin": "Skin + Case + 包装",
      "skinHint": "面料 skin、case 和包装合计。",
      "cmt": "供应商 CMT",
      "cmtHint": "供应商缝制工费（Cut · Make · Trim）。",
      "ohp": "供应商 OH 与利润",
      "ohpHint": "供应商的管理费和毛利。",
      "frame": "框架成本",
      "frameHint": "选择型号，从框架价目表自动填入。",
      "framePick": "选择框架型号…",
      "frameSupply": "框架供应方式",
      "supplySell": "售予供应商",
      "supplySellHint": "框架利润 + 处理费 $0.50 + 运费 (p.19)",
      "supplyFoc": "免费提供 (FOC)",
      "supplyFocHint": "仅 FM 费 $0.04 (p.13, p.20)",
      "matSupply": "材料供应方式",
      "matVendor": "供应商自购",
      "matVendorHint": "面料、case 和包装由供应商自行采购。",
      "matFf": "Helinox 提供 (FF)",
      "matFfHint": "材料不由供应商出资，因此改收 FF CMT 费。",
      "frameProfitRate": "框架利润率",
      "excludedTitle": "排除项",
      "excludedSub": "Inline 生产中不会发生的成本。它们计入 T1 毛利基数，同时以 HPAC 营销借记的形式向合作伙伴收回；T2 的计价不含这些成本。在某一栏手动输入只覆盖该栏的规则。",
      "autoToggle": "按规定自动计算",
      "autoTag": "自动",
      "resetOverride": "手动 — 重置",
      "fprofit": "框架利润",
      "fprofitHint": "框架成本 x 利润率。框架免费提供时为零。",
      "handling": "处理费",
      "handlingHint": "Helinox 向供应商出售框架时为 $0.50 (p.19)。",
      "fmfee": "FM 费",
      "fmfeeHint": "框架免费提供时为 $0.04 (p.13, p.20)。计入基础成本。",
      "transport": "运输费",
      "transportHint": "实际运费 — 不做估算。",
      "moqCharge": "MOQ 附加费",
      "moqChargeHint": "Markup Base x MOQ 费率 (p.15)。",
      "addMat": "追加材料",
      "addMatHint": "订单所需但基础成本未涵盖的部分。",
      "ffcmt": "FF CMT 费",
      "ffcmtHint": "供应商加工 Helinox 所提供材料的工费。在附加费之后加计。",
      "ffcmtOff": "仅在 Helinox 提供材料时适用 — 见材料供应方式。",
      "shortLead": "短交期附加费",
      "shortLeadHint": "供应商 CMT x (1 + MOQ 费率) x 短交期费率 (p.21)。",
      "moqBaseLabel": "MOQ 附加费的计费对象",
      "moqBaseHint": "取消勾选该供应商在附加费之后（而非之内）加计的项目。",
      "part_skin": "Skin + Case + 包装",
      "part_cmt": "供应商 CMT",
      "part_ohp": "OH 与利润",
      "part_frame": "框架",
      "part_fmfee": "FM 费",
      "pricingTitle": "定价",
      "stepProfit": "利润 / MSRP 模拟",
      "stepTarget": "目标 MSRP",
      "t1Ratio": "HPAC 外部利润（T2 比例）",
      "t1RatioHint": "是 T2 上的毛利，而非在基础成本上加价。情形 A 必填。",
      "t0Ratio": "HPAC 内部利润（T1 比例）",
      "t0RatioHint": "Helinox 法人实体的层级。情形 B 必填。",
      "options": "方案",
      "optionsNote": "每个方案都是在本报价基础上改动一两项条件 — 会随上方所有数字联动。",
      "optionAdd": "添加方案",
      "optionN": "方案 {{n}}",
      "optAsQuoted": "原报价",
      "optAsQuotedSub": "上方输入的数值",
      "optNoCond": "尚未更改",
      "optSameAsQuote": "与报价相同 — 修改左侧任一数值，这些数字会随之变化。",
      "optEdit": "条件",
      "optCancel": "取消",
      "optDone": "完成",
      "optRemove": "移除",
      "optCondNote": "可在此修改任意数值。未修改的项目沿用报价。",
      "optQuoteReadOnly": "报价本身的数值，用于与选项对照。请在上方各区块中修改。",
      "optClose": "关闭",
      "optOrderProfitT1": "订单总利润（T1）",
      "optOrderProfitT2": "订单总利润（T2）",
      "optQty": "订单数量",
      "optBasis": "毛利计算基础",
      "optT1Profit": "T1 利润",
      "optT2Ratio": "T2 比率",
      "optT2Profit": "T2 利润",
      "optPremium": "Collab 溢价",
      "optShortLead": "短交期附加费",
      "benchTitle": "Inline 基准对比",
      "benchTag": "仅供对比",
      "benchLine": "成本项",
      "benchThis": "本报价",
      "benchInline": "Inline 产品",
      "benchDiff": "差额",
      "vsInline": "对比 Inline 零售价",
      "linesApplied": "此选项收取的额外成本 1 项目",
      "qtyWord": "订单数量",
      "targetHint": "Inline 零售价 × (1 + Collab 溢价)",
      "lineDropped": "不收取",
      "inclTitle": "计入毛利计算基础",
      "exclTitle": "不计入 — 以 HPAC 营销扣款方式收回",
      "inclBoth": "同时计入毛利基础，因此被重复收回",
      "inclTotal": "毛利计算基础",
      "exclTotal": "向合作方扣款",
      "quotedIn": "计毛利",
      "quotedOut": "不计毛利",
      "estIsCheck": "仅作交叉核对，并非报价的 MSRP — 后续计算均不读取该值。本报价采用的 MSRP 在第 6 区块。",
      "msrpIsQuote": "报价 MSRP",
      "factoryWord": "工厂",
      "frameWord": "框架",
      "marginAtQty": "{{n}} EA 时的毛利",
      "gapWord": "差额",
      "collabCol": "Collab",
      "benchCol": "Inline",
      "benchTotal": "工厂成本",
      "benchWhy": "差异原因",
      "benchWhyHint": "Collab 款相对 Inline 版本增加或减少的内容 — 审批人在差额旁看到的说明。此步骤的内容不会改变报价。",
      "ohPart": "O.H",
      "ohPartFixed": "O.H（固定）",
      "frameModelLabel": "框架型号",
      "benchLinkedTo": "关联到",
      "benchNoModel": "尚未选择框架型号",
      "benchFollowsFrame": "沿用第 3 区块所选的框架型号",
      "benchFromCollab": "来自 Collab",
      "benchFrameHint": "Inline 产品所用框架，按其自身标价计。",
      "benchModelHint": "沿用第 3 区块 — 同一部件，因此差额来自价格而非设计。",
      "benchSame": "相同",
      "benchBase": "基础",
      "blkExtra": "额外",
      "fxBuying": "加毛利前的单位成本",
      "fxBuyingRule": "基础 = 工厂 + 框架，即各层级比率的计算基础。额外成本在加毛利之后计入，从不加价。两者合计即为采购成本。",
      "fxBenchBase": "Inline 成本（skin + CMT + OH 及利润 + 框架）",
      "fxBenchBaseRule": "Inline 产品自身的工厂成本，加上其所用框架的标价。之后不再加任何项目 — Inline 一侧未设额外成本。",
      "benchFrameLabel": "框架成本",
      "benchImport": "从成本表填入",
      "benchImportHint": "用 Inline 成本表中已存档的成本表填入此列。",
      "benchSrc": "来源",
      "benchPickTitle": "本报价与哪一行对比？",
      "benchPickBody": "{{file}} 列出了 {{n}} 行价格。请选择与本报价对比的一行 — 每行的金额是该表自身注明的采购成本。",
      "benchVariant": "成本版本",
      "benchApply": "填入基准",
      "benchRefused": "有 {{n}} 行无法读取，因为各列合计与旁边注明的采购成本不符：",
      "benchLibBody": "按款式、SKU、配色或文件名搜索 Inline 成本表中已存档的成本表。",
      "benchSearch": "搜索款式、SKU、配色、文件…",
      "benchNewFile": "读取新文件…",
      "benchBackToLib": "返回库",
      "benchLibEmpty": "尚未存档任何成本表。请在 Sales Operation → Inline 成本表中读入。",
      "benchNoHit": "库中没有与“{{q}}”匹配的内容。",
      "benchLineCol": "项目",
      "benchWhyCol": "说明",
      "benchWhyPh": "差异原因",
      "benchNoGap": "无差额 — 无需说明",
      "benchAllLevel": "所有项目都与 Inline 产品一致 — 无需说明。",
      "benchNotFilled": "填写 Inline 基准对比后即可看到差异所在。",
      "benchElsePh": "其他…",
      "benchBomSub": "Collab 价格与 Inline 价格之间的 BOM 差异。",
      "stepExtra2": "额外成本 2",
      "stepExtra2Sub": "（成本对比）",
      "addMatWhat": "内容…",
      "addLine": "添加一行",
      "removeLine": "删除此行",
      "ohLine": "Helinox 的 O.H",
      "profitLine": "Helinox 利润",
      "extraLine": "额外成本",
      "extraFromBlock": "来自第 4 区块",
      "inclExtra": "O.H + 利润 + 额外成本 — 合作方实际支付的金额",
      "fxOpen": "{{what}} 的计算方式",
      "fxFactory": "工厂成本",
      "fxFrame": "框架成本",
      "fxExtra": "额外成本 1",
      "t2Divide": "{{basis}} ÷ (1 − {{r}}%)",
      "t2ThisQuote": "本报价",
      "t2Both": "同一比率分别套用两种成本核算口径。报价采用已标记的那一种 — 该选择在选项中进行。",
      "t2BasisFromOpt": "按选项设定",
      "fxT2": "T2 定价方式",
      "fxT2Rule": "毛利是从价格中扣出的，而不是在其上加成：基础除以（1 − T2 比率）。所有已保存的报价都采用此口径 — T1 使用的累加法会得出不同的数字。",
      "fxExtraAfter": "在加毛利后计入，从不加价",
      "fxT1Base": "工厂成本 + 框架成本 + 额外成本 1",
      "t1BaseLine": "工厂成本 + 框架成本 + 额外成本 1",
      "optExtraOff": "适用的额外成本 1 项目",
      "optExtraOffLbl": "否",
      "optExtraOffNone": "全部",
      "optExtraOffSome": "已去除 {{n}} 项",
      "t1Sum": "基础 + O.H + 利润",
      "fxT1On": "以 {{n}} 为基础",
      "fxOh": "Helinox 的 O.H",
      "fxProfit": "Helinox 利润",
      "fxTier": "层级价格",
      "fxMsrp": "目标 MSRP",
      "fxLead": "交期",
      "fxBenchProfit": "Inline 产品利润",
      "fxMoq": "MOQ 附加费",
      "fxSl": "短交期附加费",
      "fxFprofit": "框架利润",
      "byOption": "同一报价，按选项对比",
      "optPick": "此选项更改的项目：",
      "optName": "选项名称",
      "optNamePh": "选项 {{n}} — 输入易于识别的名称",
      "fxBenchRule": "Inline 产品自身成本，按 Collab 的 T1 利润率计算 — 基准没有单独的利润率。",
      "optDropCond": "从选项中移除此项",
      "tierSubAny": "O.H + 利润 + 额外成本，按该列自身比率计算",
      "tierSubOwn": "O.H + 利润 + 额外成本",
      "fxTimesQty": "单位金额 × 订单数量 — 整个订单，而非单件。",
      "fxDebitRule": "所有排除项目，在层级价格之外另向合作方收取。",
      "fxDebitInPrice": "不另行扣款 — 按此口径已包含在价格中。",
      "profitSubOwn": "该层级每单位赚取的 O.H 与利润",
      "ohShareAny": "其中 O.H",
      "profitShareAny": "其中利润",
      "optSameShort": "与报价相同",
      "revenueSubAny": "层级价格 × 订单数量 — 整个订单，而非单件",
      "totalProfitSubAny": "单位利润 × 订单数量 — 收入减去订单成本",
      "fxExtraRule": "所有排除项目的合计。",
      "fxMoqRule": "MOQ 基数 × 订单数量所对应的费率。",
      "fxMoqBase": "MOQ 基数",
      "fxSlRule": "供应商 CMT × 交期所对应的短交期费率。",
      "extraInBase": "已含在基础中",
      "unit": "单件",
      "totalWord": "合计",
      "estMsrp": "预估 MSRP：从",
      "estTo": "到",
      "estTimes": "倍 →",
      "targetMsrp": "目标 MSRP",
      "targetMsrpHint": "Inline 零售价 × (1 + 溢价)。",
      "msrpOverT1": "MSRP ÷ T1",
      "msrpOverT1Hint": "所得倍数",
      "yTarget": "Y 的目标价",
      "yTargetHint": "按 Inline 价格比率设定的目标价。可选。",
      "collabVsInline": "Collab 对比 Inline",
      "blockResult": "结果 / 选项",
      "blockDetail": "数字的构成",
      "optConditions": "条件",
      "colCollab": "Collab",
      "colInline": "Inline 基准对比",
      "profitPart": "利润",
      "ohShare": "其中 O.H（{{pct}}）",
      "profitShare": "其中利润（{{pct}}）",
      "dealCase": "情形",
      "dealCaseHint": "属于哪种合作模式 — 决定必须填写哪个层级比率。",
      "dealCasePick": "选择方案…",
      "dealCaseBoth": "两者皆有",
      "dealCaseA": "情形 A：HPAC 直接合作",
      "dealCaseB": "情形 B：子公司主导合作",
      "dealCasePath_both": "工厂 → HPAC → 合作方   ·   工厂 → HPAC → Helinox 子公司 → 其所在市场",
      "dealCasePath_a": "工厂 → HPAC → 联名合作方",
      "dealCasePath_b": "工厂 → HPAC → Helinox 子公司 → 其自有市场",
      "dealCasePathLbl": "谁卖给谁",
      "dealCaseWhat_both": "两条路径都要定价：HPAC 采购后转售，Helinox 子公司也在其自有市场销售。两个层级比率均为必填。",
      "dealCaseWhat_a": "HPAC 从工厂采购货物并直接销售给联名合作方。中间没有 Helinox 子公司，因此只对 HPAC 层级定价。",
      "dealCaseWhat_b": "Helinox 子公司（Helinox Inc.、Helinox Japan 等）从 HPAC 采购并在其自有市场销售。子公司层级定价的就是这第二步。",
      "needPhoto": "保存前请至少添加一张照片。",
      "needCase": "{{sku}}: 请选择方案。",
      "needT1": "{{sku}}: 此方案必须填写 T1 比率。",
      "needT2": "{{sku}}: 此方案必须填写 T2 比率。",
      "needInlineRrp": "{{sku}}: Inline 零售价为必填项。",
      "needPremium": "{{sku}}: Collab 溢价为必填项。",
      "marginBasis": "毛利计算基础",
      "marginBasisBase": "Markup Base（指引）",
      "marginBasisBuying": "总采购成本（报价单）",
      "marginBasisBaseHint": "排除项目不计入 T2 基础 — 改为以 HPAC 扣款方式收回。",
      "marginBasisBuyingHint": "所有项目都加价，因此不单独扣款。",
      "partnerRatio": "合作方比率",
      "partnerRatioHint": "合作方价格占 MSRP 的比例。",
      "inlineRrp": "Inline 零售价",
      "productPage": "产品页面",
      "folderPlaceholder": "文件夹 — 例如 27SS",
      "folderNone": "未归类",
      "newFolder": "新建文件夹",
      "newFolderPlaceholder": "文件夹名称",
      "renameFolder": "重命名",
      "renameFolderTitle": "重命名 {{name}}",
      "deleteFolderTitle": "删除文件夹 {{name}}？",
      "deleteFolderBody": "其中的报价会保留，并退回“未归类”。",
      "dragHint": "将行拖到文件夹上即可归类。",
      "approvePricing": "批准报价",
      "inlineRrpHint": "可比 Inline 产品的零售价。",
      "premium": "Collab 溢价",
      "premiumHint": "联名带来的加价，以 Inline RRP 的百分比表示。",
      "markupBase": "Markup Base",
      "markupBaseSub": "计算毛利所依据的成本",
      "composition": "供应商 FOB 构成",
      "pricingResults": "定价结果",
      "buyingCost": "总采购成本",
      "buyingCostSub": "Markup Base + 排除项目",
      "hpacUnit": "HPAC 营销费用",
      "hpacUnitSub": "每单位",
      "hpacTotal": "HPAC 营销费用",
      "hpacTotalSub": "扣款总额 · 每单位 × 订单数量",
      "t1": "T2（合作品牌）",
      "t1Sub": "Markup Base ÷ (1 − T2 比率)",
      "colStatus": "状态",
      "stDraft": "草稿",
      "colNo": "序号",
      "countAll_one": "{{count}} 份报价",
      "countAll_other": "{{count}} 份报价",
      "countOf": "{{n}} / 共 {{total}}",
      "allTeams": "全部团队",
      "approvalTitle": "报价审批",
      "approvalSub": "两级审批：先由销售经理，再由 CEO。此处的报价均在等待某人处理。",
      "colTeam": "Sales OP",
      "colTrail": "流程记录",
      "colSubmittedBy": "提交人",
      "colNote": "备注",
      "colCreatedBy": "创建人",
      "colCreatedAt": "创建时间",
      "colModifiedBy": "修改人",
      "colModifiedAt": "修改时间",
      "selected": "已选 {{n}} 项",
      "approveSelected": "批准所选",
      "clearSelection": "取消选择",
      "submitTitle": "提交 {{id}}",
      "submitBody": "给 {{who}} 留言 — 说明定价理由或变更内容。可选。",
      "submitPh": "例如：根据 9 月 9 日供应商报价更新框架成本",
      "recall": "撤回",
      "recallTitle": "撤回 {{id}}",
      "recallBody": "此操作会将报价从 {{who}} 的待办队列中撤回并退回草稿，以便您修改后重新提交。系统会发邮件告知对方此报价已不再等待其处理。",
      "recallPh": "撤回原因（可选）",
      "remind": "催办",
      "remindTitle": "催办 {{id}}",
      "remindBody": "系统会给 {{who}} 发邮件，提醒此报价仍在等待其决定，并附上链接。创建人会被抄送。每个报价每 4 小时只能催办一次。",
      "remindPh": "附言（可选），例如：合作方周五前需要价格",
      "remindSend": "发送催办",
      "remindSent": "已向 {{to}} 发送 {{id}} 的催办。",
      "reminded": "{{who}} 已催办 · {{at}}",
      "remindCount": "已催办 {{n}} 次",
      "remindSoon": "{{who}} 已发送过催办。下一次可从 {{at}} 起发送。",
      "noteFrom": "备注",
      "noteManager": "经理",
      "noteFinal": "最终审批人",
      "gateBy": "由 {{who}} 提交",
      "openMissing": "{{id}} 不在此列表中 — 可能已被批准。",
      "deleted": "已删除 {{id}}。",
      "deleteTitle": "删除此项目？",
      "deleteBody": "{{id}} 将从已保存列表中移除。成本核算本身会保留，管理员可以恢复。",
      "confirmDelete": "删除",
      "stagePending": "待处理",
      "stagePendingHint": "在编写人手中 — 包括新草稿和被退回的报价。行上的状态会注明是哪一种。",
      "stageManager": "销售经理 — 审批",
      "stageManagerHint": "已提交，等待 Sales OP 团队经理处理。",
      "stageFinal": "CEO — 审批",
      "stageFinalHint": "经理已批准，等待最终决定。",
      "stageDone": "已批准",
      "stageDoneHint": "已批准并完成，此处没有任何待人处理的事项。",
      "stageApproval": "审批",
      "approvedElsewhere": "已批准的报价属于已完成工作 — 位于“已保存项目”中，可使用“复制”。",
      "queueMine": "等待您处理",
      "queueMineHint": "由您决定。批准后转到下一步；退回需要填写原因。",
      "queueBack": "已退回",
      "queueBackHint": "按要求修改后重新提交。",
      "queueDraft": "未提交",
      "queueDraftHint": "尚未提交给任何人的草稿。",
      "queueWaiting": "在他人处处理中",
      "queueWaitingHint": "正在等待他人处理 — 放在这里，就不必再问“我的报价在哪”。",
      "queueDone": "已批准",
      "queueDoneHint": "已定稿。复制会生成一份注明来源的新草稿。",
      "queueEmpty": "暂无内容。",
      "trailSubmitted": "{{who}} 提交 · {{on}}",
      "trailManager": "销售经理：{{who}} · {{on}}",
      "trailFinal": "CEO 审批：{{who}} · {{on}}",
      "trailNone": "未提交",
      "resubmit": "重新提交",
      "gate": "审批",
      "goApproval": "打开报价审批页面",
      "reload": "重新加载",
      "loading": "加载中…",
      "stPendingmanager": "待处理：经理",
      "stPendingCEO": "待处理：CEO",
      "stApproved": "已批准",
      "stRejected": "已驳回",
      "sentBackMgr": "被销售经理驳回",
      "sentBackCeo": "被 CEO 驳回",
      "submit": "提交",
      "reject": "退回",
      "revise": "复制",
      "view": "查看",
      "rejectTitle": "退回 {{id}}",
      "rejectBody": "请说明需要修改的内容。被退回的人只能依据这段说明处理。",
      "nowStatus": "完成 — 报价当前状态：{{status}}。{{to}}",
      "revisedInto": "已复制为新草稿 {{id}}。",
      "leadWorked": "XF − PO = {{days}} 天 → 短交期 {{rate}}",
      "stepOrder": "订单",
      "stepFactory": "工厂成本",
      "stepFrame": "框架成本",
      "stepOthers": "额外成本 1",
      "days": "天",
      "unitCost": "单位成本",
      "share": "占比",
      "bothConventions": "同一报价的两种口径",
      "whatTheyPay": "各法人实体与合作方支付的金额",
      "marginTakenOn": "毛利计算基础",
      "profitAtT1": "T1 利润",
      "profitAtT2": "T2 利润",
      "profitSub": "层级价格减去毛利计算基础，按单位计",
      "totalProfitAtT1": "T1 总利润",
      "totalProfitAtT2": "T2 总利润",
      "totalProfitSub": "单位利润 × {{qty}} EA — 收入减去订单成本",
      "revenueAtT1": "T1 收入",
      "revenueAtT2": "T2 收入",
      "revenueSub": "层级价格 × {{qty}} EA — 整个订单，而非单件",
      "gapNote": "两种口径在 {{tier}} 上相差 {{gap}}。按指引，每单位 {{unit}} 的其他成本单独向合作方收取 — {{qty}} EA 共 {{debit}}；按报价单则已包含在价格中。同一笔钱放在两个地方，所以报价必须注明采用哪种口径。",
      "basisLine": "按 {{name}} 提交 — 高亮列即请审批人确认的金额。",
      "t0": "T1（Helinox 法人实体）",
      "t0Sub": "Markup Base ÷ (1 − T1 比率)",
      "t0SubBuying": "总采购成本 ÷ (1 − T1 比率)",
      "t1SubBuying": "总采购成本 ÷ (1 − T2 比率)",
      "marginOnBuying": "总采购成本",
      "hpacTotalInPrice": "按此毛利基础已包含在价格中",
      "msrp": "MSRP",
      "msrpSub": "Inline 零售价 × (1 + 溢价 %)",
      "partnerPrice": "合作方价格",
      "partnerPriceSub": "MSRP × 合作方比率",
      "allSkus": "全部 SKU",
      "globalInputs": "全局输入",
      "licensedSub": "授权模式从合作方的零售标价倒推定价。版税按其售价支付，因此关键数字是扣除版税后剩余的毛利。",
      "globalMsrp": "全球 MSRP（USD）",
      "t1Fob": "T1 FOB 价",
      "logistics": "物流 %",
      "logisticsHint": "加到 T1 FOB 上得出到岸成本。",
      "wholesale": "批发 %",
      "wholesaleHint": "批发价占当地 SRP 的比例。",
      "wsRoyalty": "批发版税 %",
      "wsRoyaltyHint": "按批发价计收的版税。",
      "dtcRoyalty": "DTC 版税 %",
      "dtcRoyaltyHint": "按零售价计收的版税。",
      "landed": "到岸成本",
      "landedSub": "T1 FOB × (1 + 物流 %)",
      "entities": "法人实体",
      "addEntity": "添加法人实体",
      "entity": "法人实体",
      "fx": "汇率 / USD",
      "localSrp": "当地 SRP",
      "resultsByEntity": "按法人实体的结果",
      "resultsByEntitySub": "毛利显示扣除版税前与后的数值。两者之差即授权成本。",
      "srpUsd": "SRP（USD）",
      "wholesaleCol": "批发价",
      "wsMargin": "批发毛利",
      "dtcMargin": "DTC 毛利",
      "prePost": "扣前 → 扣后",
      "fobMult": "FOB 倍数",
      "addEntityFirst": "请添加法人实体",
      "colProject": "项目",
      "colName": "名称",
      "openQuote": "打开报价 {{id}}",
      "colMode": "类型",
      "colSkus": "SKU 数",
      "colSavedBy": "保存人",
      "colSaved": "保存时间",
      "general": "常规",
      "licensed": "授权",
      "nothingSaved": "尚未保存任何内容",
      "skuField": "SKU",
      "skuFieldHint": "要计算的单个品项。",
      "globalMsrpHint": "统一的全球零售价（USD），各地 SRP 由此换算。",
      "t1FobHint": "与供应商谈判后的法人实体转移价，未含物流费用。",
      "royaltyNote": "版税不是成本。它不是制造产品所需的费用，而是售出后从销售额中支付的品牌费，因此作为收入下方的独立一行，而不计入成本。它也不适用于集团内部的 T1 转移（HPAC → 各法人实体），只有当产品流向外部（批发商或消费者）时才会产生。",
      "burdenNote": "当批发价为 SRP 的 50% 时，11% 的批发版税与 5.5% 的 DTC 版税实际负担相同。批发比例一变，这种对等关系也随之改变，因此请同时审视两个费率。",
      "autoFillSrp": "自动填写当地 SRP",
      "autoFillHint": "全球 MSRP × 各汇率。",
      "resetEntities": "重置",
      "wholesalePrice": "批发价",
      "dtcRoyaltyAmt": "DTC 版税",
      "wsRoyaltyAmt": "版税",
      "wsMarginLabel": "批发毛利",
      "dtcMarginLabel": "DTC 毛利",
      "pre": "扣前",
      "lowMargin": "毛利偏低",
      "fobBadge": "FOB",
      "cancel": "取消",
      "colAction": "操作",
      "colBuying": "采购成本",
      "colT1": "T2",
      "edit": "编辑",
      "clearFilters": "清除排序和筛选",
      "discardTitle": "放弃此成本核算？",
      "discardBody": "屏幕上的内容尚未保存。放弃后将清空并新建空白项目。",
      "keepEditing": "继续编辑",
      "discard": "放弃"
    },
    "ask": {
      "launch": "问 Catchy",
      "role": "AI 效率助手",
      "note": "聊天内容会用于让 Catchy 变得更聪明。",
      "moveHint": "拖动以移动 · 双击复位",
      "hello": "您好，我是 Catchy。可以问我项目、SKU 及其阶段、样品、工单、OPA / SCT、NFC 令牌和销售 — 只要是您的页面能看到的内容都可以。也可以粘贴截图。",
      "s1": "本周到期的样品有哪些？",
      "s2": "哪些工单已逾期？",
      "s3": "Team 2 有多少个 SKU 处于延迟状态？",
      "hideSugs": "隐藏推荐问题",
      "showSugs": "显示推荐问题",
      "otherSugs": "其他问题",
      "placeholder": "输入问题或粘贴截图…",
      "send": "发送",
      "attach": "添加截图",
      "screenshot": "截图",
      "screenshotReady": "已附上截图",
      "remove": "移除",
      "lookingAt": "正在查看：",
      "lookingAtHint": "Catchy 会把“这个”理解为本页打开的项目",
      "dropContext": "不带此项目提问",
      "save": "保存对话",
      "newChat": "新对话",
      "expand": "展开",
      "shrink": "缩小",
      "close": "关闭",
      "you": "您",
      "leftToday_one": "今天还剩 {{count}} 个问题",
      "leftToday_other": "今天还剩 {{count}} 个问题",
      "noneLeft": "今天的提问次数已用完，请在午夜后再问。"
    },
    "ps": {
      "titleFor": "{{org}} 样品跟踪",
      "partner": "合作方",
      "loading": "加载中…",
      "fills": "由 {{org}} 填写",
      "requiresReview": "需 {{reviewer}} 评审",
      "reviewerDefault": "设计师",
      "reviewerNote": "{{reviewer}} 评审：请在下方“轮次结果”中填写评审日期和结果。",
      "reviewDateHint": "{{reviewer}} 给出评审的日期",
      "internalOnly": "仅 {{org}} 内部评审",
      "internalNote": "请用“评审日期”和“备注”记录 {{org}} 的内部评审。此轮次不计入设计师工作量或待反馈。",
      "internalReview": "{{org}} 内部评审",
      "location": "地点",
      "allLocations": "全部地点",
      "locationPh": "选择或输入地点...",
      "createTitle": "新样品 — 输入款式 / 品项",
      "createSub": "新款式会获得下一个 Base ID（{{prefix}}-00001、{{prefix}}-00002…），并且需要照片。已有的款式则会把本轮次加到其 Base ID 下。",
      "styleTypedHint": "在此输入 — Base ID 按款式名称分配",
      "pickPh": "例如 {{prefix}}-00001-P1 或 {{prefix}}-00001...",
      "pickNone": "没有匹配的样品。如需新建，请使用“+ 创建样品”。",
      "pickCompany": "选择此样品所属的公司",
      "allCompanies": "全部公司",
      "empty": "{{org}} 还没有样品。点击“+ 创建样品”创建第一个。",
      "tourCreateB": "输入款式 / 品项名称并添加照片。新款式会获得下一个 Base ID；已有款式则把轮次加到其自身的 Base ID 下。然后填写样品计划。",
      "tourFiltersB": "可按状态、开发员或地点筛选，或在搜索框中输入。“清除”会还原所有设置，包括列标题上的筛选。",
      "manual": "用户手册",
      "manualTitle": "在新标签页中打开本跟踪页面的手册 — Tiếng Việt、English、한국어、中文、Français、日本語",
      "tourTabsT": "两种查看方式",
      "tourTabsB": "“全部样品”列出每个 Base ID 及其轮次。“样品汇总”每个样品一行，R1 到 R5 各轮次并排显示。"
    },
    "cr": {
      "requestTitle": "快递申请",
      "requestSub": "凡使用 Helinox 快递账户（FedEx、DHL、UPS …）发货，请先在此提交申请。系统会将费用与合同费率对比；审批人在发货前作出决定。不适用于普通海运或空运。",
      "approvalTitle": "快递审批",
      "approvalSub": "发货前等待决定的快递件，按 HINC 的 FedEx 与 HPAC 的 DHL 合同价核对。审批人：{{who}}。",
      "new": "新申请",
      "newTitle": "新快递申请",
      "close": "关闭",
      "cancel": "取消",
      "send": "提交审批",
      "pick": "选择…",
      "loading": "加载中…",
      "clear": "清除",
      "sendNote": "提交审批后将发送给审批人 {{who}}，由其在此批准或驳回。您和抄送人员也会收到邮件。",
      "b_requester": "申请人",
      "b_carrier": "快递公司与计费账户",
      "b_route": "发货地与目的地",
      "b_weight": "重量与箱数",
      "b_cost": "预估费用",
      "b_goods": "货物",
      "requester": "申请人",
      "department": "部门",
      "ccEmails": "抄送（账户所属法人实体）",
      "ccHint": "Young 规则 1：抄送账户所属法人实体。仅限 @helinox.com 地址，用逗号分隔。",
      "carrier": "快递公司",
      "carrierOther": "快递公司名称",
      "service": "服务等级",
      "accountHolder": "计费的 Helinox 账户",
      "accountHint": "由其快递账户付款的法人实体。",
      "accountNo": "账号",
      "from": "发货地",
      "to": "目的地",
      "shipper": "发货人",
      "receiver": "收货人",
      "country": "国家",
      "city": "城市",
      "address": "地址",
      "zipHint": "请包含邮政编码。",
      "toIndividual": "送至个人地址（同事家中、客户现场）",
      "importer": "收货人及登记进口商",
      "importerHint": "Young 规则 5：填写 Helinox 法人实体，个人作为转交人（c/o）— 绝不能只写个人。",
      "shipmentTo": "收货方",
      "to_internal": "Helinox 法人实体或团队",
      "to_direct": "客户或第三方（直发）",
      "toDirect": "直接发给客户或第三方（非 Helinox 法人实体）",
      "to_customer": "客户（直发）",
      "to_partner": "合作方或第三方（直发）",
      "freightPayer": "运费承担方",
      "payerHint": "Young 规则 6：订舱前说明由谁付款。",
      "incoterm": "贸易条款（Incoterm）",
      "cartons": "箱数",
      "actualKg": "实际重量（毛重），kg",
      "dimKg": "体积重，kg",
      "dimPh": "所有箱子合计",
      "useBoxTitle": "按单箱尺寸（L × W × H ÷ 5,000）× 箱数计算体积重",
      "boxSize": "箱子尺寸，cm（L × W × H）",
      "useBox": "应用",
      "estCost": "预估运费",
      "currency": "币种",
      "duties": "预估关税 / 税费",
      "dutiesDdp": "DDP：由 Helinox 支付 — 请填写预估金额（没有则填 0）。",
      "bulkyNote": "大件货（体积重大于实重，或超过 100 kg）：不默认使用快递。订舱前请至少添加一份货代报价进行比较（Young 规则 2）。支杆、帐篷、框架和家具本身即属大件货。",
      "fwdName": "货代",
      "fwdCost": "货代报价",
      "goodsFor": "货物收件对象",
      "goodsForHint": "货物送达的个人、团队或客户。",
      "contents": "内容物",
      "purpose": "用途",
      "notes": "备注",
      "checkTitle": "费用核查",
      "checkWhat": "填写表单时，系统会将您的预估费用与 HINC 的 FedEx 合同费率进行比较。",
      "checkNeed": "仍需填写：{{list}}。",
      "need_courier": "快递公司",
      "need_dest": "目的国",
      "need_weight": "实际重量",
      "need_cost": "预估费用",
      "need_currency": "币种",
      "chargeable": "计费重量",
      "bulky": "大件货",
      "quoted": "您的预估",
      "usdPerKg": "每 kg",
      "diff": "对比合同费率",
      "fxWeek": "汇率（NetSuite）",
      "v_reasonable": "合理",
      "v_review": "建议复核",
      "v_high": "可能偏高",
      "v_nocontract": "无合同费率",
      "v_manual": "人工核查",
      "v_undefined": "—",
      "s_waiting": "待审批",
      "s_approved": "已批准",
      "s_rejected": "已驳回",
      "s_withdrawn": "已撤回",
      "tab_waiting": "待决定",
      "tab_approved": "已批准",
      "tab_rejected": "已驳回",
      "tab_all": "全部",
      "tab_rates": "费率",
      "empty_waiting": "没有待决定的申请。",
      "empty_approved": "尚无已批准的申请。",
      "empty_rejected": "没有被驳回的申请。",
      "empty_all": "尚无快递申请。",
      "emptyMine": "您还没有提交过快递申请。",
      "countRows": "{{n}} / {{total}}",
      "c_no": "申请",
      "c_created": "发送日期",
      "c_requester": "申请人",
      "c_entity": "法人实体",
      "c_route": "路线",
      "c_carrier": "快递公司",
      "c_originCountry": "始发国家",
      "c_originCity": "始发城市",
      "c_destCountry": "目的国家",
      "c_destCity": "目的城市",
      "c_service": "服务",
      "c_account": "账户",
      "c_kg": "计费重量 (kg)",
      "c_cost": "预估",
      "c_check": "核查",
      "c_status": "状态",
      "c_decidedBy": "决定人",
      "c_decidedAt": "决定日期",
      "f_route": "路线",
      "f_carrier": "快递公司和服务",
      "f_account": "计费账户",
      "f_weight": "重量和箱数",
      "f_cost": "预估运费",
      "f_fwd": "货代报价",
      "f_goodsFor": "货物收件对象",
      "f_purpose": "用途",
      "f_contents": "货物内容",
      "f_shipper": "发货人",
      "f_receiver": "收货人",
      "f_importer": "登记进口商",
      "f_direct": "直发（运费承担方）",
      "f_incoterm": "贸易条款",
      "ddpShort": "Helinox 承担关税和税费",
      "f_requester": "申请人",
      "f_cc": "抄送",
      "f_notes": "备注",
      "actualShort": "实重",
      "dimShort": "体积重",
      "chargeableShort": "计费重",
      "cartonsShort": "箱",
      "dutiesShort": "关税/税费",
      "raised": "{{by}} 于 {{at}} 发送。",
      "approvedBy": "{{by}} 已批准 · {{at}}",
      "rejectedBy": "{{by}} 已驳回 · {{at}}",
      "withdrawnAt": "已于 {{at}} 撤回。",
      "rule4": "如果订舱时承运商的报价高于此预估，请在发货前停下并说明（Young 的第 4 条规则）。",
      "approve": "批准",
      "reject": "驳回",
      "withdraw": "撤回",
      "withdrawAsk": "撤回 {{no}}？审批人将收到通知，无需再做决定。",
      "didApprove": "{{no}} 已批准，已通知申请人。",
      "didReject": "{{no}} 已驳回，已告知申请人原因。",
      "didWithdraw": "{{no}} 已撤回。",
      "s_draft": "草稿",
      "notSent": "未发送",
      "saveDraft": "保存草稿",
      "c_createdBy": "创建人",
      "c_createdAt": "创建时间",
      "checkSource": "根据 HINC 的 FedEx 合同费率文件计算，并非 AI 审核。",
      "noContract": "此线路无合同价",
      "contractBase": "未含燃油附加费的合同费率",
      "h_shipment": "货件",
      "h_source": "数据来源",
      "h_findings": "核查结果",
      "editTitle": "编辑 {{no}}",
      "copyTitle": "新快递申请 — 复制自 {{no}}",
      "savedDraft": "{{no}} 已保存为草稿，准备好后再发送。",
      "didDelete": "{{no}} 已删除。",
      "didDeleteMailed": "{{no}} 已删除，已通知审批人无需再做决定。",
      "deleteAsk": "删除 {{no}}？此操作无法撤销。",
      "deleteAskWaiting": "删除 {{no}}？该申请正在审批人处，审批人将收到通知，无需再做决定。此操作无法撤销。",
      "saveWaiting": "保存",
      "changedByYou": "{{no}} 已修改，已告知申请人修改了哪些内容。该申请仍在等待您的决定。",
      "changedBy": "最后修改：{{by}} · {{at}}。",
      "why_notWaiting": "仅限等待决定的申请",
      "c_managerNote": "经理备注",
      "c_action": "操作",
      "a_view": "查看",
      "a_edit": "编辑",
      "a_submit": "提交",
      "a_copy": "复制",
      "a_delete": "删除",
      "a_withdraw": "撤回",
      "why_waiting": "在审批人处，请先撤回再修改",
      "why_approved": "已批准，可复制用于其他货件",
      "why_sent": "已在审批人处",
      "why_done": "已作出决定",
      "why_record": "已批准，保留作为审批记录",
      "why_notMine": "不是您的申请",
      "sent": "{{no}} 已提交审批。",
      "sentMailed": "{{no}} 已提交审批，已通知审批人。",
      "billed": "计费重量",
      "lane": "合同线路",
      "dir_export": "从韩国出口",
      "dir_import": "进口到韩国",
      "dir_sg-export": "从新加坡出口",
      "dir_sg-import": "进口至新加坡",
      "dhlFreightOnly": "DHL 价目表：仅运费 — 燃油附加费、关税及 DHL 杂费另计",
      "estSurcharge": "预估附加费",
      "estSurchargeHint": "运费之外的燃油、偏远地区等附加费 — 合同价仅含运费",
      "dhlSettingsTitle": "HPAC DHL（新加坡）— 价目表仅含运费",
      "dhlFuelPct": "DHL 燃油附加费 %",
      "dhlRemarkLabel": "每次与 DHL 合同价比较时显示的备注",
      "ratesTitleDhl": "HPAC DHL Express 合同价（SGD）",
      "ratesNoteDhl": "DHL Express Worldwide，依据 HPAC 的 DHL Express Singapore 价目表。30 kg 以内按整票计价，以 0.5 kg 为单位；30.1 kg 起按每公斤计价，以整公斤为单位。仅含运费：燃油附加费、关税、税费及 DHL 杂费另计。仅文件价格与第三国 DHL 未载入。明年的价目表（.pdf）同样通过上传载入。",
      "contract": "合同费率",
      "withFuel": "含燃油附加费 {{pct}}%",
      "prioRate": "Priority：Economy 费率 × {{f}}",
      "econRate": "Economy 费率，按文件",
      "economyBase": "文件中的 Economy 费率",
      "h_remark": "备注",
      "priorityFactor": "Priority = Economy 费率 ×",
      "remarkLabel": "显示在每次合同价对比下方的备注",
      "rateFile": "费率文件",
      "depPick": "选择或输入部门",
      "depNone": "没有匹配“{{name}}”的结果",
      "depAddTo": "+ 将“{{name}}”添加到部门列表",
      "depAdded": "已将“{{name}}”添加到列表。",
      "rateVersion": "合同费率来自 {{file}} · 由 {{by}} 上传 · {{at}}",
      "rateNone": "尚未加载合同费率。",
      "settingsTitle": "核查如何判断报价",
      "settingsNote": "费率文件是 FedEx 的 Economy 费率；Priority 服务按该费率乘以系数计算。合同不含燃油附加费，因此除非有变化，否则保持为 0。报价与合同费率的差距在“合理上限”以内为合理，在“复核上限”以内建议复核，超过则可能偏高。",
      "fuelPct": "燃油附加费 %",
      "okPct": "合理上限 (%)",
      "reviewPct": "复核上限 (%)",
      "saveSettings": "保存",
      "settingsSaved": "已保存。",
      "ratesTitle": "HINC FedEx 合同费率 (KRW)",
      "ratesNote": "20.5 kg 以内按整票计价，每半公斤一档；21 kg 起按每公斤计价，每整公斤一档。明年的文件通过“上传”导入：先读取，再替换此列表。",
      "upload": "上传价目文件（FedEx .xlsx / DHL .pdf）",
      "previewCounts": "出口：{{el}} 列，{{ec}} 个目的地。进口：{{il}} 个区域代码，{{ic}} 个国家。共 {{rows}} 个价格。",
      "replaceRates": "替换费率",
      "ratesLoaded": "已从 {{file}} 加载费率。",
      "weightCol": "重量",
      "perKgShort": "（每 kg）",
      "laneNoCountry": "此列未对应任何国家",
      "countriesTitle": "每列包含的国家"
    },
    "spl": {
      "title": "销售计划",
      "loading": "加载中…",
      "cycle": "订单周期",
      "season": "季",
      "next": "下一个",
      "orderDue": "下单",
      "exf": "出厂",
      "tab_format": "订单模板",
      "tab_sheets": "订单表",
      "tab_stock": "库存",
      "tab_production": "生产",
      "tab_overview": "概览",
      "tab_setup": "设置",
      "fmtNone": "未上传",
      "fmtCount": "{{n}} 个 SKU",
      "sheetsCount": "{{done}}/{{n}} 已完成",
      "stockServed": "{{n}} 件来自库存",
      "prodCount": "{{set}}/{{n}} 已指定工厂",
      "st_open": "进行中",
      "st_closed": "已关闭",
      "closedNote": "此订单已关闭，如需修改，请在订单模板中重新打开（编辑 › 状态）。",
      "newOrder": "创建订单",
      "newOrderTitle": "创建订单",
      "open": "打开",
      "openFormat": "打开此订单的模板",
      "delOrder": "删除订单",
      "col_id": "ID",
      "view": "查看",
      "viewOrder": "查看此订单（只读）",
      "editOrder": "编辑此订单及其模板",
      "modeView": "仅查看",
      "modeEdit": "编辑中",
      "formatHead": "订单模板 · {{n}} 个 SKU",
      "col_file": "订单模板文件",
      "fileBy": "{{by}} · {{at}}",
      "fileNone": "尚无订单模板文件。",
      "col_format": "模板中的 SKU",
      "col_sheets": "已完成订单表",
      "col_qty": "已下单（件）",
      "col_createdBy": "创建人",
      "col_createdAt": "创建时间",
      "col_action": "操作",
      "ordersCount": "{{n}} / {{total}} 个订单",
      "clearFilters": "清除筛选",
      "noOrderYetMgr": "尚无订单，请点击“创建订单”并导入其订单模板。",
      "noOrderYet": "尚无订单，由销售计划经理在订单模板中创建。",
      "fmtSource": "订单模板",
      "src_file": "导入 Master order format (.xlsx)",
      "src_copy": "复制之前某个订单的模板",
      "src_later": "稍后添加",
      "copyOption": "{{date}} · 出厂 {{exf}} · {{n}} 个 SKU",
      "datesFirst": "请填写下单截止日和出厂日，两者都填好后会立即读取文件。",
      "pvFile": "工作表“{{sheet}}”：{{rows}} 个 SKU 将成为此订单的模板。",
      "pvCopy": "将从 {{date}} 的订单复制 {{n}} 个 SKU。",
      "orderCreated": "已创建订单 {{date}}，模板中有 {{n}} 个 SKU。",
      "orderCreatedNoFmt": "已创建订单 {{date}}，准备好后请导入其订单模板。",
      "orderDeleted": "已删除订单 {{date}}。",
      "delAsk": "删除截止日为 {{date}}（出厂 {{exf}}）的订单及其模板中的 {{n}} 个 SKU？尚无人处理此订单。",
      "formatOf": "订单模板 · {{date}}（{{season}}） · 出厂 {{exf}}",
      "seasonAuto": "季 {{s}}，按下单截止日计算（10 月至次年 9 月）。",
      "seasonAutoTip": "根据下单截止日计算：一季为 10 月至次年 9 月。",
      "sh_none": "未开始",
      "sh_open": "进行中",
      "sh_done": "已完成",
      "sh_checked": "已核对",
      "st_done_done": "{{cust}}：已标记完成，销售计划经理现在可以核对。",
      "st_check_done": "{{cust}}：已核对。",
      "st_reopen_done": "{{cust}}：已重新打开。",
      "cancel": "取消",
      "close": "关闭",
      "save": "保存",
      "saveN": "保存（{{n}}）",
      "saved": "已保存。",
      "savedCells": "已保存 {{n}} 项更改。",
      "edit": "编辑",
      "remove": "移除",
      "removed": "已从本周期移除 {{sap}}。",
      "read": "读取文件",
      "write": "写入",
      "writeN": "写入 {{n}} 项更改",
      "search": "SAP 代码、产品、颜色…",
      "allCategories": "全部类别",
      "allLineups": "全部产品线",
      "noRows": "没有匹配项。",
      "noOrders": "本周期尚无订单。",
      "sap": "SAP 代码",
      "product": "产品",
      "qty": "订单数量",
      "amountUsd": "金额 (USD)",
      "total": "合计",
      "buyer": "客户",
      "pic": "负责人",
      "status": "状态",
      "fmtEmpty": "本周期尚无订单模板。",
      "fmtEmptyHint": "上传当月的 Master order format (.xlsx)。其中的 SKU 和价格将成为本周期的清单，订单表只提供这些 SKU。随时可以添加或修改 SKU。",
      "fmtWaiting": "由销售计划经理上传。",
      "upload": "上传订单模板",
      "uploadNew": "上传新版本",
      "copyFrom": "复制 {{cycle}} 的模板",
      "addSku": "添加 SKU",
      "fmtDownload": "下载模板",
      "fmtDownloadTip": "本周期的订单模板，按 Master order format 的版式导出为 .xlsx，修改后可再上传。",
      "portalOnly": "由 Portal 保存：Master order format 中没有此列，取自包含该 SKU 的最近一个周期。",
      "fmtNote": "{{n}} / {{total}} 个 SKU · 价格单位 USD",
      "fmtUploadTitle": "上传 Master order format",
      "fmtUploadBody": "文件会先被读取，只有在您点击“写入”后才会写入。本周期已有的 SKU 将采用文件中的属性和价格；文件中未列出的 SKU 会保留，除非您勾选下方的选项。",
      "fmtSummary": "工作表“{{sheet}}”：{{rows}} 个 SKU，其中 {{added}} 个新增，{{changed}} 个变更，{{missing}} 个在本周期中但不在文件中。",
      "fmtAdded": "新增",
      "fmtChanged": "变更",
      "fmtMissing": "不在文件中",
      "fmtUsed": "已勾选或已下单，保留",
      "fmtRemove": "同时移除不在文件中且无人勾选或下单的 {{n}} 个 SKU",
      "fmtNoChange": "文件与本周期的模板一致。",
      "fmtDone": "订单模板已写入：新增 {{added}}，变更 {{changed}}，移除 {{removed}}。",
      "fmtCopied": "已复制 {{n}} 个 SKU。",
      "skuNew": "添加 SKU",
      "skuEdit": "编辑 {{sap}}",
      "skuRemoveAsk": "从本周期的订单模板中移除 {{sap}}（{{product}}）？",
      "noFormatYet": "请先上传订单模板，所有订单表都会提供其中的 SKU。",
      "priceCol": "计价",
      "pf_price_t1": "T1 FOB",
      "pf_price_t2": "T2 FOB",
      "pf_price_hema_dt": "HEMA DT 价格",
      "pf_null": "—",
      "ticked": "已勾选 SKU",
      "ordered": "已下单",
      "updated": "最后保存",
      "myBuyers": "仅我的客户",
      "allStatus": "全部状态",
      "sheetsNote": "{{done}} / {{n}} 张订单表已完成",
      "sapAll": "SAP 上传（全部客户）",
      "sapOne": "此客户的 SAP SO 上传",
      "sheetTitle": "订单表 {{date}}",
      "customerRef": "Customer Reference（客户 PO#）",
      "showTicked": "已勾选（{{n}}）",
      "showAll": "全部 SKU（{{n}}）",
      "tick": "勾选",
      "tickShown": "勾选全部显示项",
      "untickShown": "取消勾选全部显示项",
      "fromLast": "与上一周期相同的 SKU",
      "fromLastDone": "已勾选 {{n}} 个 SKU，与 {{date}} 相同。",
      "nothingTicked": "尚未勾选任何内容：请勾选此客户可订购的 SKU（全部 SKU），或从上一周期开始。",
      "tickedN": "已勾选 {{n}} 个",
      "exportForm": "客户订单表单",
      "exportTip": "仅包含已勾选 SKU 和此客户价格的订单模板，由客户填写订单数量。",
      "tickFirst": "请先勾选此客户可订购的 SKU",
      "saveFirst": "请先保存您的更改",
      "importForm": "导入客户的表单",
      "markDone": "完成",
      "markChecked": "标记为已核对",
      "reopen": "重新打开",
      "doneBy": "由 {{who}} 完成，{{at}}",
      "checkedBy": "由 {{who}} 核对，{{at}}",
      "unsaved": "{{n}} 项更改未保存。",
      "keepEditing": "继续编辑",
      "discard": "放弃更改",
      "sheetLocked": "此订单表已移交，销售计划经理仍可修改或重新打开。",
      "notYours": "此客户的负责人是 {{pic}}，只有该负责人或销售计划经理可以填写此订单表。",
      "flagCycle": "订单模板：{{rule}}，本周期未开放",
      "flagPrice": "此客户无价格",
      "formTitle": "{{cust}} — 导入客户的表单",
      "formBody": "您发送并由客户填写的表单 (.xlsx)：读取其中的 SAP Code 和 Order Q'ty 列。表单上的每个 SKU 采用其数量（空白表示未订购），表单上没有的 SKU 保持不变。点击“写入”之前不会写入任何内容。",
      "formSummary": "工作表“{{sheet}}”：{{rows}} 行 SKU，共订购 {{total}} 件，{{n}} 个 SKU 有变化。",
      "formUnknown": "不在本周期订单模板中（未导入）：{{list}}",
      "formDup": "重复列出（采用第一个）：{{list}}",
      "formNoChange": "表单内容与订单表现有内容一致。",
      "formWritten": "{{cust}}：已从表单写入 {{n}} 个 SKU。",
      "was": "当前",
      "now": "表单上",
      "stockNote": "填写三个库存池后进行分配：按库存优先级（设置 › 客户）依次为客户分配，每个客户依次从 KR 国内、EUSU、KR SOP 中取货。",
      "notAllDone": "{{n}} 张订单表尚未完成，全部完成后请重新分配。",
      "countOver": "{{n}} 条客户明细从库存获得的数量多于其订购量。",
      "pool_kr_dom": "KR 国内",
      "pool_eusu": "EUSU (SOP)",
      "pool_kr_sop": "KR (SOP)",
      "avail": "可用",
      "fromStock": "来自库存",
      "left": "剩余",
      "allocation": "分配给",
      "onlyActive": "仅显示有订单或库存的 SKU",
      "stockTpl": "库存文件",
      "stockImport": "导入库存文件",
      "allocate": "分配库存",
      "allocateTitle": "分配库存",
      "allocateGo": "分配",
      "allocateBody": "所有有库存的 SKU 将重新分配：按下方顺序为客户分配，每个客户依次从 KR 国内、EUSU、KR SOP 中取货，最多取其订购量及库存池剩余量。这些 SKU 上手动修改的数字将被替换。",
      "allocateOrder": "分配顺序（设置 › 客户 › 库存优先级）：",
      "allocated": "已为 {{skus}} 个 SKU 分配库存：{{pcs}} 件来自库存。",
      "allocEdit": "{{sap}} 的分配",
      "allocTotal": "已分配 {{served}} / 可用 {{avail}}",
      "stockImportBody": "文件中的 SKU 采用其中的三个数字（空白表示无库存）；文件中未列出的 SKU 保持不变。请下载库存文件查看版式。",
      "stockSummary": "工作表“{{sheet}}”：{{rows}} 行，{{n}} 个 SKU 有变化。",
      "stockWritten": "已为 {{n}} 个 SKU 写入库存。",
      "prodNote": "需生产 = 订单 − 库存分配量，按客户计算后汇总。为每个 SKU 指定工厂及超额生产量；卡片显示各工厂的计划数量。",
      "required": "需生产",
      "overbuild": "超额生产",
      "planned": "计划",
      "factory": "工厂",
      "comment": "备注",
      "needsOnly": "仅显示需生产的 SKU",
      "allFactories": "全部工厂",
      "unassigned": "未分配",
      "byBuyer": "按客户",
      "m_order": "订单",
      "m_stock": "来自库存",
      "m_prod": "生产",
      "total_order": "订单合计",
      "total_stock": "库存合计",
      "total_prod": "需生产",
      "mNote_order": "黄色：在本周期未开放的 SKU 上下单，或该客户没有价格。",
      "mNote_stock": "红色：从库存获得的数量多于客户订购量。",
      "mNote_prod": "订单 − 库存，按客户计算。",
      "c_orders": "订单合计",
      "c_stock": "来自库存",
      "c_prod": "需生产量",
      "c_ob": "超额生产",
      "c_planned": "计划生产量",
      "c_amount": "订单金额",
      "customerReport": "客户报告 — 按产品类别",
      "priceRule": "金额 = 数量 × 客户价格：T2 客户按 T2 FOB，HEMA 经销商按 HEMA DT 价格，其他客户按 T1 FOB。",
      "sub_customers": "客户",
      "sub_cycles": "日程",
      "addCustomer": "添加客户",
      "active": "启用",
      "discontinued": "已停用",
      "custNote": "负责人 = 填写该客户订单表的 Sale OP 人员。价格等级和法人实体决定价格列；设置了订单簿列的客户才会出现在订单表中；库存优先级是库存分配的顺序。",
      "cycleNote": "下单和出厂日程（Monthly order program 2026）。已关闭的周期无法修改。",
      "etas": "ETA KR/JP/SIN · AUS · EU · USA",
      "etaLine": "{{a}} · {{au}} · {{eu}} · {{us}}",
      "edit_customer": "编辑客户",
      "edit_customer_new": "添加客户",
      "edit_cycle": "编辑订单 {{date}}",
      "f_customer_key": "客户",
      "f_pic_user_id": "负责人 (Sale OP)",
      "f_country": "国家",
      "f_pricing": "价格等级",
      "f_entity": "Helinox 法人实体",
      "f_status": "状态",
      "f_sold_to": "Sold-To (SAP)",
      "f_ship_to": "Ship-To (SAP)",
      "f_grid_order": "订单簿列",
      "f_alloc_priority": "库存优先级",
      "f_remark": "备注",
      "f_sap_code": "新 SKU#（SAP Code）",
      "f_product": "产品",
      "f_skin_color": "面料颜色",
      "f_frame_color": "框架颜色",
      "f_selling_sku": "销售 SKU#",
      "f_upc": "UPC",
      "f_line_category": "类别",
      "f_lineup": "产品线",
      "f_order_cycle": "订单周期",
      "f_noos": "NOOS=Never Out of Stock（常青 SKU）",
      "f_product_category": "产品类别",
      "f_ex_factory_loc": "出厂地点",
      "f_carton_qty": "每箱数量",
      "f_hts_usa": "美国 HTS 编码",
      "f_hts_eu": "欧洲 HTS 编码",
      "f_ctn_size": "外箱尺寸 (mm) /类型",
      "f_frame_category": "框架类别",
      "f_price_t1": "T1 FOB（全球法人实体及亚洲客户）",
      "f_price_hema_dt": "T1 FOB（仅限 HEMA DT）",
      "f_price_t2": "T2 FOB（非经销商）",
      "f_season": "季",
      "f_fc_due": "FC 截止日",
      "f_order_due": "下单截止日",
      "f_ex_factory": "出厂日",
      "f_items_note": "品项",
      "f_eta_asia": "ETA KR/JP/SIN",
      "f_eta_aus": "ETA 澳大利亚",
      "f_eta_eu": "ETA 欧洲",
      "f_eta_usa": "ETA 美国"
    },
    "nav": {
      "aiPowered": "本门户中的摘要和回答由 Anthropic 的 AI Claude 撰写",
      "report": "报告",
      "salesReport": "销售报告",
      "saleOperation": "其他工具",
      "development": "开发",
      "salesOperation": "销售运营",
      "production": "生产",
      "productSalesDashboard": "产品销售看板",
      "salesReportDashboard": "经营绩效",
      "marketingDashboard": "营销看板",
      "dataExplorer": "数据探索",
      "salesDataLoad": "销售数据更新",
      "inventoryReport": "Global Inventory Report",
      "poleInventory": "支架库存月结",
      "eusuStock": "EUSU 非销售库存",
      "inventoryDashboard": "库存看板",
      "poleDashboard": "支架库存看板",
      "demandForecastDashboard": "需求预测看板",
      "autoJobs": "Sales Op. Python",
      "dashboard": "看板",
      "projectTracker": "项目跟踪",
      "documents": "电子文档",
      "documentLibrary": "文档库",
      "sampleTracker": "样品跟踪",
      "partnerSamples": "DAC 样品跟踪",
      "ticketStation": "工单中心",
      "userManual": "用户手册",
      "projectApproval": "项目审批",
      "nfcTokenPortal": "NFC Token 门户",
      "pricingCalculator": "Collab 报价计算器",
      "ceoOffice": "CEO 办公室",
      "gtm": "GTM",
      "finance": "财务",
      "cashSetup": "设置",
      "cashImport": "提交",
      "cashApproval": "审批",
      "courierRequests": "快递申请",
      "courierApproval": "快递审批",
      "courier": "快递",
      "collabPricing": "Collab 报价",
      "arrangeOpen": "调整菜单",
      "arrangeTitle": "调整您的菜单",
      "arrangeHint": "拖动文件夹或条目，或使用箭头。此顺序仅您可见。",
      "arrangeUp": "上移 {{name}}",
      "arrangeDown": "下移 {{name}}",
      "arrangeDone": "完成",
      "arrangeCancel": "取消",
      "arrangeReset": "重置",
      "arrangeResetHint": "恢复门户的默认顺序",
      "arrangeIsDefault": "当前已是门户的默认顺序",
      "arrangeFailed": "无法保存菜单顺序",
      "arrangeUnfold": "显示 {{name}} 中的条目",
      "arrangeFold": "隐藏 {{name}} 中的条目",
      "hevnAdmin": "HEVN 行政",
      "driverLog": "司机日志",
      "salesPlanning": "销售计划",
      "splFormat": "订单模板",
      "splOrders": "订单表",
      "splStock": "库存分配",
      "splProduction": "工厂分配",
      "splOverview": "订单概览",
      "splSetup": "计划设置",
      "cashWeekly": "每周现金报告",
      "cashPlan": "月度现金计划",
      "cashMonthEnd": "月末对账",
      "cashReport": "现金报告",
      "gtmProgrammes": "GTM 方案",
      "gtmApproval": "GTM 审批",
      "gtmTracker": "GTM 跟踪",
      "ceoFolder": "CEO",
      "benchmarkLibrary": "Inline 成本表",
      "pricingApproval": "报价审批",
      "costing": "成本核算",
      "opaSct": "OPA / SCT",
      "sctSummary": "SCT 汇总"
    },
    "cash": {
      "title": "设置",
      "sub": "所有现金报告读取的清单：法人实体、银行账户、周、汇率、费用类别，以及编制、审核和批准人员。任何更改须经 Group CFO 批准后才生效。",
      "loading": "加载中…",
      "tab_entity": "法人实体",
      "tab_account": "账户",
      "tab_user": "用户",
      "tab_period": "期间",
      "tab_fx": "汇率",
      "tab_expense": "费用类别",
      "tab_account_type": "账户类型",
      "tab_role": "角色",
      "tab_notice": "通知",
      "tab_flow": "流程",
      "tab_changes": "待批更改",
      "tab_history": "历史",
      "tab_setting": "设置项",
      "tab_currency": "币种",
      "f_code": "代码",
      "f_name": "名称",
      "f_tax_code": "税号 / 识别码",
      "f_legal_address": "注册地址",
      "f_country": "国家",
      "f_ho_address": "总部地址",
      "f_acc_mail": "行政 / 会计邮箱",
      "f_min_balance_sgd": "最低余额 (SGD)",
      "f_status": "状态",
      "f_seq": "顺序",
      "f_account_id": "账户 ID",
      "f_entity_code": "法人实体",
      "f_account_no": "账号",
      "f_currency": "币种",
      "f_bank_name": "银行名称",
      "f_account_type": "账户类型",
      "f_restricted": "受限",
      "f_fixed_deposit": "定期存款",
      "f_remarks": "备注",
      "f_user_code": "代码",
      "f_mail": "邮箱",
      "f_role_key": "角色",
      "f_year": "年",
      "f_week": "周",
      "f_week_ending": "周末日期（周五）",
      "f_submit_deadline": "提交截止日",
      "f_category_type": "类型",
      "f_describe": "说明",
      "f_type_name": "类型",
      "f_default_restricted": "默认：受限",
      "f_default_fd": "默认：定期存款",
      "f_action": "操作",
      "f_right_scope": "权限",
      "f_restriction": "限制（职责分离）",
      "f_notice_id": "通知 ID",
      "f_header": "标题",
      "f_content": "内容",
      "f_report": "报告",
      "f_send_to_role": "发送给（角色）",
      "f_send_day": "发送日",
      "f_send_time": "发送时间",
      "f_setting_value": "值",
      "f_rate": "汇率",
      "f_week_code": "周",
      "f_trigger_key": "触发条件",
      "tab_log": "通知日志",
      "trg_report_open": "周报开放（定时）",
      "trg_due_soon": "截止提醒（定时）",
      "trg_missing": "未提交（定时）",
      "trg_plan_update": "13 周计划更新（定时）",
      "trg_month_open": "月末对账开放（定时）",
      "trg_upload_errors": "上传有错误",
      "trg_submitted": "已提交审核",
      "trg_reviewed": "已审核",
      "trg_approved": "Group CFO 已批准",
      "trg_closed": "CEO 已关闭",
      "trg_returned": "已退回",
      "trg_below_min": "低于最低余额",
      "trg_setup_submitted": "设置已提交审批",
      "mailHeld": "邮件暂停",
      "mailLive": "邮件已启用",
      "mailHeldLine": "模块建设期间，现金报告邮件处于暂停状态：下方每条通知都已生成并记录，但没有发送给任何人。",
      "mailLiveLine": "现金报告邮件已启用：下方通知已发送。",
      "logRun": "立即运行定时通知",
      "logRunAt": "按此时刻运行",
      "logAtWhy": "留空表示现在，或选择一个时刻以查看届时会发送什么（仅在邮件暂停期间可用）。服务器时间。",
      "logRan_one": "按 {{at}} 运行：生成了 {{count}} 条通知。",
      "logRan_other": "按 {{at}} 运行：生成了 {{count}} 条通知。",
      "logEmpty": "尚未生成任何现金报告邮件。",
      "logWhen": "时间",
      "logStatus": "状态",
      "logWhat": "通知",
      "logFor": "法人实体 · 期间",
      "logTo": "收件人",
      "logSubject": "主题",
      "log_held": "已暂停",
      "log_sent": "已发送",
      "log_failed": "失败",
      "log_claimed": "发送中…",
      "log_tester": "已发送给测试人员",
      "testAs": "以角色测试",
      "testOff": "关闭 — 使用我自己的角色",
      "testOnNote": "正在以 {{role}} 身份测试：所执行的每一步都会记录为“(test as {{role}})”。仅在现金报告邮件暂停期间可用。",
      "testOffNote": "建设期间：可扮演编制人或审核人，将一份报告走完两个步骤。",
      "logSim": "模拟",
      "logSimWhy": "由“按此时刻运行”在所选时刻生成，不会占用当天真实的通知。",
      "s_base_currency": "基准币种",
      "s_rate_source": "汇率来源",
      "s_rate_date": "汇率日期",
      "state_clean": "生效中",
      "state_draft": "草稿 — 未发送",
      "state_submitted": "等待 Group CFO",
      "bandClean": "这些标签页上的所有内容均已批准并生效。",
      "bandEmpty": "尚无任何内容获批。请先导入设置工作簿，然后发送给 Group CFO。",
      "bandCounts": "{{insert}} 项新增 · {{update}} 项变更 · {{delete}} 项移除 — 须经 Group CFO 批准后生效",
      "sentBy": "由 {{by}} 于 {{at}} 发送",
      "returned": "由 {{by}} 于 {{at}} 退回：",
      "bootstrap": "用户清单中尚无已批准的行，由于您是门户管理员，您目前以现金报告管理员身份操作。第一份清单获批后即结束。",
      "provisional": "尚无任何内容获批，因此您以拟定用户清单赋予您的角色（{{roles}}）查看此页。Group CFO 批准清单后即正式生效。",
      "import": "导入 Excel",
      "send": "发送给 Group CFO",
      "approve": "批准",
      "notePh": "给 Group CFO 的备注（可选）",
      "fixFirst": "有数据检查错误的行须先修正才能发送。",
      "sent": "已发送给 Group CFO。获批前不会有任何变化。",
      "approved": "已批准 — 更改现已生效。",
      "rejected": "已连同您的理由退回给管理员。",
      "imported": "已导入：新增 {{insert}}，变更 {{update}}，{{same}} 项已相同。这些更改在草稿中，尚未生效。",
      "sumErrors_one": "{{count}} 行有数据检查错误",
      "sumErrors_other": "{{count}} 行有数据检查错误",
      "sumWarns_one": "{{count}} 行有警告",
      "sumWarns_other": "{{count}} 行有警告",
      "onlyIssues": "仅显示有数据检查提示的行",
      "onlyChanged": "仅显示已更改的行",
      "rows_one": "{{count}} 行",
      "rows_other": "{{count}} 行",
      "search": "搜索…",
      "clear": "清除",
      "addRow": "添加一行",
      "save": "保存",
      "cancel": "取消",
      "edit": "编辑",
      "remove": "移除",
      "undo": "撤销此更改",
      "was": "已批准的值",
      "choose": "请选择…",
      "auto": "保存时生成",
      "autoHint": "新行的代码由门户生成（Entity-01、EC-0001、N-001…），且永不重复使用。",
      "dataCheck": "数据检查",
      "chkOk": "正常",
      "chkError": "错误",
      "chkWarn": "警告",
      "op_insert": "新增",
      "op_update": "变更",
      "op_delete": "待移除",
      "noRows": "无数据行。",
      "yes": "是",
      "no": "否",
      "week": "周",
      "allWeeks": "全部周",
      "year": "年",
      "addYear": "添加全年各周",
      "addWeeks": "添加周",
      "weeksAdded": "已将 {{year}} 年的 {{count}} 周添加到草稿。",
      "fxHint": "汇率 = 每 1 单位该币种对应的基准币种数量，因此 SGD 金额 = 外币金额 × 汇率。每周一个汇率；Template 1 读取其所在周的汇率。",
      "newCurrency": "例如 CHF",
      "addCurrency": "添加币种",
      "editRates": "编辑汇率",
      "saveRates": "保存 {{count}} 个单元格",
      "fxSync": "从 NetSuite 同步",
      "fxSyncTitle": "从 NetSuite 读取每周五的汇率。这些汇率直接生效，无需 Group CFO 审批；在此手动输入的汇率保持不变。",
      "fxLastSync": "NetSuite 最近汇率：{{when}}",
      "fxNeverSynced": "尚未从 NetSuite 同步",
      "fxSynced": "NetSuite：已写入 {{written}} 个汇率，{{unchanged}} 个已是最新，共 {{weeks}} 周。",
      "fxKeptTyped": "在设置中输入的 {{n}} 个汇率保持不变 ({{list}})。",
      "fxMissing": "NetSuite 中有 {{n}} 项没有汇率 ({{list}})。",
      "fxFromNetsuite": "来自 NetSuite — {{day}} 的汇率",
      "fxBase": "基准货币",
      "fxTyped": "在设置中输入并已批准 — NetSuite 同步不会更改此汇率",
      "flowReport": "报告",
      "step": "第 {{n}} 步",
      "rep_weekly": "每周现金报告",
      "rep_13w": "13 周现金计划",
      "rep_month": "月末对账",
      "rep_setup": "设置",
      "flowPrep": "编制人：编制",
      "flowReview": "审核人：审核并同意",
      "flowCfo": "Group CFO：批准",
      "flowCeo": "CEO：批准并关闭",
      "flowAdmin": "管理员：完成设置",
      "flowNote": "三个报告都遵循此流程（财务 › 现金报告：每周现金报告、13 周现金计划、月末对账）— 审核人的同意是最后一步，同意后报告会显示在现金报告中。通知标签页说明发送什么、发给谁以及何时发送 — 定时通知设定发送日期和时间，由步骤触发的通知设为“事件”— 通知日志则显示所有已生成的邮件。",
      "noChanges": "没有待处理的更改。",
      "list": "列表",
      "code": "代码",
      "change": "更改",
      "what": "更改内容",
      "by": "操作人",
      "noHistory": "尚无已批准的更改。",
      "histLine": "{{n}} 项更改 · {{by}} 于 {{at}} 发送 · {{cfo}} 于 {{on}} 批准",
      "histBuild": "{{n}} 项更改 · {{by}} 于 {{on}} 为开发而应用 — 未经 Group CFO 批准"
    },
    "cashr": {
      "title": "现金报告",
      "reviewedOnly": "只有经审核人同意的报告才会在此显示数据。"
    },
    "cashw": {
      "h_balance": "余额（{{ccy}}）",
      "h_balanceOrig": "余额（账户币种）",
      "h_amountIn": "金额（{{ccy}}）",
      "baseLabel": "显示币种",
      "baseWhy": "所有金额均按 Set up 中当周汇率（NetSuite，周五）由 SGD 换算；账户本身的余额保留其原币种。",
      "baseRate": "按 Set up 中当周汇率：1 {{ccy}} = {{rate}} SGD。",
      "noBaseRate": "Set up 中尚无本周 {{ccy}} 汇率——以 SGD 显示。",
      "balanceWhy": "查看各银行账户的现金",
      "balanceNote": "余额 = 周末银行持有的现金。可用 = 余额 − 受限 − 定期存款。账户余额按其原币种显示，与银行对账单一致；其他金额按 Set up 中当周汇率（NetSuite）换算。变动按两周均已报告的法人计算。",
      "tot_balance": "余额",
      "title": "现金报告 · 每周",
      "sub": "各法人实体在提交页面导入当周的 Template 1；报告随后按 编制人 → 审核人 流转，审核人同意后显示在此。此处所有数字均以 SGD 计，由门户根据录入的内容计算。",
      "prevWeek": "上一周",
      "nextWeek": "下一周",
      "weekLine": "周结束于 {{end}} · 报告截止 {{due}}",
      "closedWeek": "已关闭",
      "noRates": "设置中尚无本周汇率 — 周五汇率发布后将从 NetSuite 获取。在此之前，数据无法以 SGD 显示，也无法发送报告。",
      "h_entity": "法人实体",
      "h_opening": "期初",
      "h_inflow": "流入",
      "h_outflow": "流出",
      "h_closing": "期末",
      "h_restricted": "受限",
      "h_fd": "定期存款",
      "h_available": "可用",
      "h_change": "较上周变化",
      "h_belowMin": "低于最低余额",
      "h_status": "状态",
      "h_no": "序号",
      "h_category": "类别",
      "h_memo": "备注",
      "h_amount": "金额 (SGD)",
      "h_account": "账户",
      "h_ccy": "币种",
      "h_closingStmt": "期末（对账单）",
      "h_diff": "差额",
      "h_rate": "兑 SGD 汇率",
      "h_closingSgd": "期末 (SGD)",
      "h_files": "文件",
      "h_kind": "类型",
      "h_other": "对方法人实体",
      "h_ref": "参考",
      "groupNote": "不含法人实体之间的相互交易",
      "groupCount": "{{of}} 个法人实体中已审核 {{n}} 个",
      "unmatched": "关联公司交易未抵销：{{amt}} SGD",
      "unmatchedWhy": "各法人实体报告的相互收款与相互付款之和不为零 — 一方尚未报告，或款项仍在途中。期末是银行实际持有的现金，因此与 期初 + 流入 − 流出 恰好相差此金额。",
      "nothingYet": "本周尚无法人实体上传。",
      "yearTitle": "{{year}} 年的每一周",
      "yearPick": "年份",
      "h_weekEntity": "法人实体 / 账户",
      "h_bank": "银行",
      "h_acctNo": "账号",
      "h_acctType": "账户类型",
      "h_acctFlag": "受限 / 定期存款",
      "weekTitle": "周 {{code}} · 结束于 {{end}}",
      "weekOpenWhy": "展开或收起本周的法人实体",
      "weekPickWhy": "将此周设为当前显示周 — 其图表、Top 3 和报告",
      "weekNothing": "无报告",
      "yearLoading": "正在加载全年其余各周…",
      "yearNote": "全年每周一行 GROUP；点击 ▸ 展开该周的法人实体，点击法人实体的 ▸ 查看其账户，点击周代码可将其设为当前显示周。",
      "origClosing": "以 {{ccy}} 计的期末：{{amt}}",
      "inCcy": "以 {{ccy}} 计",
      "origWhy": "以 {{ccy}} 计（账户本身的币种），与银行对账单一致。",
      "notUploaded": "尚未上传。",
      "notReviewed": "尚未审核 — 审核人同意后显示数据。",
      "expandWhy": "查看各银行账户的现金",
      "errorsN_one": "{{count}} 个 Data Check 错误",
      "errorsN_other": "{{count}} 个 Data Check 错误",
      "below": "不足",
      "belowWhy": "可用现金低于为该法人实体设置的最低余额 {{min}} SGD。",
      "noMinWhy": "设置中未为该法人实体设定最低余额。",
      "interGroup": "关联公司交易",
      "interGroupWhy": "与其他 Helinox 法人实体的交易 — 不计入 GROUP 行。",
      "restrictedTag": "受限",
      "fdTag": "定期存款",
      "noTxn": "无交易",
      "sgdNote": "SGD = 账户本币金额 × 设置中的当周汇率 (NetSuite)。账户以本币计的期末余额显示在其所在行。流入和流出不含法人内部转账；可用 = 期末 − 受限 − 定期存款。",
      "topTitle": "Top 3",
      "top_spend": "本周 Top 3 主要支出",
      "top_payable": "下周 Top 3 应付款",
      "noTops": "本周尚无法人实体报告",
      "expandAll": "全部展开",
      "collapseAll": "全部收起",
      "st_none": "未上传",
      "st_open": "已编制 — 未发送",
      "st_returned": "已退回",
      "st_submitted": "审核人审核中",
      "st_reviewed": "已同意",
      "st_approved": "已批准",
      "st_closed": "已关闭",
      "by_submitted": "{{by}} 于 {{at}} 发送",
      "by_reviewed": "{{by}} 于 {{at}} 审核",
      "by_approved": "{{by}} 于 {{at}} 批准",
      "by_closed": "{{by}} 于 {{at}} 关闭",
      "by_returned": "{{by}} 于 {{at}} 退回",
      "weekEnding": "周结束于 {{d}}",
      "step_prep": "编制人",
      "step_review": "审核人",
      "step_cfo": "Group CFO",
      "step_ceo": "CEO",
      "notYet": "尚未",
      "returnedBy": "{{by}} 于 {{at}} 退回：",
      "weekClosed": "该周已在设置中关闭 — 报告只能查看，不能上传。",
      "weekClosedReturned": "该周已在设置中关闭，但被退回的报告仍可修改并重新发送。",
      "selfBlocked": "您上传了此版本或已处理过该报告的前一步骤，因此“{{step}}”须由其他人处理。",
      "tooBig": "单个文件最大 3.5 MB。请将银行对账单另存为更小的 PDF，或分多次附加。",
      "changeOver_one": "基于两周均已报告的 {{count}} 个法人实体",
      "changeOver_other": "基于两周均已报告的 {{count}} 个法人实体",
      "template": "下载模板",
      "upload": "导入文件",
      "uploadAgain": "重新导入",
      "notePh": "给审核人的备注（可选）",
      "submit": "发送给审核人",
      "fixFirst": "发送前请先修正 Data Check 错误。",
      "btn_review": "审核并同意",
      "btn_approve": "批准",
      "btn_close": "批准并关闭",
      "sendBack": "退回",
      "reopen": "重新打开以修改",
      "reopenWhy": "已同意。重新打开会连同您的理由退回给编制人；在再次同意之前，其数据将从现金报告中移除。",
      "done_submit": "已发送给审核人。",
      "done_review": "已审核并同意 — 现已显示在现金报告中。",
      "done_approve": "已批准 — 现由 CEO 处理。",
      "done_close": "已批准并关闭。",
      "done_return": "已连同您的理由退回给编制人。",
      "mailHeld": "（未发送邮件：模块开发期间，现金报告邮件暂缓发送。）",
      "uploadedOk": "已导入版本 {{v}}。",
      "replacedOk": "已导入版本 {{v}} — 已通过 Data Check，并替换审核人处的版本 {{old}}。",
      "correctWhileReview": "审核人审核中 (版本 {{v}})。您仍可在下方直接修改，或导入修改后的文件：保存后若通过 Data Check，将替换审核人正在查看的版本。",
      "uploadedErrors_one": "已上传版本 {{v}} — 发送前需修正 {{count}} 个 Data Check 错误。",
      "uploadedErrors_other": "已上传版本 {{v}} — 发送前需修正 {{count}} 个 Data Check 错误。",
      "nothingUploaded": "尚未录入任何内容。",
      "sumErrors_one": "{{count}} 个 Data Check 错误",
      "sumErrors_other": "{{count}} 个 Data Check 错误",
      "sumWarns_one": "{{count}} 个警告",
      "sumWarns_other": "{{count}} 个警告",
      "versionLine": "正在显示版本 {{v}}",
      "accountsTitle": "账户",
      "transfersTitle": "转账",
      "filesTitle": "银行对账单和截图",
      "versionsTitle": "版本 — 导入或录入",
      "historyTitle": "历史记录与评论",
      "current": "流程中",
      "rateFrom_setup": "来自设置的汇率",
      "rateFrom_base": "基准货币",
      "tot_opening": "期初",
      "tot_inflow": "流入",
      "tot_outflow": "流出",
      "tot_closing": "期末",
      "tot_restricted": "受限",
      "tot_fixed_deposit": "定期存款",
      "tot_available": "可用",
      "tr_internal": "法人内部",
      "tr_group": "关联公司",
      "kind_statement": "对账单",
      "kind_balance": "余额截图",
      "kind_other": "其他",
      "wholeEntity": "整个法人实体",
      "attach": "附加文件",
      "attached": "文件已附加。",
      "removeFile": "删除此文件",
      "noFiles": "没有附件。",
      "commentPh": "写评论…",
      "comment": "评论",
      "noEvents": "尚无任何记录。",
      "waitingYou": "等待您处理",
      "waitingOpen": "在审批中打开以作决定",
      "ev_upload": "从文件导入了版本 {{v}}",
      "ev_entry": "保存了版本 {{v}}（在门户上修改）",
      "changesAgainst": "与版本 {{v}} 相比的更改 — {{n}} 项",
      "noChange": "与版本 {{v}} 相比没有数字变化。",
      "moreChanges": "再显示 {{n}} 项",
      "fewerChanges": "收起",
      "changesCut": "…另有 {{n}} 项。",
      "ev_discard": "取消了版本 {{v}}",
      "cancelled": "已取消",
      "ev_submit": "将版本 {{v}} 发送给审核人",
      "ev_review": "审核并同意",
      "ev_approve": "批准了",
      "ev_close": "批准并关闭了",
      "ev_return": "退回了",
      "ev_comment": "发表了评论",
      "ev_file": "附加了一个文件",
      "ev_unfile": "删除了一个文件"
    },
    "cashp": {
      "title": "现金报告 · 13 周现金计划",
      "sub": "各法人实体以 SGD 编制未来 13 周的计划 (Template 2)，并与其随后各周现金报告中的数据对比。每周编制一份新计划；与周报相同的两个步骤。",
      "startsLine": "从 {{week}} 开始的计划 (周结束于 {{end}})，至 {{last}}",
      "h_week": "周次",
      "h_end": "周末日期",
      "h_planOpen": "期初（上期期末）",
      "h_planIn": "计划流入",
      "h_planOut": "计划流出",
      "h_planClose": "计划期末（预计）",
      "h_actIn": "实际流入",
      "h_actOut": "实际流出",
      "h_actClose": "实际期末",
      "h_variance": "与计划差异（期末）",
      "h_weekly": "周报",
      "h_reported": "已报告",
      "h_comment": "评论",
      "h_planClose13": "计划期末，第 13 周",
      "h_planOpen1": "期初，第 1 周",
      "h_planIn13": "计划流入，13 周",
      "h_planOut13": "计划流出，13 周",
      "noReviewed": "尚无已审核的计划",
      "reportedOf": "已报告 {{n}}",
      "noPlan": "尚无法人实体上传从本周开始的计划。",
      "openWhy": "展开或收起全年计划",
      "groupPlanned": "已审核计划：{{of}} 个法人实体中的 {{n}} 个",
      "listHint": "各法人实体本周计划的进展情况。上方的图表和表格随所选内容变化。",
      "pickLabel": "显示",
      "pickGroup": "GROUP（所有法人实体）",
      "pickGroupWhy": "所有法人实体合计",
      "filtersTitle": "筛选计划",
      "filterEntities": "法人实体",
      "filtersHint": "选择 GROUP、一个或多个法人实体（多个时合计），然后选择年份。下方的图表和 53 周表格随两者变化。",
      "oneYear": "目前计划仅涵盖一年",
      "weeksShown": "{{of}} 周中的 {{count}} 周",
      "h_planFrom": "来源计划",
      "planFromWhy": "取自从 {{week}} 开始的计划 — 涵盖本周的最新计划",
      "plannedBy_one": "{{count}} 个法人实体",
      "plannedBy_other": "{{count}} 个法人实体",
      "yearOf": "{{year}} 年的每一周",
      "yearNote": "全年每一周。每周数据取自涵盖该周的最新计划 — 已过去的周取自为该周提交的计划，未来的周取自最新的预测 —“来源计划”列显示所用的计划。",
      "groupTitle_one": "GROUP — {{count}} 个法人实体已编制计划",
      "groupTitle_other": "GROUP — 本周已编制计划的 {{n}} 个法人实体合计",
      "groupNote": "GROUP 为本周已编制计划的法人实体之和。只有当这些法人实体全部报告了该周，实际数才会计入，因此差异绝不会用部分法人实体的实际数去对比全部法人实体的计划。",
      "entityNote": "实际数为每周现金报告本身以 SGD 计的数据（流入和流出不含法人内部转账，期末 = 各银行的期末余额）。差异 = 实际期末 − 计划期末。",
      "panelHeading": "从 {{week}} 开始的计划",
      "opening": "期初现金 (SGD)",
      "closing13": "计划期末，第 13 周 (SGD)"
    },
    "cashm": {
      "title": "现金报告 · 月末对账",
      "sub": "各法人实体在月末对每个账户进行对账 (Template 3)：将月度银行对账单上的期末余额与每周现金报告中的周末期末余额（月末当天或之前的最后一个周末日期）对比，并核对两个日期之间的变动。对账 = 差异 − 流入 + 流出，且必须为 0。与周报相同的两个步骤。",
      "monthLine": "{{month}} · 月末 {{end}}",
      "open": "可对账",
      "notEnded": "尚未结束",
      "notEndedLine": "本月尚未结束 — 月份结束后才能开始对账。",
      "ruleHead": "周末基准：{{week}} ({{end}})。",
      "h_reconciled": "已对账账户",
      "h_totalSgd": "月末期末余额 (SGD)",
      "h_monthEnd": "月末余额",
      "h_weekEnd": "周末余额 ({{week}})",
      "h_variance": "差异",
      "netOff": "抵销",
      "statusGroup": "状态",
      "h_netIn": "抵销流入",
      "h_netOut": "抵销流出",
      "h_reconcile": "对账",
      "accountsTitle": "账户",
      "reconciled": "已对账账户",
      "totalSgd": "月末期末余额 (SGD)",
      "unconvertedWhy": "设置中周末日期没有汇率的账户不计入 SGD 合计。",
      "monthEndOn": "月末 {{d}}",
      "st_submitted": "已编制",
      "st_reviewed": "已审核",
      "st_approved": "已批准",
      "st_closed": "已关闭",
      "unconverted": "{{n}} 个无汇率",
      "allReconciled": "全部 {{n}} 个已对账",
      "reportNote": "每个法人实体行显示其以 SGD 计的月末余额，以及编制和审核该对账的人员；其账户列在下方，以各自币种显示。点击法人实体可打开其对账。"
    },
    "cashq": {
      "title": "审批",
      "sub": "编制人已发送的报告，涵盖每周现金报告、13 周现金计划和月末对账。选择一份报告查看，然后同意或退回。审核人同意后，报告会显示在现金报告中。被退回的报告会留在“处理中”，直到重新发送。",
      "tab_waiting": "等待您处理",
      "tab_progress": "处理中",
      "tab_closed": "已同意",
      "rows_one": "{{count}} 份报告",
      "rows_other": "{{count}} 份报告",
      "clear": "清除排序和筛选",
      "colReport": "报告",
      "colEntity": "法人实体",
      "colPeriod": "期间",
      "colStatus": "状态",
      "colSentBy": "发送人",
      "colSentAt": "发送日期",
      "colUpdated": "最近更改",
      "empty_waiting": "没有等待您决定的内容。",
      "empty_progress": "没有正在流转或已退回给编制人的报告。",
      "empty_closed": "尚无已同意的报告。",
      "notListed": "该报告不在您的待办列表中 — 可能尚未发送，或您无权查看。"
    },
    "cashi": {
      "title": "提交",
      "sub": "下载本法人实体的各个模板，填写、导入、检查后发送给审核人。",
      "entity": "法人实体",
      "yoursOne": "您的法人实体，来自设置中的用户列表。",
      "yoursMany": "您是 {{n}} 个法人实体的编制人 — 请选择要录入的法人实体。",
      "notPreparer": "您不是现金报告用户列表中任何法人实体的编制人，因此此处只能查看和下载，不能导入。编制人在 设置 › 用户 中指定。",
      "noEntity": "没有可显示的法人实体。",
      "checkPassed": "已通过 Data Check",
      "saveOrCancel": "请先保存或取消更改，再导入。",
      "openReport": "打开 {{report}}",
      "pointer": "此报告在提交页面导入并发送 ({{tpl}})。",
      "pointerReturned": "已退回给编制人 — 需在提交页面修改后重新发送。",
      "goImport": "打开提交",
      "pointerDecide": "此报告正在等待您的决定 — 请在审批中同意或退回。",
      "nothingYet": "尚未录入 — 由该法人实体的编制人在提交页面导入 {{tpl}}。"
    },
    "cashc": {
      "byEntity": "各法人实体现金 ({{ccy}})",
      "byEntitySub": "期末拆分为可用、受限和定期存款 — 本周 {{of}} 个法人实体中已审核 {{n}} 个。",
      "trend": "GROUP 现金，最近 12 周 ({{ccy}})",
      "trendSub": "每周已报告法人实体的余额和可用现金 — 空缺表示该周无人报告。",
      "reported": "{{of}} 个中已报告 {{n}} 个",
      "noneYet": "尚无法人实体报告。",
      "noTrend": "此范围内尚无任何一周有报告。",
      "planTitle": "计划 — {{who}} (SGD)",
      "planSub": "计划流入向上，计划流出向下；虚线为计划期末，实线为每周现金报告中的实际期末。",
      "monthCash": "各法人实体月末现金 (SGD)",
      "monthCashSub": "本月 {{of}} 个法人实体中已有 {{n}} 个报告。",
      "noRateAll": "设置中录入 {{week}} 的汇率后将以 SGD 显示 — 已报告的账户暂时都无法换算。",
      "noRateSome": "未绘制 — {{week}} 尚无汇率：{{list}}。",
      "recon": "已对账账户",
      "reconSub": "按法人实体：对账为 0 的账户，以及有差异的账户。",
      "reconciled": "已对账",
      "difference": "有差异",
      "accounts_one": "{{count}} 个账户",
      "accounts_other": "{{count}} 个账户"
    },
    "cashf": {
      "inputTitle": "录入 — {{tpl}}",
      "enterHere": "在门户上录入",
      "editHere": "在门户上编辑",
      "inputClosed": "只有该法人实体的编制人可在报告处于打开或退回状态时导入此报告。",
      "field1": "Field 1 — 法人实体实际现金流 (SGD)",
      "field2": "Field 2 — 法人实体账户：所有交易合计",
      "field3": "Field 3 — 法人内部转账（法人实体自身账户之间）",
      "field4": "Field 4 — 关联公司交易（与其他 Helinox 法人实体）",
      "field5": "Field 5 — 本周 Top 3 主要支出",
      "field6": "Field 6 — 下周 Top 3 应付款",
      "f1Entity": "法人实体",
      "f1Overall": "总体",
      "f1Group": "关联公司交易",
      "f1NoRate": "当所有账户币种在 设置 › 汇率 中都有本周汇率时，Field 1 才会以 SGD 计算。",
      "h_rate": "汇率",
      "h_noTxn": "确认无交易",
      "h_restrictedAcct": "受限账户",
      "h_fdAcct": "定期存款",
      "h_upStatement": "上传对账单",
      "h_upBalance": "上传余额截图",
      "h_entity": "法人实体",
      "h_no": "序号",
      "h_category": "类别",
      "h_memo": "备注",
      "h_amountSgd": "金额 (SGD)",
      "fromSetup": "取自设置中的账户类型",
      "rateFromSetup": "设置中的本周汇率",
      "rateMissing": "设置 › 汇率 (从 NetSuite 同步) 中没有本周的 {{ccy}} 汇率 — 不能在此手动输入",
      "closingCalc": "期末 = 期初 + 流入 − 流出",
      "closingFiled": "导入的文件中期末为 {{v}} — 期初 + 流入 − 流出 得出的是所显示的数字。在此保存将保留计算所得的数字。",
      "closingDiff": "期初 + 流入 − 流出 与此期末相差 {{d}}",
      "memoPh": "说明是什么 — 长短不限",
      "f4None": "本周无关联公司交易。",
      "rateOpt": "兑 SGD 汇率（可选）",
      "noTxn": "无交易",
      "check": "检查",
      "ok": "OK",
      "diff": "差额 {{d}}",
      "notNumber": "不是数字",
      "noTxnAmounts": "标记为无交易，但填写了金额",
      "upStatement": "对账单",
      "upBalance": "余额",
      "addRow": "添加一行",
      "removeRow": "删除此行",
      "save": "另存为新版本",
      "cancel": "取消编辑",
      "cancelImport": "取消导入",
      "cancelBack": "移除版本 {{v}}，并将报告恢复到版本 {{back}}。",
      "cancelEmpty": "移除版本 {{v}} — 报告恢复为空，可重新导入。",
      "discardedBack": "已取消版本 {{v}} — 已恢复到版本 {{back}}。",
      "discardedEmpty": "已取消版本 {{v}} — 报告已再次清空。",
      "noChanges": "尚无更改 — 请修改数字或导入文件。",
      "saveHint": "保存将创建新版本并重新运行 Data Check。",
      "payrollRule": "工资只填一个总额。切勿输入员工姓名或个人工资。",
      "savedOk": "已保存版本 {{v}}。",
      "savedReplaced": "已保存版本 {{v}} — 已通过 Data Check，并替换审核人处的版本 {{old}}。",
      "savedErrors_one": "已保存版本 {{v}} — 发送前需修正 {{count}} 个 Data Check 错误。",
      "savedErrors_other": "已保存版本 {{v}} — 发送前需修正 {{count}} 个 Data Check 错误。",
      "openingFrom": "第一周的上期期末取自您 {{week}} 每周现金报告的期末 — 仅在有误时修改。",
      "prepareDate": "编制日期",
      "entityGroup": "法人实体 / 集团",
      "entityLabel": "法人实体",
      "currency": "币种",
      "currencySgd": "SGD — 本模板中的所有数字",
      "planCloseExp": "计划期末（预计）",
      "prevWeek": "上周",
      "thisWeek": "本周",
      "openingNone": "上一周没有每周现金报告 — 请输入期初现金。"
    },
    "gtm": {
      "title": "GTM 方案",
      "subtitle": "按照七个问题编写方案并提交审核。审批人在 GTM › 审批 中作出决定。",
      "newProgramme": "新建方案",
      "createTitle": "创建方案",
      "nameLabel": "标题",
      "namePlaceholder": "例如：Sunset Chair (re) Home · Book Reading Edition",
      "create": "创建",
      "cancel": "取消",
      "back": "所有方案",
      "none": "暂无方案。",
      "openDecisions": "待决策",
      "openVerifies": "待核实",
      "regionsWaiting": "等待回复的区域",
      "committed": "已承诺数量",
      "ofTarget": "目标 {{n}}",
      "editProgramme": "编辑方案",
      "headline": "一句话概述",
      "openItem": "未决事项",
      "openItems": "决策、工作与核查",
      "noItems": "此问题下暂无内容。",
      "lineTitle": "是什么",
      "lineDetail": "详情",
      "inThisProgrammeHint": "为什么列入，或为什么不列入 — 表格中显示在旁边的说明。",
      "discardAsk": "放弃已输入的内容？",
      "needed": "仍需填写：{{fields}}",
      "editTable": "编辑表格",
      "editTableWhy": "解锁表格，修改任意多行，然后一次保存",
      "editTableHint": "随意输入 — 保存前不会写入任何内容，且一次性保存：要么全部写入，要么什么都不变。",
      "saveTable": "保存表格",
      "saveTableN": "保存表格 ({{n}})",
      "layerHead": "销售渠道之上的推进环节",
      "stage": "阶段",
      "role": "角色",
      "condition": "条件",
      "addStage": "添加阶段",
      "orderHead": "顺序",
      "orderLabel": "各事项发生的顺序",
      "step": "步骤",
      "stepDetail": "内容",
      "addStep": "添加步骤",
      "savedN": "已保存 {{n}} 项更改。",
      "savedNothing": "没有任何更改。",
      "regionsHint": "此方案涵盖的区域，按优先顺序排列 — 拖动行或使用箭头进行调整。",
      "sheetLocked": "点击“编辑”以修改此页上的任何内容。",
      "sheetOpen": "页面已打开 — 可随意输入。点击“保存”前不会写入任何内容。移动行会即时保存。",
      "acrossProgramme": "整个方案",
      "qOpenCount": "{{n}} 项未决",
      "removeYes": "移除",
      "waitingOnYou": "等待您的决定",
      "rev_draft": "未提交审核",
      "rev_in_review": "审批人处理中",
      "rev_approved": "已批准",
      "rev_rejected": "已驳回",
      "approver": "审批人",
      "sentForReview": "已提交审核",
      "approvedOn": "已批准",
      "rejectedOn": "已驳回",
      "sendForReview": "提交审核",
      "reviewAgain": "重新提交审核",
      "approve": "批准",
      "resubmit": "重新提交",
      "sent": "已发送",
      "view": "查看",
      "kpiAll": "所有方案",
      "kpiMine": "我的方案",
      "scopeMine": "我的方案",
      "scopeAll": "所有方案",
      "noneMine": "您还没有方案 — 没有由您创建、发送或负责的方案。",
      "showAll_one": "显示这 {{count}} 个方案",
      "showAll_other": "显示全部 {{count}} 个方案",
      "backApproval": "GTM 审批",
      "approvalTitle": "GTM 审批",
      "approvalSub": "发送给您决定的方案。草稿保留在作者处，不会出现在这里。",
      "approvalSubAdmin": "已提交待决定的方案。作为管理员，您可看到所有审批人的待办；草稿不会出现在这里。",
      "tabWaiting": "待决定",
      "tabApproved": "已批准",
      "tabRejected": "已驳回",
      "emptyQueue_in_review": "没有等待您决定的内容。",
      "emptyQueue_approved": "尚无已批准的内容。",
      "emptyQueue_rejected": "没有已驳回的内容。",
      "colSentBy": "发送人",
      "colSentOn": "发送日期",
      "colDecidedOn": "决定日期",
      "colCreatedBy": "创建人",
      "colCreatedAt": "创建时间",
      "colUpdatedBy": "更新人",
      "colUpdatedAt": "更新时间",
      "colManagerNote": "经理备注",
      "colSkus": "项目 SKU",
      "skuHead": "已关联的项目 SKU",
      "skuHint": "在此方案下上市的项目 SKU。同一关联即项目跟踪中每个 SKU 上的 GTM 字段。",
      "skuNone": "尚未关联项目 SKU。",
      "skuId": "项目 SKU ID",
      "skuName": "SKU 名称",
      "skuGroup": "项目组",
      "skuStatus": "状态",
      "skuPh": "选择或输入项目 SKU，例如 9048 或 SKU-09048",
      "skuAdd": "关联 SKU",
      "skuUnlink": "取消关联此 SKU",
      "deleteLockedSent": "已提交审核 — 审批人处理期间无法删除。",
      "deleteLockedApproved": "已批准 — 已批准的方案无法删除。",
      "countAll_one": "{{count}} 个方案",
      "countAll_other": "{{count}} 个方案",
      "countOf": "{{total}} 个方案中的 {{n}} 个",
      "searchPh": "搜索代码、标题、负责人…",
      "clear": "清除",
      "noMatch": "没有符合这些筛选条件的方案。",
      "loading": "加载中…",
      "colNo": "序号",
      "colCode": "GTM 编号",
      "colTitle": "方案",
      "colStatus": "状态",
      "colOwner": "负责人",
      "colApprover": "审批人",
      "colLaunch": "上市",
      "colDecisions": "决策",
      "colVerify": "待核实",
      "colRegions": "区域",
      "colAction": "操作",
      "reviewDone_submit": "已提交审核。",
      "reviewDone_approve": "已批准。",
      "reviewDone_reject": "已驳回。",
      "coverEyebrow": "GTM 方案",
      "printedOn": "打印日期",
      "coverStatus": "审核状态",
      "coverDecisionNote": "决定备注",
      "exportPdf": "导出 PDF",
      "delete": "删除",
      "deleteProgramme": "删除此方案",
      "deleteBody": "此操作将删除其下的 {{n}} 行数据和 {{photos}} 张照片。",
      "deleteWarn": "此操作无法撤销。",
      "exporting": "正在导出…",
      "pdf": "PDF",
      "addStop": "添加停止条件",
      "stopKind_manual": "人工跟踪",
      "stopKind_commit_min": "区域承诺数量低于设定值",
      "stopKind_anchor_consent": "主导区域的负责人不同意",
      "stopKindAsk": "Portal 应读取什么？",
      "deleteYes": "删除",
      "measureHead": "如何衡量成功",
      "measureHint": "每项指标是什么，以及怎样算好。",
      "measureItem": "指标",
      "measureWhat": "是什么，如何评判",
      "measurePh": "防守、特别版、常规款…",
      "timelineHead": "时间线 · 负责人",
      "timelineHint": "本计划如何推进，以及每一步由谁负责。",
      "timelineStep": "步骤",
      "timelineStage": "阶段",
      "timelineWho": "具体内容",
      "timelinePh": "指定负责人、决策、发布…",
      "timelineWhen": "预计",
      "timelineNote": "接收人",
      "stopWhere": "当前状况",
      "stopThreshold": "阈值",
      "removeDoc": "仍然删除",
      "removeDocWhy": "此行来自总体规划。重新运行导入会将其恢复。",
      "keepIt": "保留",
      "specHead": "条目与内容",
      "specHint": "发布前必须具备的内容：每个条目及其内容。其他内容请添加一行。",
      "specItem": "条目",
      "specItemPh": "框架、口袋、价格…",
      "specA": "常规款",
      "specB": "特别版",
      "photosHead": "照片",
      "photosHint": "本计划涉及的图片。说明文字标注每张图所指的内容。",
      "discoverHead": "用户如何发现产品",
      "discoverHint": "发布前、发布当天及发布后要做的事。",
      "discoverPh": "内容、种草、邀请…",
      "noLines": "暂无内容。",
      "collapseAll": "全部收起",
      "expandAll": "全部展开",
      "fieldTitle": "标题",
      "stopHead": "停止条件（建议）",
      "stopNone": "尚未设置停止条件。",
      "tripped": "已触发停止条件",
      "holding": "维持中",
      "addLine": "添加一行",
      "lineKind": "类型",
      "persona": "用户画像",
      "channel": "渠道",
      "inThisProgramme": "本计划中",
      "remarks": "备注",
      "select": "选择",
      "selectHint": "勾选某一行，或在下方的添加框中选取，即可选中。已选行的顺序即为优先级——拖动行或使用箭头进行调整。",
      "regionsCount": "本计划中的区域",
      "specContent": "内容",
      "timelineOwner": "负责人",
      "discoverItem": "条目",
      "discoverDetail": "具体内容",
      "trkTitle": "GTM 跟踪",
      "trkSub": "已批准的计划及其进度，按“时间线 · 负责人”中的步骤逐一显示。工作推进时，将步骤标记为进行中或已完成；超过预计日期仍未完成的步骤会被标记为逾期。",
      "trkApproved": "已批准的计划",
      "trkStepsDone": "已完成步骤",
      "trkOverdue": "逾期",
      "trkOnlyOverdue": "仅显示有逾期步骤的计划",
      "trkSearch": "搜索计划、步骤或负责人…",
      "trkToday": "今天：{{day}}",
      "trkNone": "尚无已批准的计划。",
      "trkApprovedBy": "批准人",
      "trkStepsOf": "已完成 {{done}} / {{total}} 步",
      "trkNoSteps": "尚无时间线步骤",
      "trkOverdueN_one": "{{count}} 项逾期",
      "trkOverdueN_other": "{{count}} 项逾期",
      "trkNext": "下一步",
      "trkAllDone": "所有步骤均已完成",
      "trkStatus": "状态",
      "trkDoneOn": "完成日期",
      "trkNoStepsHint": "该计划尚无时间线步骤——请在计划的“时间线 · 负责人”中添加。",
      "st_not_started": "未开始",
      "st_in_progress": "进行中",
      "st_done": "已完成",
      "trkProgress": "进度",
      "trkNextDue": "下一步截止日期",
      "trkApprovedOn": "批准日期",
      "listNew": "新条目：将加入列表，下次可直接选用。",
      "listAllIn": "列表中的所有条目都已在本计划中。请输入新条目。",
      "listDup": "已在本计划中选中。",
      "listHave": "已在本计划中。",
      "listPick": "从列表中选择，或输入新条目",
      "addPersona": "添加用户画像",
      "addChannel": "添加渠道",
      "removeRow": "删除",
      "removeAsk": "删除 \"{{name}}\"？此操作无法撤销。",
      "add": "添加",
      "noteOnTable": "表格备注",
      "noteOnTableHint": "上表无法表达的内容——注意事项，或表中未涵盖的部分。",
      "moveUp": "上移",
      "moveDown": "下移",
      "targetAudience": "已选用户画像——按优先级排序",
      "notATarget": "未选",
      "channelsInUse": "已选渠道——按优先级排序",
      "channelsOut": "未选",
      "chStatus_green": "全公司渠道状态：良好",
      "chStatus_amber": "全公司渠道状态：需关注",
      "chStatus_red": "全公司渠道状态：较弱",
      "notYet": "尚无法判断",
      "unmeasured": "人工跟踪",
      "stopNote": "由计划负责人填写各条件的当前状况。",
      "question": "问题 {{n}}",
      "emptySection": "尚未回答。",
      "oneChange": "已更改 1 个部分",
      "nChanges": "已更改 {{count}} 个部分",
      "discard": "放弃更改",
      "edit": "编辑",
      "save": "保存",
      "decision": "待决策",
      "verify": "待核实",
      "addDecision": "添加决策",
      "addVerify": "添加待核实事项",
      "todo": "待办",
      "addTodo": "添加待办事项",
      "phaseFilter": "发布阶段",
      "allPhases": "所有阶段",
      "phaseHintOne": "仅显示 {{phase}}——{{all}} 个未结事项中有 {{hidden}} 个已隐藏。再次点击该按钮或点击“所有阶段”即可恢复显示。",
      "phaseWhy_all": "计划中与某个时间点相关的所有事项",
      "phaseWhy_before": "Q5——开工前必须具备的内容，以及仍待决定的事项",
      "phaseWhy_pre": "Q6——发布前：发布日之前",
      "phaseWhy_launch": "Q6——发布：发布当天",
      "phaseWhy_post": "Q6——发布后：产品上市之后",
      "workNone": "暂无事项。",
      "phase_before": "开工前",
      "phase_pre": "发布前",
      "phase_launch": "发布",
      "phase_post": "发布后",
      "noPhase": "无阶段",
      "owner": "负责人",
      "noOwner": "无负责人",
      "due": "截止",
      "noDue": "无日期",
      "answer": "答复",
      "answered": "已答复",
      "dropped": "已放弃",
      "open": "未结",
      "remove": "删除",
      "regionsHead": "区域",
      "region": "区域",
      "person": "联系人",
      "replyStatus": "回复",
      "consent": "授权",
      "commitQty": "承诺量",
      "replyDue": "回复截止",
      "anchor": "主导",
      "note": "备注",
      "addRegion": "添加区域",
      "metricsHead": "如何衡量成功",
      "metric": "指标",
      "baseline": "基线",
      "baselineWindow": "时间窗口",
      "live": "此后",
      "takeBaseline": "获取基线",
      "retakeBaseline": "重新获取",
      "baselineTaken": "已于 {{when}} 获取",
      "baselineNotTaken": "未获取",
      "manualMetric": "手动输入",
      "baselineWhy": "在获取当天固定。Shopify 订单可能在数月后退款，若数值会自行重算，作为比较基准的数字就会随之变动。",
      "units": "件",
      "sourceDoc": "源文档",
      "status": "状态",
      "launchTarget": "发布",
      "notSet": "未设置",
      "saved": "已保存",
      "saveFailed": "保存失败"
    },
    "account": {
      "profile": "个人资料",
      "listUsers": "用户列表",
      "createUser": "创建用户",
      "accessRequests": "访问申请",
      "rolesPermissions": "角色与权限",
      "portalInsights": "Portal 使用分析",
      "masterData": "主数据",
      "activityLog": "操作日志",
      "logout": "退出登录"
    },
    "quote": {
      "label": "每日一句"
    },
    "doc": {
      "title": "文档库",
      "subtitle": "公司文档——在此阅读，或下载标有版本号的副本。最新版本始终在门户中。",
      "folders": "文件夹",
      "allDocs": "全部文档",
      "unfiled": "未归档",
      "newFolder": "新建文件夹",
      "newFolderIn": "在 {{name}} 中新建文件夹",
      "folderName": "文件夹名称",
      "renameFolder": "重命名",
      "deleteFolder": "删除",
      "deleteFolderAsk": "删除文件夹 \"{{name}}\"？其中的文档不会被删除。",
      "folderField": "文件夹",
      "folderNone": "未归档",
      "folderSaved": "文件夹已保存。",
      "search": "搜索标题或编号…",
      "upload": "上传",
      "refresh": "刷新",
      "none": "尚无与您共享的文档。",
      "noMatch": "没有匹配的结果。",
      "unread": "未读",
      "acknowledged": "已读",
      "code": "编号",
      "docTitle": "标题",
      "version": "版本",
      "updated": "更新时间",
      "status": "状态",
      "changeNote": "变更内容",
      "uploadedBy": "上传人",
      "author": "作者",
      "authorNone": "— 未注明 —",
      "versionAuthor": "此版本作者",
      "authorSame": "— 与上一版本相同 —",
      "byAuthor": "作者 {{name}}",
      "authorHint": "撰写人，与上传人不一定相同。",
      "newDoc": "新建文档",
      "newVersion": "上传新版本",
      "addingVersionTo": "正在添加新版本至",
      "findDocPh": "输入编号或标题——HB-0001、手册…",
      "findDocNone": "没有与 \"{{q}}\" 匹配的文档。",
      "currentlyAt": "当前为 {{version}}——将添加新版本，旧版本仍可在下方的历史记录中阅读",
      "kind": "类型",
      "codeAuto": "由 Portal 生成",
      "summary": "简短描述",
      "everyone": "所有能打开文档库的人都可阅读",
      "narrowHint": "否则在您共享之前，只有您和其他文档库管理员可以阅读。",
      "file": "文件",
      "fileKinds": "HTML、PDF、PNG、JPEG、Word、PowerPoint 和 Excel（.xlsx）均可在此直接阅读。下载的始终是原始文件。",
      "noPreview": "浏览器无法在页面中显示此类文件。文件连同版本保存在此，下载时使用上传时的文件名。",
      "download": "下载",
      "imgBroken": "无法打开此图片——文件已损坏，或其格式浏览器无法读取。文件仍保存在此，下载时使用上传时的文件名。",
      "versionLabel": "版本",
      "versionAuto": "留空：Portal 将接续上一版本",
      "versionFound": "从文档本身读取：{{version}}",
      "versionNotFound": "文档封面上未找到版本 — 留空即为 v1.0，或自行填写。",
      "changeNoteLabel": "变更内容（一行）",
      "uploading": "上传中…",
      "allDocuments": "全部文档",
      "history": "版本历史",
      "latest": "最新",
      "view": "打开",
      "readingOld": "您正在阅读旧版本——",
      "backToLatest": "返回最新版本",
      "iHaveRead": "我已阅读",
      "recording": "正在记录…",
      "youAcknowledged": "您已确认阅读 {{version}}",
      "noVersion": "尚未上传任何版本。",
      "readers": "阅读情况",
      "readersCount": "{{notified}} 人中 {{opened}} 人已打开 · {{acked}} 人已确认",
      "notified": "已通知",
      "opened": "已打开",
      "confirmed": "已确认",
      "nobody": "尚未通知任何人。",
      "share": "共享",
      "shareLink": "复制链接",
      "linkCopied": "链接已复制",
      "shareByEmail": "通过邮件发送",
      "emails": "邮箱地址",
      "emailsHint": "多个地址请用逗号或空格分隔。",
      "groups": "群组",
      "person": "收件人",
      "groupsNone": "选择群组…",
      "groupsClear": "清除",
      "addGroup": "添加群组",
      "addGroupName": "群组名称",
      "addGroupEmail": "群组邮箱地址",
      "addGroupSave": "加入列表",
      "addGroupHint": "今后所有共享文档的人都会看到此群组。",
      "groupAdded": "\"{{name}}\" 已加入列表。",
      "groupRemoved": "已将 \"{{name}}\" 从列表中删除。",
      "removeGroupConfirm": "将 \"{{name}}\" 从所有人的群组列表中删除？",
      "sharers": "谁可以共享",
      "sharersIntro": "{{code}} 由您上传，因此您可以发送。您在此指定的任何人也可以发送。",
      "sharersIntroAdmin": "{{code}} 由 {{owner}} 上传。您可以以管理员身份发送，在此指定的人也可以发送。",
      "sharersNone": "没有其他人。只有 {{owner}} 和管理员可以发送此文档。",
      "sharersAdd": "添加人员",
      "sharersPick": "选择人员…",
      "sharersFind": "输入姓名或地址…",
      "sharersNoMatch": "没有匹配的人员。",
      "sharersAddN": "授予共享权限 ({{count}})",
      "sharersSaved": "已保存可共享人员。",
      "sharersUploader": "上传人",
      "cannotShare": "只有 {{owner}} 和管理员可以发送此文档。",
      "sendNote": "备注（可选——默认使用变更说明）",
      "send": "发送通知",
      "sending": "发送中…",
      "sentTo": "已发送给 {{count}} 位收件人。",
      "remove": "删除",
      "edit": "编辑",
      "save": "保存",
      "saving": "保存中…",
      "savedMsg": "已保存。",
      "noteOfVersion": "变更说明属于 {{version}}，即当前列表中的版本。",
      "comments": "评论",
      "noComments": "暂无评论。第一个问题往往也是别人想问的。",
      "commentPlaceholder": "就此文档提问，或回复他人…",
      "commentHint": "所有能打开此文档的人都能看到您的评论。按 Ctrl+Enter 发布。",
      "post": "发布",
      "posting": "发布中…",
      "commentGone": "此评论已删除。",
      "deleteComment": "删除",
      "deleteCommentTitle": "删除此评论？",
      "deleteCommentBody": "该评论将对所有人消失。它在对话中的位置会保留，并标记为已删除。",
      "removeTitle": "删除此文档？",
      "removeConfirm": "该文档将从所有人的列表中移除，链接也将无法打开。阅读记录会保留，且该编号永远不会分配给其他文档。",
      "removedMsg": "已将 {{code}} 从文档库中删除。",
      "cancel": "取消",
      "removed": "已删除。"
    },
    "home": {
      "morning": "早上好",
      "afternoon": "下午好",
      "evening": "晚上好",
      "myWork": "我的工作——{{role}}",
      "notLinkedToEmployee": "此 Portal 账号尚未关联员工档案，因此无法匹配您的工作。请联系管理员进行关联。",
      "notLinkedToSalesRep": "此账号尚未关联销售代表，因此无法匹配您的项目。请联系管理员进行关联。",
      "targetLaunch": "目标上市月份",
      "ack": "知道了",
      "ackTitle": "确认您已看到此驳回——它将不再显示在此卡片上",
      "lateThreshold": "逾期标准（天）",
      "saved": "已保存",
      "lateThresholdRange": "1-365",
      "save": "保存",
      "ackUndo": "恢复",
      "seenCount": "已确认 {{n}} 项——显示",
      "viewAs": "查看",
      "allOf": "所有人——{{role}}",
      "viewAll": "所有人",
      "repNoAccount": "未关联账号",
      "openThisList": "在样品跟踪中打开此列表",
      "andMore": "另有 {{n}} 项",
      "workload": {
        "title": "每周工作量",
        "sub": "每周一记录一次——每位负责人当天早上手头的工作",
        "rounds": "进行中的轮次",
        "projects": "进行中的项目",
        "pic": "负责人",
        "change": "较上周",
        "total": "合计",
        "reconstructed": "本周数据并非在当周周一早上统计——而是事后补录的。",
        "cellRounds": "生产中 {{prod}} · 待结果 {{pending}} · 待原料 {{wait}}",
        "note": "进行中的轮次 = 生产中 + 待结果。标有 * 的周并非在当周周一统计——而是事后补录的。"
      },
      "noModules": "您的账号尚未开通任何模块。请联系管理员申请访问权限。"
    },
    "tc": {
      "colNo": "序号",
      "colAction": "操作",
      "stateActive": "启用",
      "stateInactive": "停用",
      "title": "工单代码",
      "subtitle": "工单代码下拉菜单背后的主列表。共 {{n}} 个编码。",
      "readOnly": "——您的角色仅可查看。",
      "newCode": "新建编码",
      "exportExcel": "导出 Excel",
      "searchPh": "搜索编码、名称、阶段、团队…",
      "showInactive": "显示已停用",
      "clearTools": "清除排序和筛选",
      "countOf": "{{n}} / {{total}}",
      "loading": "加载中…",
      "saving": "保存中…",
      "btnEdit": "编辑",
      "btnView": "查看",
      "btnViewHint": "查看此编码（只读）",
      "btnClose": "关闭",
      "formView": "工单代码 {{code}}",
      "viewOnly": "仅查看",
      "btnSave": "保存",
      "btnCancel": "取消",
      "formNew": "新建工单代码",
      "formEdit": "编辑 {{code}}",
      "fCode": "编码",
      "fTeam": "团队",
      "fCase": "情形",
      "fCategory": "类别",
      "fName": "工单名称",
      "fPhase": "阶段",
      "fAssignedTo": "指派给",
      "fGroupEmail": "群组邮箱",
      "fNote": "备注",
      "fActive": "启用——停用的编码仍保留在已使用它的工单上，但不再出现在新建工单表单中",
      "phCase": "A / B / 留空",
      "phName": "样品开发申请",
      "phTeamSearch": "搜索团队…",
      "everyCategory": "所有类别",
      "created": "已创建 {{code}}。",
      "saved": "已保存 {{code}}。",
      "nothingToExport": "没有可导出的内容",
      "preparingExport": "正在准备导出 Excel…",
      "exported": "已导出 {{n}} 个编码",
      "exportFailed": "导出失败",
      "exportInclInactive": "包含已停用编码",
      "exportActiveOnly": "仅启用的编码"
    },
    "pa": {
      "title": "项目审批",
      "subtitle": "新项目在此获得批准前一直处于待处理状态。未获批准的项目无法发起工单。",
      "tabPending": "待处理",
      "tabApproved": "已批准",
      "tabRejected": "已驳回",
      "tabSettings": "设置",
      "loading": "加载中…",
      "saving": "保存中…",
      "working": "处理中…",
      "countAll": "{{n}} 个项目",
      "countOf": "{{n}} / {{total}} 个项目",
      "chartPick": "图表：{{label}} · {{n}} 个项目",
      "chartPickClear": "重新显示所有项目",
      "allTeams": "所有团队",
      "scopeHint": "显示哪个团队的项目",
      "clearTools": "清除排序和筛选",
      "searchPh": "搜索项目、SKU、团队、负责人…",
      "rejectedChip": "已驳回 · {{n}} SKU",
      "rejectedChipHint": "审批人退回了 {{n}} 个 SKU——请修改后点击重新提交。",
      "selected": "已选 {{n}} 项",
      "decideSelected": "对所选项作出决定",
      "clearSelection": "清除选择",
      "emptyFiltered": "没有项目符合搜索或列筛选条件。",
      "emptyPending": "没有等待审批的项目。",
      "emptyTab": "没有 {{tab}} 项目。",
      "colNo": "序号",
      "colProjectId": "项目组 ID",
      "colProjectName": "项目名称",
      "colTeam": "团队",
      "colManager": "经理",
      "colOwner": "项目负责人",
      "colSalesRep": "销售代表",
      "colCategory": "类别",
      "colSeason": "季",
      "colPartner": "合作方 / 系列",
      "colTargetLaunch": "目标上市",
      "colSkus": "SKU",
      "colRequestedBy": "申请人",
      "colRequestedAt": "申请时间",
      "colManagerNote": "经理备注",
      "colApprovedBy": "批准人",
      "colApprovedAt": "批准时间",
      "colApprovedOpinion": "审批意见",
      "colRejectedBy": "驳回人",
      "colRejectedAt": "驳回时间",
      "colReason": "原因",
      "colAction": "操作",
      "btnView": "查看",
      "btnApprove": "批准",
      "btnEdit": "编辑",
      "btnResubmit": "重新提交",
      "btnCancel": "取消",
      "btnClose": "关闭",
      "btnSaveChanges": "保存更改",
      "btnApproveN": "批准 {{n}} 项",
      "btnRejectN": "驳回 {{n}} 项",
      "notYourTeam": "此项目属于其他团队——只有其项目负责人、该团队经理或管理员可以修改。",
      "dlgResubmitTitle": "重新提交 {{id}}",
      "dlgDecisionOne": "对 {{id}} 的决定",
      "dlgDecisionBulk": "对 {{n}} 个项目的决定",
      "dlgStatus": "审批状态",
      "dlgAgree": "同意",
      "dlgReject": "驳回",
      "skuToggle": "显示此项目中的 {{n}} 个 SKU",
      "skuNone": "此项目尚无 SKU。",
      "skuId": "SKU",
      "skuItem": "品名",
      "skuCategory": "类别",
      "skuQty": "数量",
      "skuPrice": "目标价",
      "skuExf": "EXF",
      "skuPic": "开发员 / 设计师",
      "skuStatus": "阶段",
      "skuTba": "待定",
      "skuState": "审批状态",
      "skuNote": "审批人备注",
      "skuSt_unsent": "未发送",
      "skuSt_waiting": "等待中",
      "skuSt_approved": "已批准",
      "skuSt_rejected": "未批准",
      "skuPicked": "已选 {{n}} 个 SKU",
      "skuWithApprover": "已发送——由审批人作出决定。",
      "skuNotYours": "未发送——由申请团队发送。",
      "skuDoneAlready": "已作出决定。",
      "skuNoneYours": "这里没有等待您处理的内容。",
      "submitPickFirst": "请勾选要发送的 SKU，或勾选项目以发送全部 SKU。",
      "skuNotRefused": "未被驳回——没有需要重新提交的内容。",
      "resubmitSome": "重新提交 {{n}} 项",
      "dlgBackHead": "每个 SKU 的修改内容（{{n}} 个重新提交）",
      "dlgBackWas": "未批准",
      "dlgBackWhy": "此 SKU 修改了什么",
      "skuMgrNote": "经理备注",
      "submitSome": "提交 {{n}} 项",
      "submitSomeHint": "仅发送下方勾选的 {{n}} 个 SKU；其余保持不变。",
      "approveSome": "决定 {{n}} 项",
      "approveSomeHint": "仅对下方勾选的 {{n}} 个 SKU 作出决定。",
      "dlgSkuHead": "逐个决定 SKU（{{n}} 个待处理）",
      "dlgAllApprove": "全部批准",
      "dlgAllReject": "全部驳回",
      "dlgSkuWhy": "此 SKU 未获批准的原因",
      "dlgSkuDefault": "除非您标记 ✕，否则此处所有 SKU 均为批准。",
      "dlgSkuYes": "批准",
      "dlgSkuNo": "不批准",
      "dlgSkuUndo": "将此 SKU 恢复为批准",
      "dlgWasApproved": "此前已批准",
      "dlgWasRejected": "此前已驳回",
      "btnApproveSkus": "批准 {{n}} 个 SKU",
      "btnRejectSkus": "驳回 {{n}} 个 SKU",
      "btnPartial": "批准 {{yes}} 个，驳回 {{no}} 个",
      "stPartial": "部分批准",
      "dlgUnchangedTitle": "自驳回以来未做任何修改。",
      "dlgUnchangedBody": "请按审批人的要求修改（点击该行的编辑），或在下方说明为何应按现状批准——不做修改重新提交时必须填写备注。",
      "dlgManagerOpinion": "经理意见",
      "dlgApproverOpinion": "审批人意见",
      "dlgPhReject": "为什么不批准此项目？团队会看到此内容。",
      "dlgPhResubmitRequired": "必填——为什么应在不做修改的情况下批准？",
      "dlgPhResubmit": "自驳回以来修改了什么？（可选）",
      "dlgPhOptional": "输入内容（可选）",
      "secProject": "项目信息",
      "secSku": "SKU 信息",
      "fTeam": "团队",
      "fOwner": "项目负责人（Sales OP）",
      "fCategory": "类别",
      "fSeason": "季",
      "fPartner": "合作方 / 系列",
      "fKeyword": "关键词",
      "fTargetLaunch": "目标上市（月份）",
      "fCase": "情形",
      "fEntity": "法人实体",
      "selectTeam": "选择团队…",
      "selectOwner": "选择负责人…",
      "pickTeamFirst": "请先选择团队",
      "noMember": "该团队尚无成员——请在用户列表中设置",
      "addSku": "+ 添加 SKU",
      "noSkuYet": "尚无 SKU——没关系，SKU 可随时添加。",
      "skuSaveHint": "新 SKU 会在保存时创建。删除已有 SKU 会立即生效，而非在保存时。",
      "fillRequired": "请先填写必填字段：",
      "couldNotSave": "无法保存：",
      "rejectedBy": "{{who}} 驳回：",
      "managerNoteLabel": "经理备注：",
      "submit": "提交",
      "submitSelected": "将所选项提交给审批人",
      "readyToSubmit": "{{n}} / {{total}} 项可提交",
      "nothingToSubmit": "勾选项中没有可提交的内容——已发送，或属于其他团队。",
      "sent": "已发送",
      "submittedOn": "已于 {{when}} 提交给审批人",
      "remind": "提醒",
      "remindHint": "已于 {{when}} 发送 · 仍有 {{n}} 个 SKU 等待审批人处理。发送提醒。",
      "remindSent": "已向 {{to}} 发送提醒——仍有 {{n}} 个 SKU 在等待",
      "lockedSubmitted": "已提交——审批人正在处理，其收到的邮件仍显示发送时的数值。",
      "drop": "删除",
      "dropTitle": "删除此项目",
      "dropSubmitted": "已提交——无法删除。",
      "dropHead": "删除 {{id}}？",
      "dropChecking": "正在检查属于此项目的内容…",
      "dropWarnOne": "将删除 1 个 SKU。样品轮次会保留——它们仍在样品跟踪中，但不再关联项目。此操作无法撤销。",
      "dropWarnMany": "将删除 {{n}} 个 SKU。样品轮次会保留——它们仍在样品跟踪中，但不再关联项目。此操作无法撤销。",
      "dropTicketsOne": "此项目的 1 个工单将被取消，并通知接收团队：",
      "dropTicketsMany": "此项目的 {{n}} 个工单将被取消，并通知接收团队：",
      "dropEmailed": "已发邮件",
      "dropReason": "取消原因？（将写入邮件）",
      "dropConfirm": "删除项目",
      "dropBusy": "删除中…",
      "approverNoteLabel": "审批人备注：",
      "setTitle": "审批邮件",
      "setNote": "“项目需要审批”邮件的发送对象。在此修改即可——无需重新部署。",
      "setApprover": "审批人（收件人）",
      "setCc": "抄送（用逗号分隔）",
      "setGate": "启用审批关卡（新项目以待处理状态开始，工单将被阻止）",
      "setSave": "保存审批设置",
      "setSaved": "审批设置已保存。"
    },
    "tour": {
      "title": "屏幕导览",
      "ciTabsT": "每个模板一个标签页",
      "ciTabsB": "模板 1 为每周现金报告，模板 2 为13周现金计划，模板 3 为月末对账。请选择您要提交的模板。",
      "ciPeriodT": "您的法人实体与期间",
      "ciPeriodB": "法人实体随您而定：取自现金报告用户列表中您的编制人记录，只有当您负责多个法人实体时才会出现下拉菜单。箭头可切换到前一周（或月）或后一周（或月）；旁边的文字显示报告的截止时间。",
      "ciStepsT": "报告当前进度",
      "ciStepsB": "编制人 → 审核人。完成的步骤会高亮显示；审核人同意后，报告数据将显示在现金报告中。",
      "ciTemplateT": "下载模板",
      "ciTemplateB": "此法人实体和期间的 Excel 模板，已预先填好账户。填写后导入——数据不在 Portal 上直接录入。",
      "ciImportT": "导入文件",
      "ciImportB": "导入已填写的模板。它会成为一个版本：系统运行数据检查，数据显示在下方。错误的文件可以取消，并重新导入更正后的文件。",
      "ciFormT": "在此更正",
      "ciFormB": "模板导入后，其数据会在此打开。更正数据并保存：即成为下一个版本，同样经过数据检查——无需重新导入文件。",
      "ciCheckT": "数据检查",
      "ciCheckB": "每个版本都会接受检查。错误必须修正后才能发送报告；警告会一并提交给审核人阅读。",
      "ciSendT": "发送给审核人",
      "ciSendB": "如需让审核人了解情况，请添加备注后发送。已发送的报告无法更改；如被退回，请在此更正后重新发送。",
      "ciFilesT": "银行对账单与截图",
      "ciFilesB": "为每个账户附上对账单或余额截图。所有审核或批准该报告的人都能看到。",
      "ciHistoryT": "历史记录与评论",
      "ciHistoryB": "每次导入、录入、发送和决定都会在此列出，并注明操作人和时间。可发表评论，就此报告提问或回答问题。",
      "ciTestAsT": "以角色测试",
      "ciTestAsB": "仅供测试：在现金报告邮件暂停发送期间，可扮演各个角色试用完整流程。每一步操作都会记录为 \"test as …\"。",
      "cqTabsT": "三个标签页",
      "cqTabsB": "“等待您处理”中是等待您审核的报告，最早的排在前面。“进行中”中是在其他审核人处的报告，以及附带原因退回给编制人的报告。“已同意”中是审核人已同意的报告——即现金报告中显示的报告。",
      "cqListT": "所有已发送的报告，集中在一个列表",
      "cqListB": "每周现金报告、13周现金计划和月末对账，涵盖所有法人实体和期间。每个表头都可像 Excel 一样排序和筛选。点击某一行可在下方打开该报告；再次点击即可关闭。",
      "cqDecideT": "您的决定",
      "cqDecideB": "审核并同意是最后一步：您同意后，报告数据将显示在现金报告中。该按钮会打开一个对话框，您可以同意，或附原因将报告退回给编制人。已同意的报告可在此附原因重新打开以便更正。被退回的报告会在“进行中”等待，直到再次发送。",
      "cqCheckT": "数据检查",
      "cqCheckB": "存在错误时编制人无法发送，因此已发送的报告没有错误。警告会一并提交，供您在决定前阅读。",
      "cqBodyT": "导入的内容",
      "cqBodyB": "数据与编制人从模板导入的完全一致——周报的字段 1 至 6、计划的 13 周，或各账户的对账。此处内容无法更改；数据有误请退回。",
      "cqFilesT": "银行对账单与截图",
      "cqFilesB": "编制人为每个账户附上的文件。打开即可将数据与银行核对。",
      "cqHistoryT": "历史记录与评论",
      "cqHistoryB": "谁导入、发送和决定，以及时间。可发表评论向编制人提问，而无需退回报告。",
      "crNewT": "发起申请",
      "crNewB": "货物的收件对象、快递公司和计费的 Helinox 账户、起运地和目的地、重量、您的预估费用以及运输条款。表单旁的费用检查会在您输入时，将预估费用与 HINC 的 FedEx 合同价进行比较。“保存草稿”可保留填写了一半的表单；“提交审批”会将其发送给审批人。",
      "crListT": "您的申请",
      "crListB": "每个申请占一行。前五列固定不动，其余列可横向滚动。点击某一行即可按发送时的表单查看该申请。",
      "crCheckT": "费用检查",
      "crCheckB": "您的预估与合同价对比：合理（最多高出 15%）、需复核（最多高出 35%）或可能偏高。合同未覆盖的线路或快递公司将人工核查。",
      "crStatusT": "当前状态",
      "crStatusB": "草稿（未发送）、等待中（审批人处理中）、已批准、已驳回或已撤回。",
      "crNoteT": "经理备注",
      "crNoteB": "审批人随决定填写的内容。点击可阅读全文。",
      "crActT": "可执行的操作",
      "crActB": "查看 · 编辑（草稿、已驳回或已撤回的申请，或仍在等待中的申请——保存后会告知审批人改动内容）· 提交草稿 · 复制为新申请 · 删除任何未批准的申请。按钮呈灰色时，鼠标悬停会显示原因。",
      "crqTabsT": "三个标签页",
      "crqTabsB": "“待决定”是您的待办队列；“已批准”和“已驳回”保留已作出决定的申请。",
      "crqListT": "申请列表",
      "crqListB": "申请人、所属法人实体、路线和快递公司。前五列固定不动。点击一行可查看申请及其费用核查。",
      "crqNoteT": "经理备注",
      "crqNoteB": "您随决定填写的内容；申请人在其列表中也能看到。",
      "crqActT": "查看 · 编辑 · 批准",
      "crqActB": "编辑用于修正等待中的申请——申请仍保持等待状态，并会通过邮件告知申请人改动内容。批准会打开决定窗口；驳回在窗口内，需要填写原因。",
      "crqRatesT": "费率",
      "crqRatesB": "费用核查所读取的 FedEx 合同费率文件、文件上传、燃油附加费以及两个阈值。",
      "crTabsT": "三份报告",
      "crTabsB": "每周现金报告、13 周现金计划和月末对账。这里只显示审核人已同意的数字；仍在编制人或审核人手中的报告只显示一行，说明其所处环节。",
      "crPeriodT": "期间",
      "crPeriodB": "选择一周（在月末标签页中选择一个月）；箭头可切换到上一期或下一期。旁边一行显示报告的截止时间。",
      "crChartsT": "图表",
      "crChartsWB": "按法人实体显示的现金，分为可用、受限和定期存款，以及 GROUP 最近 12 周的现金。将鼠标悬停在柱条或数据点上可查看数字。",
      "crChartsPB": "计划流入向上，计划流出向下；虚线为计划期末余额，实线为每周现金报告中的实际期末余额。",
      "crChartsMB": "按法人实体显示的月末现金，以及已对平和存在差异的账户数量。",
      "crWeekT": "先 GROUP，再各法人实体",
      "crWeekB": "第一行为 GROUP；其后为各法人实体，以 SGD 计。点击某法人实体的行，可展开其关联公司间交易行和各账户——此时会出现银行、账号、账户类型和受限 / 定期存款列，每个账户按上传时的原币种显示。",
      "crExpandT": "展开或收起所有法人实体",
      "crExpandB": "全部展开会在此处展开每个法人实体的账户，并在下方展开其前三项；全部收起则重新收起。",
      "crTopT": "前三项",
      "crTopB": "各法人实体本周三笔主要支出和下周三笔应付款，以 SGD 计。尚未上传的法人实体也会列出，以免遗漏。",
      "crFiltersT": "两个筛选条件",
      "crFiltersB": "法人实体：GROUP、单个法人实体，或同时勾选多个（数字会相加）。年份：显示哪一年的各周。下方的图表和表格都按这两个条件显示。",
      "crPlanTableT": "全年每一周",
      "crPlanTableB": "每周一行。已过去的周取自为该周提交的计划，未来的周取自最新计划；“来源计划”列会注明是哪一份。实际数在每周现金报告被同意后取自该报告。当前显示的周会高亮，每个表头都可像 Excel 一样排序和筛选。",
      "crPlanListT": "本周计划情况",
      "crPlanListB": "各法人实体针对当前所示周的计划：第 13 周的计划期末余额及计划当前状态。",
      "crMonthT": "对账",
      "crMonthB": "每个法人实体的行显示其以 SGD 计的月末余额以及编制人和审核人；其后为各账户，按各自币种显示。每个账户的对账差额都必须为 0。",
      "crWaitingT": "等待您处理",
      "crWaitingB": "下一步由您处理的报告会带有此标签。点击可在“审批”中打开该报告，在那里同意或退回。",
      "step": "第 {{n}} 步，共 {{of}} 步",
      "next": "下一步",
      "back": "上一步",
      "done": "完成",
      "skip": "跳过",
      "stCreateT": "在这里新建样品",
      "stCreateB": "选择该样品对应的项目 SKU。只列出尚无样品的 SKU，因为一个 SKU 只对应一个样品。无需再去项目跟踪中操作。",
      "stRoundT": "为已有样品添加轮次",
      "stRoundB": "P1、P2、P3 等。先输入 Sample ID、Base ID 或款式名称找到样品——选中后其余内容才会展开。",
      "stTrialT": "不属于任何项目的样品",
      "stTrialB": "例外情况，用于尚未成为项目 SKU 的工作。它会获得 TSMP 编号，而不是 SMP 编号。",
      "stCardsT": "卡片即筛选条件",
      "stCardsB": "点击一张卡片，下方表格只显示对应内容。再次点击即可清除。上排统计样品数，下排统计轮次数。",
      "stFiltersT": "进一步筛选",
      "stFiltersB": "可按开发员、设计师或 R&D 地点筛选，或在搜索框中输入。清除会恢复全部内容，包括列标题上的筛选。",
      "stRowT": "样品可展开查看各轮次",
      "stRowB": "点击任意行的箭头，可查看该 Base ID 的所有轮次。全部展开可一次全部打开。",
      "stExportT": "导出到 Excel",
      "stExportB": "按表格当前显示的内容导出，包括所有筛选条件。"
    },
    "st": {
      "tabAll": "全部样品",
      "tabSummary": "样品级汇总",
      "tagTrial": "试验",
      "pillProject": "项目样品 (SMP)",
      "pillTrial": "试验样品 (TSMP)",
      "pillBoth": "两者",
      "pillCtrlHint": "Ctrl / ⌘ + 点击可与另一类一起显示",
      "hintTrial": "不对应任何项目 SKU 的一次性样品。其 Base ID 为 TSMP，而非 SMP。",
      "titleTracker": "样品跟踪",
      "titleSummary": "样品级汇总",
      "hintTracker": "点击卡片更新表格 - 点击样品行展开轮次",
      "hintSummary": "每个 Base ID / 产品一行，含最新进度与轮次状态",
      "groupSample": "样品 / Base ID",
      "groupRounds": "轮次 / 流程",
      "totalSamples": "样品总数",
      "totalSamplesSub": "所有状态的样品记录",
      "inProgressSamples": "进行中样品",
      "confirmedSamples": "已确认样品",
      "reworkSamples": "返工样品",
      "droppedSamples": "已放弃样品",
      "onHoldSamples": "暂停样品",
      "totalRounds": "轮次总数",
      "totalRoundsSub": "所有状态的轮次记录",
      "inProgressRounds": "进行中轮次",
      "confirmedRounds": "已确认轮次",
      "reworkRounds": "返工轮次",
      "droppedRounds": "已放弃轮次",
      "onHoldRounds": "暂停轮次",
      "pendingOutcome": "待定结果",
      "pendingOutcomeSub": "有完成日期，无结果",
      "rmWaiting": "等待 RM",
      "rmWaitingSub": "物料未就绪",
      "inProduction": "生产中",
      "inProductionSub": "RM 已就绪，未完成",
      "allRounds": "全部轮次",
      "allDevelopers": "全部开发员",
      "allDesigners": "全部设计师",
      "allLocations": "全部 R&D 地点",
      "allStatus": "全部状态",
      "searchPlaceholder": "搜索 ID 或品项...",
      "clear": "清除",
      "newRound": "+ 新轮次",
      "csButton": "+ 创建样品",
      "tourButton": "导览",
      "tourReopen": "带我了解此页面",
      "csTitle": "创建样品",
      "csIntro": "选择该样品对应的项目 SKU。只列出尚无样品的 SKU——一个 SKU 只对应一个样品。",
      "csSearch": "搜索项目、SKU 编码或款式…",
      "csCount": "{{projects}} 个项目中的 {{skus}} 个 SKU",
      "csNone": "所有有效 SKU 都已有样品。",
      "csNoMatch": "没有匹配的结果。",
      "csMore": "还有 {{n}} 项——缩小搜索范围即可看到",
      "trButton": "+ 试验样品（非项目）",
      "trTitleNew": "新建试验样品",
      "trAddNewSample": "添加新样品",
      "trTitle": "试验样品——无项目",
      "trSub": "用于不对应任何项目 SKU 的一次性样品。Base ID 以 TSMP 而非 SMP 编号。",
      "trStylePh": "输入款式 / 品项名称",
      "trStyleHint": "在上方输入——试验样品没有可引用的项目 SKU",
      "expandAll": "全部展开",
      "collapseAll": "全部收起",
      "exportExcel": "导出 Excel",
      "backToBase": "返回 Base ID 视图",
      "colBaseId": "Base ID",
      "colStyleItem": "款式 / 品项",
      "colRound": "轮次",
      "colSeason": "季",
      "colLocation": "R&D 地点",
      "colDeveloper": "开发员",
      "colDesigner": "设计师",
      "colProjectId": "项目 SKU ID",
      "colRequestDate": "申请日期",
      "colDevelopmentDue": "开发截止日",
      "colRmReady": "RM 就绪",
      "colRoundDue": "轮次截止日",
      "colSampleFinish": "样品完成日期",
      "colReceived": "接收日期",
      "colComment": "意见日期",
      "colQty": "数量",
      "colRounds": "轮次数",
      "colStatus": "状态",
      "colDday": "D-day",
      "colDdayHint": "D-DAY = 今天 − 开发截止日。正值表示样品已逾期相应天数；负值表示还剩相应天数。",
      "colDaysWaiting": "等待天数",
      "goToProject": "在项目跟踪中打开此 SKU",
      "colRemarks": "备注",
      "colActions": "操作",
      "colRework": "返工",
      "ptNo": "序号",
      "ptId": "编号",
      "ptProjectItem": "项目 / 品项",
      "ptNotYours": "只有项目负责人、团队主管或管理员才能修改此项目。",
      "ptNotYourSku": "只有负责此 SKU 的开发员、项目负责人或团队主管才能修改。",
      "ptDeleteNotYours": "只有项目负责人、团队主管或管理员才能删除 SKU。",
      "ptCompletedLocked": "此 SKU 已完成且已通知生产部门——无法再编辑或删除。",
      "ptTicketNotYours": "只有项目负责人、团队主管或管理员才能为此项目创建工单。",
      "ptTeam": "团队",
      "ptOwner": "项目负责人",
      "ptCategory": "类别",
      "ptCase": "情形",
      "ptEntity": "法人实体",
      "ptItemCategory": "品类",
      "ptFrameColor": "框架颜色",
      "ptQty": "数量",
      "ptAssigned": "负责人",
      "ptAllocation": "分配",
      "ptStatus": "状态",
      "ptSalesRep": "销售代表",
      "ptWhere": "项目状态",
      "ptWhereComplete": "已完成",
      "ptWhereDropped": "已放弃",
      "ptWhereActive": "进行中",
      "ptAiHead": "Claude 摘要",
      "ptAiWriting": "正在生成摘要…",
      "ptStart": "开始日期",
      "ptExfDate": "EXF 日期",
      "ptTargetPrice": "目标价 (USD)",
      "ptLaunchDate": "上市日期",
      "ptWeeksLeft": "剩余周数",
      "ptProgress": "进度",
      "ptRemark": "备注",
      "ptSampleId": "样品 ID",
      "ptAction": "操作",
      "ptTitle": "项目跟踪",
      "ptHint": "管理和跟踪所有开发项目",
      "ptGroups": "项目组",
      "ptProjectComplete": "已完成项目",
      "ptProjectCompleteSub": "所有 SKU 均已完成（或已放弃）",
      "ptProjectDropped": "已放弃项目",
      "ptProjectDroppedSub": "所有 SKU 均已放弃",
      "ptProjectActive": "进行中项目",
      "ptProjectActiveSub": "仍有未完成的 SKU",
      "ptSkus": "项目 SKU",
      "ptComplete": "SKU 已完成",
      "ptDrop": "SKU 已放弃",
      "ptActive": "SKU 进行中",
      "ptPriority": "SKU 优先",
      "ptViewProject": "查看此项目（只读）",
      "ptViewSku": "查看此 SKU（只读）",
      "ptViewTag": "仅查看",
      "rmTitleView": "样品轮次",
      "viewRound": "查看此轮次（只读）",
      "viewBase": "查看此 Base ID（只读）",
      "tkView": "查看此工单（只读）",
      "tkTitleView": "工单",
      "viewClose": "关闭",
      "ptViewHint": "只读——此处任何内容都不能修改或保存。",
      "ptViewClose": "关闭",
      "ptOnTrack": "SKU 正常",
      "ptConcern": "SKU 需关注",
      "ptDelayed": "SKU 延迟",
      "ptOnHold": "SKU 暂停",
      "ptShipFinished": "SKU 已出货",
      "ptAllTeams": "全部团队",
      "ptAllOwners": "全部项目负责人",
      "ptByMember": "按成员",
      "ptByMemberTitle": "按项目负责人统计的工作量",
      "ptByMemberHint": "点击一行可按该负责人筛选跟踪表。数量随上方筛选条件变化。",
      "ptOverdueExf": "EXF 逾期",
      "ptAllCategories": "全部类别",
      "ptAllAssignees": "全部负责人",
      "ptAllAllocation": "全部分配",
      "ptSearch": "搜索项目 / 品项...",
      "ptExpandAll": "全部展开",
      "ptCollapseAll": "全部收起",
      "ptColumns": "列",
      "ptReport": "报告",
      "ptNewProject": "+ 新建项目",
      "ptExpand": "展开",
      "ptCollapse": "收起",
      "ptNoProjects": "未找到项目。",
      "stgLdSoff": "L/D S/OFF",
      "stgProto": "Proto",
      "stgCounter": "Counter",
      "stgCosting": "成本核算",
      "stgHandOffMeeting": "交接会议",
      "stgPpsPpm": "PPS/PPM",
      "stgProduction": "生产",
      "stgFinalInspection": "终检",
      "stgExfShipment": "出货状态",
      "stgPayment": "付款",
      "stgPoStatus": "PO 状态",
      "pfNewProject": "新建项目",
      "pfProjectInfo": "项目信息",
      "pfProjectInfoHint": "基本信息、进度、状态、阶段和关联样品",
      "pfCategory": "类别",
      "pfSelectCategory": "选择类别...",
      "dgpTitle": "确定删除项目 {{id}} 吗？",
      "dgpChecking": "正在检查此项目下的内容…",
      "dgpSkus": "将删除 {{n}} 个 SKU。",
      "dgpRounds": "样品轮次不会被删除——它们仍保留在样品跟踪中，但不再关联项目。",
      "dgpTickets": "将取消 {{n}} 个工单，并通知持有这些工单的团队。",
      "dgpUndo": "无法在门户中撤销此操作。",
      "dgpConfirm": "删除项目",
      "dt1Title": "确定删除工单 {{id}} 吗？",
      "dt1Emailed": "此工单已通过邮件发送给 {{to}}。删除将取消该请求，并通知对方——同时附上下方填写的原因。",
      "dt1NotEmailed": "此工单从未通过邮件发送，因此门户之外无人知晓。删除不会通知任何人。",
      "dt1ReasonHint": "接收团队会通过这一行了解其请求为何消失。",
      "dt1Confirm": "删除工单",
      "dt1ConfirmMail": "删除并通知",
      "dtTitle": "删除 {{id}}——其下有工单",
      "dtLead": "以下 {{n}} 个工单属于此项目。删除项目将取消这些工单，并通知已接收的团队：",
      "dtNeverEmailed": "从未发送邮件",
      "dtReason": "为什么要删除？",
      "dtReasonPh": "例如：合作方取消了合作",
      "dtReasonHint": "这一行会写入取消邮件——接收团队会通过它了解其请求为何消失。",
      "dtConfirm": "删除并取消工单",
      "gmSkuOnlyHint": "您的团队只能编辑 SKU 部分——上方的项目信息归 Sales OP 管理。",
      "pfReadOnlyHere": "此处只读——请在“编辑项目组”中修改",
      "bmHint": "属于 Base ID 本身、而非某一轮次的内容：照片，以及其所有轮次共用的款式名称（此处共 {{rounds}} 轮）。",
      "bmStyleHint": "重命名会一次性应用到此 Base ID 的所有轮次。",
      "bmRename": "重命名款式",
      "rmBasePhotos": "样品照片 (Base ID)",
      "rmPhotoRequired": "必填",
      "rmPhotoNewBase": "这是新款式，保存时会创建新的 Base ID——需要至少一张样品照片。照片归属于 Base ID，之后的轮次不会再次要求。",
      "rmPhotoExistingBase": "此款式已存在，编号为 {{baseId}}，并已有自己的照片。此处无需添加。",
      "rmPhotoNoStyle": "请先填写款式 / 品项。新款式会创建新的 Base ID，需要上传照片。",
      "pfPurpose": "项目目的",
      "pfPurposePh": "为什么做这个项目，以及将在哪里销售。",
      "pfPurposeHint": "Sales OP 经理须与销售代表确认。CEO 会根据这一行决定是否推进。",
      "pfNote": "备注",
      "pfTeam": "团队",
      "pfOwner": "项目负责人 (Sales OP)",
      "pfHandover": "您正在将此项目移交给 {{who}}。保存后您将无法再编辑——只有 {{who}}、{{mgr}} 或管理员可以编辑。",
      "pfHandoverMgr": "团队主管",
      "pfYear": "年份",
      "pfYearPick": "选择年份…",
      "pfSeasonParts": "季",
      "pfSeasonMax2": "可选——最多选两个",
      "pfSeasonCode": "项目代码：{{code}}",
      "seasonSpring": "春季",
      "seasonSummer": "夏季",
      "seasonFall": "秋季",
      "seasonWinter": "冬季",
      "pfSeason": "季",
      "pfPartner": "合作方 / 产品线",
      "pfKeyword": "关键词",
      "pfTargetLaunch": "目标上市（月份）",
      "pfNameHint": "由系统生成。PRJ-ID 始终是永久编号；这是供大家阅读的名称。",
      "pfSelectTeam": "选择团队…",
      "pfSelectOwner": "选择负责人…",
      "pfPickTeamFirst": "请先选择团队",
      "gmTitle": "编辑项目组",
      "gmSaveGroup": "保存项目组",
      "gmSaveTickets": "保存工单",
      "pfProjectName": "项目名称",
      "pfProjectNamePh": "例如：25 PARTICULIER",
      "pfCase": "情形",
      "pfSelectCase": "选择情形...",
      "pfEntity": "法人实体",
      "pfSelectEntity": "选择法人实体...",
      "pfSkuInfo": "SKU 信息",
      "pfAddSku": "+ 添加 SKU",
      "mvBtn": "从其他项目移入 SKU",
      "mvBtnTitle": "从本团队的其他项目移入已批准的 SKU——它们会保留批准状态",
      "mvNeedTeam": "请先选择项目所属团队",
      "mvNotManager": "只有管理员或本团队主管才能移动 SKU",
      "mvHead": "将已批准的 SKU 移入此项目",
      "mvIntro": "选择同一团队的项目并勾选其已批准的 SKU。保存此表单时这些 SKU 才会移动，并保留其 SKU ID、批准状态、样品和阶段——无需再提交 CEO。已创建的工单仍留在原项目。开发员、设计师和项目负责人会收到邮件。",
      "mvSource": "来源项目",
      "mvSearch": "搜索项目或 SKU",
      "mvSearchPh": "PRJ 编号、项目名称、SKU 编号或品项名称…",
      "mvNoMatch": "没有匹配项——请尝试更短的关键词。",
      "mvPicked": "已勾选 {{n}} 个",
      "mvChoose": "选择项目…",
      "mvLoading": "加载中…",
      "mvApprovedN": "{{n}} 个已批准",
      "mvNone": "本团队没有其他项目包含已批准的 SKU。",
      "mvAllTaken": "此项目所有已批准的 SKU 都已选中。",
      "mvAll": "全部勾选",
      "mvColItem": "品项",
      "mvColApproved": "已批准",
      "mvColDeveloper": "开发员",
      "mvColDesigner": "设计师",
      "mvCancel": "取消",
      "mvAdd": "添加 {{n}} 个 SKU",
      "mvListHead": "保存时移入——{{n}} 个 SKU",
      "mvFrom": "来自 {{id}}",
      "mvApprovedBy": "由 {{who}} 批准",
      "mvRemove": "不移动此项",
      "mvSaveHint": "尚未移动任何内容：保存表单时这些 SKU 才会移入此项目。",
      "mvTeamChanged": "这些 SKU 来自与上方所选团队不同的团队项目——请移除它们或将团队改回。",
      "pfSkuHint": "每个 SKU 作为独立的 PRJ 条目保存在一个 PG 项目下。展开 SKU 可编辑其信息、初始阶段和关联样品。",
      "pfUnassigned": "未分配",
      "pfNoCategory": "无类别",
      "pfQty": "数量",
      "pfStageChip": "阶段",
      "pfRemoveSku": "移除 SKU",
      "pfDuplicateSku": "复制此 SKU",
      "pfApprovalNoteHead": "已保存为待审批——尚未发送给审批人。",
      "pfApprovalNoteBody": "打开项目审批并点击提交以发送申请。批准后即可创建工单。",
      "pfDeveloper": "开发员",
      "pfDesigner": "设计师",
      "pfNoDesigner": "无设计师",
      "ptDesigner": "设计师",
      "ptAllSalesReps": "全部销售代表",
      "ptAllDesigners": "全部设计师",
      "pfAssignedTo": "分配给",
      "pfAllocation": "分配",
      "pfProductCategory": "产品类别",
      "pfFrameColor": "框架颜色",
      "pfFrameColorPh": "搜索或添加颜色…",
      "pfItemName": "品项 / SKU 名称",
      "pfItemNamePh": "例如：Backpack 17L",
      "pfEstQty": "预计数量",
      "pfStartDate": "开始日期",
      "pfExfShipDate": "EXF 出货日期",
      "pfTargetPrice": "目标价 (USD)",
      "pfLaunchDate": "上市日期",
      "pfProjectStatus": "项目状态",
      "pfRemark": "备注",
      "pfInitialStages": "初始流程阶段",
      "pfPctComplete": "已完成",
      "pfStageHint": "从列表中选择状态或自行输入——如输入日期请使用 dd/mm/yyyy。留空则保存为待处理。",
      "pfRepeatOrder": "返单",
      "pfRepeatOrderHint": "已开发过的款式再次下单——无需 proto、counter 样品，也无需 L/D 确认和交接会议，因此这四个阶段都设为已完成。",
      "pfStagePh": "待处理或 dd/mm/yyyy",
      "pfStageAuto": "自动——取自关联样品",
      "pfLinkSample": "关联样品（可选）",
      "pfLinkSampleHint": "一个或多个 Sample ID/Base ID，用逗号分隔。选择样品即会将其关联到此 PRJ 条目。",
      "pfLinkSamplePh": "选择或输入一个 Sample ID/Base ID",
      "pfGtm": "GTM 计划（可选）",
      "pfGtmHint": "此 SKU 所属的 GTM 上市计划。也会显示在 GTM 表单上",
      "pfGtmPh": "选择或输入 GTM 编号，例如 GTM-26-001",
      "pfTickets": "工单",
      "pfTicketsAdded": "已添加 {{count}} 个工单",
      "pfNoTicketYet": "尚未添加工单",
      "pfAllReceivingTeams": "全部接收团队",
      "pfAddTicket": "＋ 添加工单…",
      "pfTicketHint": "只提供与本项目团队、情形和类别相符的代码，并按阶段分组。先选择接收团队，再点击“＋ 添加工单”。保存项目组时才会创建新工单。",
      "pfClearTickets": "清除工单",
      "pfPhotosOnSku": "照片附在上方各 SKU 中——打开 SKU 并使用“添加照片”。",
      "pfTicketEmpty": "尚未添加工单——请从“＋ 添加工单”中选择。",
      "pfCancel": "取消",
      "pfSaving": "保存中...",
      "pfAddProject": "添加项目",
      "pfDiscardTitle": "放弃此项目？",
      "pfDiscardBody": "您输入的内容尚未保存。关闭表单后将全部丢失。",
      "pfDiscardKeep": "继续编辑",
      "pfDiscardConfirm": "放弃",
      "dgEditTitle": "放弃更改？",
      "dgEditBody": "您在此处的更改尚未保存。关闭表单后更改将丢失。",
      "pfSaveChanges": "保存更改",
      "pfViewSample": "查看关联样品",
      "pfSampleBtn": "样品",
      "pfNewSku": "新 SKU",
      "pfEditPrefix": "编辑",
      "pfGroupLevelHint": "项目组级信息——请在项目组中编辑",
      "pfNewTag": "新",
      "pfSaveAddSku": "添加 SKU",
      "thSortFilter": "排序和筛选",
      "thSortAZ": "按 A 到 Z 排序",
      "thSortOldNew": "按从旧到新排序",
      "thSortZA": "按 Z 到 A 排序",
      "thSortNewOld": "按从新到旧排序",
      "thSearch": "搜索...",
      "thSelectAll": "（全选）",
      "thNoMatches": "无匹配项",
      "thOk": "确定",
      "thCancel": "取消",
      "thBlanks": "（空白）",
      "thFiltered": "已筛选——保留 {{count}} 个值",
      "pgSharedHint": "此项目组内所有 SKU 共用的基本信息",
      "pgPrjItems": "PRJ 条目",
      "pgSkuHint": "每个 SKU 都是此 PG 项目下独立的 PRJ 条目。点击 SKU 可编辑其信息、阶段和关联样品。",
      "pgNoSku": "此项目组尚无 SKU。",
      "pgRemoveSku": "从项目组中移除此 SKU",
      "rmTitleNew": "新轮次",
      "rmTitleNewSample": "新样品",
      "rmTitleEdit": "编辑现有轮次",
      "rmTitleAdvance": "下一轮次（选择 Advance 时必填）",
      "tkFiles": "附件",
      "tfPick": "点击添加附件",
      "tfHint": "PDF、Excel、CSV、Word、图片——每个最大 {{max}} MB，随工单邮件发送",
      "tfUploading": "上传中…",
      "tfRemove": "移除此文件",
      "tfTotal": "{{n}} 个文件，{{size}}——将作为工单邮件的附件发送",
      "tfSaveFirst": "此工单不能添加附件。",
      "tfDraftNote": "保存工单时才会附加",
      "tfTooBig": "{{name}} 为 {{mb}} MB；每个文件上限为 {{max}} MB。",
      "rmPickSample": "选择要添加轮次的现有样品",
      "rmPickSampleSub": "——输入 Sample ID、Base ID 或款式名称",
      "rmPickPh": "例如：SMP-2601-P1 或 SMP-2601...",
      "rmPickRequired": "请选择此轮次所属的样品——轮次总是添加到现有样品中。",
      "rmPickFirst": "从这里开始。输入 Sample ID——选中样品后表单其余部分才会展开。",
      "rmStyleFromSample": "取自上方所选样品",
      "rmStyleFromSku": "取自该样品对应的项目 SKU",
      "rmStylePlaceholder": "请在上方选择样品",
      "rmSalesTeam": "销售团队",
      "rmProjectOwner": "项目负责人",
      "rmProjectName": "项目",
      "rmNoLinkedSku": "未关联 SKU",
      "rmClear": "清除",
      "rmAddingTo": "正在为以下样品添加轮次",
      "rmChange": "更改",
      "rmAdvanceNote": "正被设为 Advance，即开发进入下一轮次。请填写该轮次并保存——两者会一起保存。",
      "rmAdvanceNoteSub": "如果取消，Advance 结果也不会保存，该轮次保持原样。",
      "rmDupWarn": "可能重复：{{sampleId}} 已有此款式的轮次“{{round}}”（结果：{{outcome}}）。",
      "rmDupOpen": "未定",
      "rmOwnership": "填写责任：",
      "rmHevnFills": "HEVN 填写",
      "rmHincFills": "HINC Design 填写",
      "rmBothTeams": "双方团队",
      "rmAutoGen": "自动生成",
      "rmMandatory": "= 必填字段",
      "rmSampleIdent": "样品识别信息",
      "rmStyleItem": "款式 / 品项",
      "rmStyleHint": "选择已有或输入新的——Base ID 自动分配",
      "rmStylePh": "例如：Chair Zero LT",
      "rmBaseId": "Base ID",
      "rmAutoAssigned": "自动分配",
      "rmSampleId": "样品 ID",
      "rmSampleIdHint": "Base ID + 轮次 + 选项（自动）",
      "rmRound": "轮次",
      "rmOption": "选项",
      "rmOptionHint": "仅在结构不同时填写",
      "rmOptionPh": "面料 / 网布（仅颜色不同时留空）",
      "rmCategory": "类别",
      "rmSeason": "季",
      "rmDevelopmentDue": "开发截止日",
      "rmDevDueHint": "必填——在 Sheet 中标为黄色",
      "rmTargetPrice": "目标价 (USD)",
      "rmLinkedSku": "关联项目 SKU",
      "rmOptional": "可选",
      "rmLinkedSkuHint": "将此样品关联到项目 SKU",
      "rmSearchProject": "搜索项目...",
      "rmReviewType": "评审类型",
      "rmHevn": "HEVN",
      "rmRequiresDesigner": "需设计师评审",
      "rmInternalOnly": "仅 HEVN 内部评审",
      "rmInternalNote": "请用评审日期和备注记录 HEVN 内部评审。此轮次不计入设计师工作量，也不计入待反馈。",
      "rmDesignerNote": "设计师评审沿用 HINC 现有的评审与结果流程。",
      "rmInternalReview": "HEVN 内部评审",
      "rmRequestDate": "申请日期",
      "rmInternalReqHint": "与 HINC 设计评审中的申请日期为同一字段——此处为内部评审日期",
      "rmRemarks": "备注",
      "rmInternalRemarksPh": "此次内部评审的备注...",
      "rmSamplePlan": "样品计划",
      "rmDeveloper": "开发员",
      "rmDeveloperPh": "选择或输入姓名...",
      "rmEitherName": "开发员或设计师——任选其一即可。",
      "rmLocation": "R&D 地点",
      "rmRmReady": "RM 就绪日期",
      "rmRmReadyHint": "如为计划日期请勾选“预计”；物料/规格就绪后取消勾选。",
      "pfNeedOwner": "此项目尚无项目负责人，因此无法创建工单——邮件会显示“项目负责人: -”，接收团队将不知道该联系谁。请点击该项目行上的铅笔图标打开项目，设置项目负责人并保存，然后回到这里。",
      "pfNeedOwnerShort": "请先为项目设置项目负责人",
      "rmMaterials": "物料列表",
      "rmMaterialsHint": "此处每一列都属于 SKU，并在 SKU 中编辑——只有一份列表而非副本，因此在那里添加的物料会出现在每个轮次中。RM 就绪日期例外：它属于本轮次，并随本轮次保存。",
      "rmMaterialsNoSku": "尚无物料列表——该列表属于项目 SKU，而本轮次未关联任何 SKU。请在上方填写关联项目 SKU，其物料就会显示在这里。",
      "rmExpectedDate": "预计日期",
      "rmSampleFinish": "样品完成日期",
      "rmQty": "数量",
      "rmActualCost": "实际成本 (USD)",
      "rmAutoCalc": "自动计算（只读）：",
      "rmMakeDays": "制作天数",
      "rmShipDays": "寄送天数",
      "rmRoundCycle": "轮次周期",
      "rmDday": "D-day",
      "rmHincReview": "HINC 设计评审",
      "rmHincDesigner": "HINC 设计师",
      "rmHincReqHint": "HINC 申请此样品的日期",
      "rmRoundDue": "轮次截止日",
      "rmRoundDueHint": "HINC 设定的样品完成目标日期",
      "rmReceivedDate": "接收日期",
      "rmReceivedHint": "HINC 收到样品的日期",
      "rmReviewDate": "评审日期（意见日期）",
      "rmReviewDateHint": "HINC 提供反馈的日期",
      "rmRoundOutcome": "轮次结果",
      "rmOutcomeHint": "在每周意见会议后设定",
      "rmNotSetYet": "— 尚未设定 —",
      "rmOutcomePick": "选择一个结果以查看其含义。",
      "rmReworkTitle": "返工——须填写原因",
      "rmReworkReason": "返工原因",
      "rmSelectAll": "（可多选）",
      "rmRoundRemarksPh": "此轮次的备注...",
      "rmSaving": "保存中...",
      "rmSaveChanges": "保存更改",
      "rmSaveAdvance": "保存 Advance + 新轮次",
      "rmAddNewRound": "添加新轮次",
      "rmCancel": "取消",
      "rmCancelAdvance": "取消（同时放弃 Advance）",
      "tkTitle": "工单中心",
      "tkHint": "跟踪项目工单、负责人跟进、截止日期和状态更新。",
      "tkAll": "全部工单",
      "tkDone": "已关闭",
      "tkCancelled": "已取消",
      "tkPending": "未结",
      "tkOverdue": "逾期",
      "tkAllRequesters": "全部申请人",
      "tkAllTeams": "全部接收团队",
      "tkAllSopTeams": "全部 Sales OP 团队",
      "tkAllPriority": "全部优先级",
      "tkSearch": "搜索工单 / 项目...",
      "tkNewTicket": "+ 新建工单",
      "tkTabTickets": "工单中心",
      "tkManageCodes": "工单代码",
      "tkColTicketId": "工单 ID",
      "tkColTicket": "工单",
      "tkColProject": "项目",
      "tkColProjectName": "项目名称",
      "tkColTeam": "接收团队",
      "tkColRequester": "申请人",
      "tkColType": "类型",
      "tkColPriority": "优先级",
      "tkColDue": "截止",
      "tkColCreatedBy": "创建人",
      "tkColCreatedAt": "创建时间",
      "tkColUpdatedBy": "修改人",
      "tkColUpdatedAt": "修改时间",
      "tkColNote": "备注",
      "tkColAssigneeReply": "负责人回复",
      "tkLinkNotSent": "请先发送工单 — 接收团队目前还没有人知道这个工单，因此没有人能通过此链接回复。",
      "tkColDescription": "描述",
      "tkColAssigneeNote": "负责人备注",
      "tkColEmailSent": "邮件发送日期",
      "tkExportEmpty": "没有可导出的内容 — 当前筛选条件下没有工单。",
      "tkManagerStatus": "经理状态",
      "tkRemind": "提醒",
      "tkRemindHint": "发邮件提醒接收团队此工单仍未结",
      "tkSend": "发送",
      "tkSendHint": "此工单从未发送过邮件 — 将申请发送给接收团队",
      "tkSendDone": "工单 {{id}} 已发送邮件至 {{to}}。",
      "tkSendFailed": "发送失败：{{err}}",
      "tkDdayHint": "D-DAY = 今天 − 截止日期。正值表示工单已逾期相应天数。工单完成或取消后，数值固定在关闭当天。",
      "tkNotYourTeam": "只有创建此工单的人、项目负责人、该团队经理或管理员可以修改此工单。",
      "tkExpandAll": "全部展开",
      "tkCollapseAll": "全部收起",
      "tkTicketsSingular": "个工单",
      "tkTicketsPlural": "个工单",
      "tkNoProject": "（无项目）",
      "tkEdit": "编辑工单",
      "tkDuplicate": "复制工单",
      "tkDelete": "删除工单",
      "tkOpenLink": "打开公开状态链接",
      "tkLink": "链接",
      "tkNoTickets": "未找到工单。",
      "tkTitleNew": "新建工单",
      "tkTitleEdit": "编辑工单",
      "tkTitleDup": "复制工单",
      "tkAuto": "自动",
      "tkProjectGroup": "项目组",
      "tkSearchGroup": "搜索项目组...",
      "tkAutoFromGroup": "根据项目组自动填写",
      "tkSelectTeam": "选择接收团队...",
      "tkTicketCode": "工单代码",
      "tkSelectCode": "选择已约定的工单类型...",
      "tkTicketName": "工单名称",
      "tkSelectTypeFirst": "请选择工单类型",
      "tkDescription": "描述",
      "tkDescriptionPh": "工单详情 / 预期结果",
      "tkRequesterPh": "根据登录用户自动填写",
      "tkGroupEmail": "群组邮箱",
      "tkGroupEmailPh": "根据接收团队自动填写",
      "tkDueDate": "截止日期",
      "tkSentAt": "邮件发送日期",
      "tkAttachment": "附件链接",
      "tkAttachmentPh": "粘贴 Drive/文件链接",
      "tkNotePh": "内部备注或最新进展",
      "tkSendAfterSave": "保存后发送邮件",
      "tkSent": "已发送",
      "tkNotSent": "未发送",
      "tkEmailSubject": "邮件主题",
      "tkSystemGenerated": "系统生成",
      "tkEmailCc": "邮件抄送",
      "tkEmailMessage": "邮件正文",
      "tkReadOnly": "只读",
      "tkEmailMessagePh": "邮件正文",
      "tkGeneratedNote": "邮件主题和正文由系统自动生成，不可编辑。",
      "tkSendEmail": "发送邮件",
      "tkDeleteTicket": "删除工单",
      "tkSaveTicket": "保存工单",
      "tkNoDueDate": "无截止日期",
      "tkRemoveTicket": "移除工单",
      "tkOptionalNote": "备注（可选）",
      "tkWillSend": "保存时发送",
      "tkQueued": "待发送",
      "tkQueuedCancelTitle": "待发送 — 点击取消",
      "tkSendBlocked": "请先填写上方的必填项 — 未填写则无法发送邮件",
      "tkSendTitle": "工单在保存时创建，因此邮件会在保存后立即发送"
    },
    "rt": {
      "bold": "加粗 (Ctrl+B)",
      "italic": "斜体 (Ctrl+I)",
      "underline": "下划线 (Ctrl+U)",
      "strike": "删除线",
      "colour": "文字颜色",
      "bullets": "项目符号列表",
      "numbers": "编号列表",
      "clear": "清除格式",
      "cDefault": "默认",
      "cRed": "红色",
      "cOrange": "橙色",
      "cGreen": "绿色",
      "cBlue": "蓝色",
      "cPurple": "紫色",
      "cGrey": "灰色"
    },
    "nfc": {
      "stDraft": "未提交",
      "stWaiting": "待审批",
      "stApproved": "已批准",
      "stRejected": "已驳回",
      "replOk": "正常",
      "replNotFound": "未找到",
      "replReplaced": "已更换",
      "replDuplicate": "重复",
      "notSignedIn": "（未登录）",
      "role": "角色",
      "manager": "经理",
      "coordinator": "协调员",
      "unassigned": "未分配",
      "loading": "加载中…",
      "noAccessTitle": "无访问权限",
      "noAccessBody": "尚未被分配 NFC 门户的协调员/经理角色。请联系 Special Project 添加。",
      "accountWord": "账号",
      "createTitle": "创建令牌发放申请",
      "tabIssuance": "令牌发放",
      "tabReplacement": "更换不良 NFC",
      "labelType": "标签类型",
      "labelNfc": "NFC 标签",
      "labelQr": "QR 热转印标签",
      "projectName": "项目名称",
      "batchName": "批次名称",
      "qty": "数量 (QTY)",
      "qtyPh": "未导入品项时必填",
      "style": "款式 / 产品",
      "stylePh": "例如：Chair One (re)",
      "color": "颜色",
      "vendor": "供应商",
      "vendorPh": "例如：Metric / TheSang",
      "code": "代码",
      "codePh": "例如：10001555",
      "importTitle": "导入多个品项（可选）",
      "importReplTitle": "导入不良 NFC 令牌",
      "downloadTemplate": "下载 CSV 模板",
      "chooseCsv": "选择 CSV",
      "noFile": "未选择文件",
      "importSummary": "已加载 {{count}} 个品项，总数量 {{qty}}。提交前请检查并修改。",
      "importInvalid": "部分行无效（需要项目 + 批次 + 数量）。",
      "importEmpty": "未加载导入文件 — 留空则使用上方的单个品项字段。",
      "replSummary": "已加载 {{count}} 个不良令牌。提交前请检查。",
      "replChecking": "正在与台账核对…",
      "warning": "警告：",
      "oldToken": "旧令牌 / NFC URL",
      "reason": "原因",
      "notes": "备注",
      "status": "状态",
      "checking": "检查中…",
      "notChecked": "未检查",
      "replEmpty": "尚未加载不良令牌 — 请先下载模板，再上传 CSV 开始。",
      "optional": "可选",
      "saving": "保存中…",
      "save": "保存",
      "cancel": "取消",
      "myRequests": "我的申请",
      "reload": "刷新",
      "colId": "ID",
      "colProject": "项目",
      "colBatch": "批次",
      "colQty": "数量",
      "colItems": "品项",
      "colLabel": "标签",
      "colVendor": "供应商",
      "colCode": "代码",
      "colStatus": "状态",
      "colUpdated": "更新时间",
      "colFile": "文件",
      "colAction": "操作",
      "colOld": "旧",
      "colNew": "新",
      "colOutput": "输出",
      "colRequestedBy": "申请人",
      "colEmail": "邮箱",
      "colAddedBy": "添加人",
      "downloadOrder": "下载订单文件",
      "viewDetail": "查看详情",
      "edit": "编辑",
      "submitApproval": "提交审批",
      "delete": "删除",
      "reject": "驳回",
      "noRequests": "暂无申请。",
      "reviewTitle": "申请审核",
      "accessTitle": "管理门户访问权限",
      "accessHint": "授予或撤销此 NFC 门户的协调员 / 经理权限。更改将在用户下次打开门户时生效。",
      "grantAccess": "授予权限",
      "noUsers": "尚未分配用户。",
      "detailTitle": "申请详情",
      "lblNotes": "备注",
      "lblOutputFile": "输出文件",
      "openOutput": "打开输出文件",
      "lblDecisionNote": "审批备注",
      "replItems": "更换品项",
      "items": "品项",
      "close": "关闭",
      "genTitle": "正在生成令牌",
      "genLead": "正在审批中。请保持此标签页打开，并且",
      "genLeadBold": "不要再次点击批准",
      "requestWord": "申请",
      "working": "处理中...",
      "rejectTitle": "驳回申请",
      "rejectReason": "原因（将发送给申请人）",
      "rejectReasonPh": "驳回原因是什么？",
      "rejectReasonReq": "请输入驳回原因。",
      "rejectBtn": "驳回申请",
      "deleteTitle": "删除申请",
      "deleteBody": "删除申请 {{id}}？只能删除草稿或已驳回的申请。",
      "nReplacements": "{{count}} 个更换",
      "nItems": "{{count}} 个品项",
      "single": "单个",
      "nCodes": "{{count}} 个代码",
      "flashCleared": "申请表单已清空。",
      "flashSubmitted": "申请 {{id}} 已提交审批。",
      "flashDraft": "申请 {{id}} 已保存为草稿。",
      "flashLoadedEdit": "已加载 {{id}} 以供编辑。",
      "flashDeleted": "申请 {{id}} 已删除。",
      "flashApproved": "申请 {{id}} 已批准 — 已生成 {{qty}} 个令牌。",
      "flashGranted": "已为 {{email}} 授予 {{role}} 权限。",
      "flashRevoked": "已撤销 {{email}} 的 {{role}} 权限。",
      "flashEmailReq": "请输入邮箱。",
      "flashLoadedFile": "已加载 {{name}}。",
      "flashRejected": "申请 {{id}} 已驳回。",
      "progStarting": "正在开始审批...",
      "progCompleted": "已完成",
      "progGenerated": "已生成 {{qty}} 个令牌",
      "progSavedImport": "已加载已保存的导入内容"
    },
    "dd": {
      "title": "仪表板",
      "scopeNote": "仅统计项目样品 — 试样（TSMP）不计入本页任何数据。样品跟踪中两者都会列出。",
      "loading": "仪表板加载中…",
      "retry": "重试",
      "noData": "暂无数据",
      "totalRounds": "总轮次",
      "acrossSamples": "覆盖 {{count}} 个样品",
      "avgRoundsSample": "平均轮次 / 样品",
      "higherSpinning": "越高 = 反复越多",
      "reworkRatio": "返工率",
      "mainKpi": "核心 KPI",
      "pastDue": "超过开发截止日",
      "pastDueSub": "D-day ≥ 0 的{{unit}}",
      "reworkByRoom": "各开发室返工率",
      "reworkAttribution": "返工归因（双向）",
      "hevnCaused": "HEVN（导致）",
      "hincCaused": "HINC（导致）",
      "external": "外部",
      "hevnRatio": "HEVN 归因比例",
      "stuckTime": "停滞时间指标",
      "avgCommentDiffers": "平均反馈天数 — 'differs' 轮次",
      "avgCommentAdvance": "平均反馈天数 — Advance 轮次",
      "avgCommentAll": "平均反馈天数 — 全部",
      "spinning": "反复样品（4 轮及以上）",
      "sampleSpeed": "样品速度",
      "sampleSpeedNote": "RM 就绪日 = 面料/物料/规格已就绪、样品室可以开始打样的日期。样品速度从 RM 就绪日计算到样品完成日；没有实际就绪日期，或预计就绪日期在未来的轮次，仍处于等待 RM 状态，不计入统计。",
      "avgMakeHevn": "平均制作天数 (HEVN R&D)",
      "avgMakeTs": "平均制作天数 (TS)",
      "avgMakeMs": "平均制作天数 (MS)",
      "avgMakeTotal": "平均制作天数（合计）",
      "byDeveloper": "按开发员 — 完整明细",
      "colDeveloper": "开发员",
      "colSamples": "样品数",
      "colRounds": "轮次数",
      "colRework": "返工",
      "colReworkRate": "返工率",
      "colAvgRounds": "平均轮次",
      "colAvgMakeDays": "平均制作天数",
      "colPending": "待处理"
    }
  }
};

export default zh;
